<template>
  <!-- <hm-content title=""> -->
  <div style="padding-bottom:80px">
  
    <div class="temp-header">
      <div class="left_box">
        <!-- <div @click="back" class="btn flex item-center">
          <span class="hmicon icon-fanhui"></span>
          返回
        </div> -->
        <div class="flex item-center">
          <div v-if="declareRow && declareRow.provinceName" class="mr10">
            当前省份: <span class="primary">{{ declareRow.provinceName }}</span>
          </div>
          <div v-if="declareRow && declareRow.storeName">
            当前商户: <span class="primary">{{ declareRow.storeName }}</span>
          </div>
        </div>
      </div>
  
      <div class="right_box" v-if="false">
        <div class="mr10" v-if="queryStartTime">
          {{ queryStartTime }} 至 {{ queryEndTime }}
        </div>
        <el-popover
            placement="top-start"
            width="100%"
            trigger="hover"
            :disabled="detailsSalesVolume.storeRemark ? false : true"
            :content="detailsSalesVolume.storeRemark"
        >
          <div
              slot="reference"
              class="store-remark"
              @click="editRemark"
          >
            {{ detailsSalesVolume.storeRemark || "添加备注" }}
          </div>
        </el-popover>
      </div>

    </div>

    
    <div class="flex flex-between">
      <div class="bg ocrResult p10">
        <div class="title">
          OCR识别结果
        </div>
        <div style="height:calc(100vh - 300px)" class="ocr">
          <el-scrollbar style="height:100%" class="page-component__scroll">
            <div
                v-for="(v, i) in detailsSalesVolume.ocrResultList"
                :key="i"
                class="mb10 pointer"
                @click="getInfo(v)"
            >
              <div :class="{ hoverBg: i == hoverIndex }">
                {{ i + 1 }}. {{ v }}
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <!-- declareSn=0130705590698076&declareVersion=old&receiptId=f64afc99e1dd4345afd29db907048848 -->
      <div class="flex-2 p10 bg ml10" style="width:50%" v-if="false">
        <div class="fz">
          <div class="flex flex-between mb10">
            <div >
              <div class="flex item-center">
                <div>
                  <div>申报单号：{{ detailsSalesVolume.declareSn }}</div>
                  <div>申报时间: {{ detailsSalesVolume.declareTime }}</div>
                </div>
                <div style="padding: 2px 5px;border-radius: 4px;border: 1px solid #E50065;background: #FEDEEC;color: #E50065;font-size: 12px;margin-left: 10px;text-align: center"  v-if="detailsSalesVolume.declareVersion == 'new'">全审单</div>
                <div style="padding: 2px 5px;border-radius: 4px;border: 1px solid #37d351;background: #37d351;color: #FFFFFF;font-size: 12px;margin-left: 10px;text-align: center; white-space:nowrap;"  v-if="detailsSalesVolume.shopMonthlyStatementFlag">月结单</div>
                <!--                <div style="padding: 2px 5px;border-radius: 4px;border: 1px solid #E50065;background: #FEDEEC;color: #E50065;font-size: 12px;margin-left: 10px;text-align: center; white-space:nowrap;"  v-if="detailsSalesVolume.shopMonthlyStatementFlag" @click="transferSupplier">月结单</div>-->
                <div style="padding: 2px 5px;border-radius: 4px;border: 1px solid #E50065;background: #FEDEEC;color: #E50065;font-size: 12px;margin-left: 10px;text-align: center;white-space:nowrap;cursor:pointer;"  v-if="detailsSalesVolume.errorBillAudit && !detailsSalesVolume.supplierAuditing && personAuditState === 'wait' " @click="showErrorAuditDialog" >转给供货商人员审批</div>
                <div style="padding: 2px 5px;border-radius: 4px;border: 1px solid #E50065;background: #FEDEEC;color: #E50065;font-size: 12px;margin-left: 10px;text-align: center;white-space:nowrap;cursor:pointer;"  v-if="detailsSalesVolume.supplierAuditing">供应商人员审核中</div>
              </div>
            </div>
            <div class="flex flex-column">
              <div
                  class="flex item-center flex-end"
                  v-if="personAuditState === 'agree'"
              >
                <div>审核状态：<span class="success">已通过</span></div>
              </div>
              <div
                  class="flex item-center flex-end"
                  v-if="personAuditState === 'refuse'"
              >
                审核状态：<span class="danger">已驳回</span>
              </div>
              <div
                  class="flex item-center flex-end"
                  v-if="personAuditState === 'hang'"
              >
                审核状态：<span class="danger">挂单</span>
              </div>
              <div
                  class="flex item-center flex-end"
                  v-if="personAuditState === 'wait'"
              >
                审核状态：<span class="blue">待审核</span>
              </div>
              <div v-if="detailsSalesVolume.personAuditUsername && detailsSalesVolume.personAuditTime">
                <!-- 审核人和审核时间:{{detailsSalesVolume.personAuditUsername}},{{detailsSalesVolume.personAuditTime}} -->
                <span :style="{color:detailsSalesVolume.personAuditUsername.includes('personAppeal')?'red':''}">{{detailsSalesVolume.personAuditUsername.includes('personAppeal') ? "系统驳回申诉单":detailsSalesVolume.personAuditUsername}}</span>,{{detailsSalesVolume.personAuditTime}}
              </div>

              <div v-if="detailsSalesVolume.declareIpAddr">
                申报所在地：{{detailsSalesVolume.declareIpAddr}}
              </div>
            </div>
          </div>
          <div class="flex flex-between mb10 item-center">
            <div style="width:180px">
              导购电话：{{ detailsSalesVolume.guiderPhone }}
            </div>

            <div class="flex-1 text-right"
                 :class="[
                  detailsSalesVolume.shopName == detailsSalesVolume.curGuiderShopName ? '' : 'danger'
                ]">
                <span v-if="detailsSalesVolume.curGuiderShopName && detailsSalesVolume.curGuiderShopName == detailsSalesVolume.shopName"  @click="modifyTheStoreMethod(detailsSalesVolume.shopName)">
                  导购门店：{{ detailsSalesVolume.curGuiderShopName }}
                </span>
              <span v-else  @click="modifyTheStoreMethod(detailsSalesVolume.shopName)">
                所属门店：{{ detailsSalesVolume.shopName }}
                </span>
            </div>
          </div>
            <div class="flex flex-end"
                :class="[
                    detailsSalesVolume.shopName == detailsSalesVolume.curGuiderShopName ? '' : 'danger'
                  ]"
                v-if="detailsSalesVolume.curGuiderShopName && detailsSalesVolume.curGuiderShopName !== detailsSalesVolume.shopName"
            >
              当前导购门店：{{ detailsSalesVolume.curGuiderShopName }}
            </div>


            <!-- <div class="flex-1 text-right"
                 :class="[
                  detailsSalesVolume.shopName == detailsSalesVolume.curGuiderShopName ? '' : 'danger'
                ]">

                
                <p v-if="detailsSalesVolume.curGuiderShopName && detailsSalesVolume.curGuiderShopName == detailsSalesVolume.shopName "  @click="modifyTheStoreMethod(detailsSalesVolume.curGuiderShopName)">

                  导购门店：{{ detailsSalesVolume.curGuiderShopName }}

                </p>

                <div 
                    :class="[
                        detailsSalesVolume.shopName == detailsSalesVolume.curGuiderShopName ? '' : 'danger'
                      ]"
                    v-if="detailsSalesVolume.curGuiderShopName && detailsSalesVolume.curGuiderShopName != detailsSalesVolume.shopName"
                    @click="modifyTheStoreMethod(detailsSalesVolume.shopName)"
                >
                  当前导购门店：{{ detailsSalesVolume.shopName }}
                </div>
            
                
            </div>
          </div> -->

          <!-- <div style="cursor:pointer" v-if="!detailsSalesVolume.curGuiderShopName || detailsSalesVolume.curGuiderShopName != detailsSalesVolume.shopName"  class="flex flex-end danger"
          @click="modifyTheStoreMethod(detailsSalesVolume.shopName)"
          >
            门店打印名称：{{ detailsSalesVolume.shopName }}
          </div> -->
          <!-- <div  style="cursor:pointer"  class="flex flex-end danger"
          @click="modifyTheStoreMethod(detailsSalesVolume.shopName)"
          >
            门店打印名称：{{ detailsSalesVolume.shopName }}
          </div> -->
        


        
          <el-dialog
            title="门店打印名称"
            :visible.sync="storesDialogVisible"
            width="420px"
            >
            <el-input v-model="theNameOfTheStore" placeholder="请输入小票上的门店打印名称" size="small" style="width: 100%;"></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" size="small" @click="storeModificationSubmission">确 定</el-button>
            </span>
          </el-dialog>


          <div class="flex mb10 item-center">
            <div class="breadth flex">
              <span
                  :class="[
                  detailsSalesVolume.guiderNameFlag === true
                    ? 'success'
                    : detailsSalesVolume.guiderNameFlag === false
                    ? 'danger'
                    : ''
                ]"
                  class="text-right"
                  style="margin-left: 27px;"
              >导购姓名:</span
              >
              <div style="width:200px" class="flex flex-around">
                <span class="mr10">{{ detailsSalesVolume.guiderName }}</span>
                <span class="mr10">{{ detailsSalesVolume.creditLevel }}</span
                ><span class="mr10">{{ detailsSalesVolume.declareNum }}单</span>
              </div>
              <span> {{ detailsSalesVolume.accessPercent * 100 }}%</span>
            </div>
            <!--<div v-if="templateInfo.guiderName === 'yes'">
              <span
                class="pointer mr10"
                @click="detailsTemp(templateInfo.guiderNameTemplateId)"
              >
                <span class="hmicon icon-chakan "></span>
                <span class="">查看模板</span>
              </span>
              &lt;!&ndash; <el-tag type="info" size="small" class="mr10">模板三</el-tag> &ndash;&gt;
              <span
                class="pointer"
                @click="
                  editTemp(
                    templateInfo.guiderNameTemplateId,
                    'shopName',
                    '选择门店模板'
                  )
                "
              >
                <span class="hmicon icon-bianji blue"></span>
                <span class="blue">修改模板</span>
              </span>
            </div>
            <div
              class="pointer"
              v-else
              @click="
                editTemp(
                  templateInfo.guiderNameTemplateId,
                  'guiderName',
                  '选择导购名称模板'
                )
              "
            >
              <span class="hmicon icon-tishi1 not-config"></span>
              <span class="not-config">未配置，</span>
              <span class="">请选择></span>
            </div>-->
            <div
                class="pointer"
                @click="guiderAliasConfig"
            >
              <span v-if="personAuditState === 'wait'" class="">请选择></span>
            </div>
          </div>
          <div class="flex mb10 item-center">
            <div
                class="flex item-center breadth"
                @mouseenter="mouseover(detailsSalesVolume.shopNameIndex)"
                @mouseleave="mouseLeave"
            >
              <span
                @click="ocrMatchLogShop(detailsSalesVolume)"
                  :class="[
                  detailsSalesVolume.storeNameOcrFlag ? 'success pointer' : 'danger pointer'
                ]"
                  class="text-right"
              >识别所属门店:</span
              >
              
              <el-input
                  :disabled="personAuditState === 'agree'"
                  v-model="detailsSalesVolume.ocrShopName"
                  @focus="receiptSnFocus('shopName')"
                  ref="shopNameFocusRef"
                  clearable
                  style="width:200px"
                  placeholder="请填写门店"
                  size="small"
                  class="ipt"
                  @blur="changeShopName()"
              ></el-input>
              <span> {{ detailsSalesVolume.shopNameMatchPercent || 0 }}%</span>
            </div>

            <div v-if="templateInfo.shopName === 'yes'">
              <span
                  class="pointer mr10"
                  @click="detailsTemp(templateInfo.shopNameTemplateId)"
              >
                <span class="hmicon icon-chakan "></span>
                <span class="">查看模板</span>
              </span>
              <!-- <el-tag type="info" size="small" class="mr10">模板三</el-tag> -->
              <span
                  class="pointer"
                  @click="
                  editTemp(
                    templateInfo.shopNameTemplateId,
                    'shopName',
                    '选择门店模板'
                  )
                "
              >
                <span v-if="(personAuditState === 'wait' || personAuditState === 'hang')" class="hmicon icon-bianji blue"></span>
                <span v-if="(personAuditState === 'wait' || personAuditState === 'hang')" class="blue">修改模板</span>
              </span>
            </div>
            <div
                class="pointer"
                v-else
                @click="
                editTemp(
                  templateInfo.shopNameTemplateId,
                  'shopName',
                  '选择门店模板'
                )
              "
            >
              <span class="hmicon icon-tishi1 not-config"></span>
              <span class="not-config">未配置</span>
              <span v-if="personAuditState === 'wait'" class="">，请前往配置></span>
            </div>
          </div>
          <div class="flex  mb10 item-center">
            <div
                class="breadth"
                @mouseenter="mouseover(detailsSalesVolume.ocrDateIndex)"
                @mouseleave="mouseLeave"
            >
              <span
                  class="text-right"
                  :class="[detailsSalesVolume.receiptDate ? 'success' : 'danger']"
              >
                识别小票日期:
              </span>
              <el-date-picker
                  :disabled="personAuditState === 'agree'"
                  @change="receiptDateChange"
                  style="width:200px;margin-left:-4px"
                  v-model="detailsSalesVolume.receiptDate"
                  align="right"
                  size="small"
                  type="date"
                  placeholder="请小票日期"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
            <div v-if="templateInfo.receiptSnDate === 'yes'">
              <span
                  class="pointer mr10"
                  @click="detailsTemp(templateInfo.receiptSnDateTemplateId)"
              >
                <span class="hmicon icon-chakan "></span>
                <span class="">查看模板</span>
              </span>
              <!-- <el-tag type="info" size="small" class="mr10">模板三</el-tag> -->
              <span
                  class="pointer"
                  @click="
                  editTemp(
                    templateInfo.receiptSnDateTemplateId,
                    'receiptSnDate',
                    '选择小票日期模板'
                  )
                "
              >
                <span v-if="(personAuditState === 'wait' || personAuditState === 'hang')" class="hmicon icon-bianji blue"></span>
                <span v-if="(personAuditState === 'wait' || personAuditState === 'hang')" class="blue">修改模板</span>
              </span>
            </div>
            <div v-else-if="templateInfo.receiptDate === 'yes'">
              <span
                  class="pointer mr10"
                  @click="detailsTemp(templateInfo.receiptDateTemplateId)"
              >
                <span class="hmicon icon-chakan "></span>
                <span class="">查看模板</span>
              </span>
              <!-- <el-tag type="info" size="small" class="mr10">模板三</el-tag> -->
              <span
                  class="pointer"
                  @click="
                  editTemp(
                    templateInfo.receiptDateTemplateId,
                    'receiptDate',
                    '选择小票日期模板'
                  )
                "
              >
                <span v-if="(personAuditState === 'wait' || personAuditState === 'hang')" class="hmicon icon-bianji blue"></span>
                <span v-if="(personAuditState === 'wait' || personAuditState === 'hang')" class="blue">修改模板</span>
              </span>
            </div>
            <div
                class="pointer"
                v-else
                @click="
                editTemp(
                  templateInfo.receiptDateTemplateId,
                  'receiptDate',
                  '选择小票日期模板'
                )
              "
            >
              <span class="hmicon icon-tishi1 not-config"></span>
              <span class="not-config">未配置</span>
              <span v-if="personAuditState === 'wait'" class="">，请前往配置></span>
            </div>
          </div>
          <div class="flex  mb10 item-center">
            <div
                class="breadth"
                @mouseenter="mouseover(detailsSalesVolume.ocrReceiptSnIndex)"
                @mouseleave="mouseLeave"
            >
              <span
                  class="text-right"
                  style="margin-left:14px"
                  :class="[
                  detailsSalesVolume.receiptSn !== '' &&
                  minReceiptSnLength <= detailsSalesVolume.receiptSn.length &&
                  detailsSalesVolume.receiptSn.length <= maxReceiptSnLength
                    ? 'success'
                    : 'danger'
                ]"
              >
                识别小票号:</span
              >
              <el-input
                  :disabled="personAuditState === 'agree'"
                  v-model="detailsSalesVolume.receiptSn"
                  clearable
                  @focus="receiptSnFocus('receiptSn')"
                  @input="filterGt0OrChinese('receiptSn')"
                  style="width:200px"
                  placeholder="请填写小票号"
                  size="small"
                  class="ipt"
              ></el-input>
              {{ detailsSalesVolume.receiptSn.length }}/{{
                minReceiptSnLength
              }}-{{ maxReceiptSnLength }}
            </div>
            <div v-if="templateInfo.receiptSn === 'yes'">
              <span
                  class="pointer mr10"
                  @click="detailsTemp(templateInfo.receiptSnTemplateId)"
              >
                <span class="hmicon icon-chakan "></span>
                <span class="">查看模板</span>
              </span>
              <!-- <el-tag type="info" size="small" class="mr10">模板三</el-tag> -->
              <span
                  class="pointer"
                  @click="
                  editTemp(
                    templateInfo.receiptSnTemplateId,
                    'receiptSn',
                    '选择小票号模板'
                  )
                "
              >
                <span v-if="(personAuditState === 'wait' || personAuditState === 'hang')" class="hmicon icon-bianji blue"></span>
                <span v-if="(personAuditState === 'wait' || personAuditState === 'hang')" class="blue">修改模板</span>
              </span>
            </div>


            <div
                class="pointer"
                v-else
                @click="
                editTemp(
                  templateInfo.receiptSnTemplateId,
                  'receiptSn',
                  '选择小票号模板'
                )
              "
            >
              <span class="hmicon icon-tishi1 not-config"></span>
              <span class="not-config">未配置</span>
              <span v-if="personAuditState === 'wait'" class="">，请前往配置></span>
            </div>

            <div class="ml20" v-if="detailsSalesVolume.receiptSn && detailsSalesVolume.posOrder">
                  <span
                      class="pointer mr10"
                      @click="viewOrder(detailsSalesVolume.receiptSn, detailsSalesVolume.storeCode)"
                  >
                <span class="hmicon icon-chakan "></span>
                <span class="">查看电子小票</span>
              </span>
            </div>
          </div>
          <div class="flex  mb10 item-center">
            <div class="breadth">
              <span
                  class="text-right"
                  style="margin-left:14px"
                  :class="[
                  minStrLength <= receiptDateStrLength &&
                  receiptDateStrLength <= maxStrLength
                    ? 'success'
                    : 'danger'
                ]"
              >
                识 别 时 间:</span
              >
              <el-input
                  :disabled="personAuditState === 'agree'"
                  v-model="detailsSalesVolume.receiptDateStr"
                  clearable
                  type="number"
                  @focus="receiptSnFocus('receiptDateStr')"
                  @input="filterGt0OrChinese('receiptDateStr')"
                  @change="receiptDateStrChange"
                  style="width:200px"
                  placeholder="请填写"
                  size="small"
                  class="ipt"
              ></el-input>
              {{ receiptDateStrLength }}/{{ minStrLength }}-{{ maxStrLength }}
            </div>
            <div v-if="templateInfo.receiptDateStr === 'yes'">
              <!-- <el-tag type="info" size="small" class="mr10">模板三</el-tag> -->
              <span
                  class="pointer mr10"
                  @click="detailsTemp(templateInfo.receiptDateStrTemplateId)"
              >
                <span class="hmicon icon-chakan "></span>
                <span class="">查看模板</span>
              </span>
              <span
                  class="pointer"
                  @click="
                  editTemp(
                    templateInfo.receiptDateStrTemplateId,
                    'receiptDateStr',
                    '选择小票时间模板'
                  )
                "
              >
                <span v-if="(personAuditState === 'wait' || personAuditState === 'hang')" class="hmicon icon-bianji blue"></span>
                <span v-if="(personAuditState === 'wait' || personAuditState === 'hang')" class="blue">修改模板</span>
              </span>
            </div>

            <div
                class="pointer"
                v-else
                @click="
                editTemp(
                  templateInfo.receiptDateStrTemplateId,
                  'receiptDateStr',
                  '选择小票时间模板'
                )
              "
            >
              <span class="hmicon icon-tishi1 not-config"></span>
              <span class="not-config">未配置</span>
              <span v-if="personAuditState === 'wait'" class="">，请前往配置></span>
            </div>
          </div>
          <div class="flex flex-between  mb10 item-center">
            <div>
              <div v-if="templateInfo.receiptRepeat === 'yes'">
                <span
                    class="pointer mr10"
                    @click="detailsTemp(templateInfo.receiptRepeatTemplateId)"
                >
                  <span class="hmicon icon-chakan "></span>
                  <span class="">查看去重规则模板</span>
                </span>
                <!-- <el-tag type="info" size="small" class="mr10">模板三</el-tag> -->
                <span
                    class="pointer"
                    @click="
                    editTemp(
                      templateInfo.receiptRepeatTemplateId,
                      'receiptRepeat',
                      '选择小票去重模板'
                    )
                  "
                >
                  <span  v-if="personAuditState === 'wait' || personAuditState === 'hang'" class="hmicon icon-bianji blue"></span>
                  <span
                      v-if="personAuditState === 'wait' || personAuditState === 'hang'"
                      class="blue"
                  >
                      修改去重规则模板
                  </span>
                </span>
                <span class="ml10">当前去重模版名称：{{ receiptRepeatTemplateName }}</span>
              </div>
              <div
                  class="pointer"
                  v-else
                  @click="
                  editTemp(
                    templateInfo.receiptRepeatTemplateId,
                    'receiptRepeat',
                    '选择小票去重模板'
                  )
                "
              >
                <span class="hmicon icon-tishi1 not-config"></span>
                <span class="not-config">去重规则未配置</span>
                <span v-if="personAuditState === 'wait'" class="">，请前往配置></span>
              </div>
            </div>
            <!-- <div>
              <div v-if="templateInfo.number==='yes'">
                <span class="pointer mr10" @click="detailsTemp(templateInfo.numberTemplateId)">
                  <span class="hmicon icon-chakan blue"></span> <span class="blue">查看商品数量模板</span>
                </span>
                <span class="pointer" @click="editTemp(templateInfo.receiptRepeatTemplateId,'number','选择小票去重模板')">
                  <span class="hmicon icon-bianji blue"></span> <span class="blue">修改商品数量模板</span>
                </span>
              </div>
              <div class="pointer" v-else @click="editTemp(templateInfo.receiptRepeatTemplateId,'number','选择小票去重模板')">
                <span class="hmicon icon-tishi1 not-config"></span> <span class="not-config">商品数量规则未配置，</span> <span class="blue">请前往配置></span>
              </div>
            </div> -->
          </div>
          <div class="flex  mb10 item-center">
            <div v-if="templateInfo.number === 'yes'">
              <span
                  class="pointer mr10"
                  @click="detailsTemp(templateInfo.numberTemplateId)"
              >
                <span class="hmicon icon-chakan "></span>
                <span class="">查看商品数量模板</span>
              </span>
              <!-- <el-tag type="info" size="small" class="mr10">模板三</el-tag> -->
              <span
                  class="pointer"
                  @click="
                  editTemp(
                    templateInfo.numberTemplateId,
                    'number',
                    '选择商品数量模板'
                  )
                "
              >
                <span v-if="(personAuditState === 'wait' || personAuditState === 'hang')" class="hmicon icon-bianji blue"></span>
                <span v-if="(personAuditState === 'wait' || personAuditState === 'hang')" class="blue">修改商品数量模板</span>
              </span>
            </div>
            <div
                class="pointer"
                v-else
                @click="
                editTemp(
                  templateInfo.numberTemplateId,
                  'number',
                  '选择商品数量模板'
                )
              "
            >
              <span class="hmicon icon-tishi1 not-config"></span>
              <span class="not-config">商品数量规则未配置</span>
              <span  v-if="personAuditState === 'wait'" class="">，请前往配置></span>
            </div>
          </div>
        </div>
        <!-- <div class="flex flex-around mb10">
          <div class="flex-2">申报单号：{{ detailsSalesVolume.declareSn }}</div>

          <div
            class="flex-1 flex item-center"
            v-if="personAuditState === 'agree'"
          >
            审核状态：<span class="success">已通过</span>
          </div>
          <div
            class="flex-1 flex item-center"
            v-if="personAuditState === 'refuse'"
          >
            审核状态：<span class="danger">已驳回</span>
          </div>
          <div
            class="flex-1 flex item-center"
            v-if="personAuditState === 'hang'"
          >
            审核状态：<span class="danger">挂单</span>
          </div>
          <div
            class="flex-1 flex item-center"
            v-if="personAuditState === 'wait'"
          >
            审核状态：<span class="blue">待审核</span>
          </div>
        </div>
        <div class="flex flex-between mb10 item-center">
          <div
            class="flex-2 flex item-center"
            @mouseenter="mouseover(detailsSalesVolume.shopNameIndex)"
            @mouseleave="mouseLeave"
          >
            <span
              :class="[
                detailsSalesVolume.storeNameOcrFlag ? 'success' : 'danger'
              ]"
              class="text-right"
              >识别所属门店:</span
            >
            <el-input
              :disabled="personAuditState === 'agree'"
              v-model="detailsSalesVolume.ocrShopName"
              clearable
              style="width:200px"
              placeholder="请填写门店"
              size="small"
              class="ipt"
            ></el-input>
            <span> {{ detailsSalesVolume.shopNameMatchPercent || 0 }}%</span>
          </div>
          <div class="flex-1">
            导购姓名：<span class="mr10">{{ detailsSalesVolume.guiderName }}</span> <span class="mr10">{{detailsSalesVolume.creditLevel}}</span><span class="mr10">{{detailsSalesVolume.declareNum}}单</span><span>{{detailsSalesVolume.accessPercent*100}}%</span>
          </div>
        </div>
        <div class="flex flex-between mb10 item-center">
          <div
            class="flex-2"
            @mouseenter="mouseover(detailsSalesVolume.ocrDateIndex)"
            @mouseleave="mouseLeave"
          >
            <span
              class="text-right"
              :class="[detailsSalesVolume.receiptDate ? 'success' : 'danger']"
            >
              识别小票日期:
            </span>
            <el-date-picker
              :disabled="personAuditState === 'agree'"
              @change="receiptDateChange"
              style="width:200px;marginLeft:-4px"
              v-model="detailsSalesVolume.receiptDate"
              align="right"
              size="small"
              type="date"
              placeholder="请小票日期"
              value-format="yyyy-MM-dd"
              :picker-options="pickerOptions"
            >
            </el-date-picker>
          </div>
          <div class="flex-1">
            导购电话：{{ detailsSalesVolume.guiderPhone }}
          </div>
        </div>
        <div class="flex flex-between mb10 item-center">
          <div
            class="flex-2"
            @mouseenter="mouseover(detailsSalesVolume.ocrReceiptSnIndex)"
            @mouseleave="mouseLeave"
          >
            <span
              class="text-right"
              style="marginLeft:14px"
              :class="[
                detailsSalesVolume.receiptSn !== '' ? 'success' : 'danger'
              ]"
            >
              识别小票号:</span
            >
            <el-input
              :disabled="personAuditState === 'agree'"
              v-model="detailsSalesVolume.receiptSn"
              clearable
              @focus="receiptSnFocus('receiptSn')"
              @input="filterGt0OrChinese('receiptSn')"
              style="width:200px"
              placeholder="请填写小票号"
              size="small"
              class="ipt"
            ></el-input>
            {{ detailsSalesVolume.receiptSn.length }}/{{
              detailsSalesVolume.receiptSnLength
            }}
          </div>
          <div class="flex-1">所属门店：{{ detailsSalesVolume.shopName }}</div>

        </div>
        <div class="flex flex-between mb10 item-center">
          <div class="flex-2">
            <span
              class="text-right"
              style="marginLeft:14px"
              :class="[
                receiptDateStrLength== 14 ? 'success' : 'danger'
              ]"
            >
              识 别 时 间:</span
            >
            <el-input
              :disabled="personAuditState === 'agree'"
              v-model="detailsSalesVolume.receiptDateStr"
              clearable
              type="number"
              @focus="receiptSnFocus('receiptDateStr')"
              @input="filterGt0OrChinese('receiptDateStr')"
              @change="receiptDateStrChange"
              style="width:200px"
              placeholder="请填写"
              size="small"
              class="ipt"
            ></el-input>
            {{ receiptDateStrLength}}/14
          </div>
          <div class="flex-1">

          </div>

        </div> -->
        <div class="item-center flex mb10">
          <span class="not-config" style="font-size: 14px; margin-right: 5px">数量规则校验成功是否通过:</span>
          <el-switch
              size="small"
              v-model="newNumAutoEnableSwitch"
              active-text="通过"
              inactive-text="不通过"
              active-color="#2fc348"
              inactive-color="#ff0000"
              @change="numAutoEnableChange"
          ></el-switch>
        </div>

        <div class="item-center flex flex-between mb10">
          <el-switch
              size="mini"
              v-model="detailsSalesVolume.isWhite"
              active-text="白名单"
              inactive-text="黑名单"
              active-color="#2fc348"
              inactive-color="#ff0000"
              @change="blackReasonClick"
          ></el-switch>

          <div style="text-align: right;">
            <p style="margin-bottom: 6px;" v-if="totalGoodsNum >= 10">共计申报：<span style="font-weight: 600;font-size: 28px; color: red; ">{{ totalGoodsNum }}</span>件</p>
            <p style="margin-bottom: 6px;" v-else>共计申报：<span style="font-weight: 600;">{{ totalGoodsNum }}</span>件</p>
            <p style="margin-bottom: 10px;" v-if="ToFixed(detailsSalesVolume.total, 2)>=10">总计提成：<span style="font-weight: 600;font-size: 28px; color: red; " >¥{{ ToFixed(detailsSalesVolume.total, 2) }}</span>元</p>
            <p style="margin-bottom: 10px;" v-else>总计提成：<span style="font-weight: 600;" >¥{{ ToFixed(detailsSalesVolume.total, 2) }}</span>元</p>
          </div>

          <p v-if="riskManagementRefuseReason == '该申报单中没有必有商品或必选商品数量不够'" style="color: #f7912b;">该申报单中没有必有商品或必选商品数量不够</p>
          
          <el-autocomplete
              v-if="detailsSalesVolume.declareVersion == 'new'"
              popper-class="my-autocomplete"
              v-model="state"
              size="small"
              clearable
              @focus="receiptSnFocus('querySearch')"
              class="shop-goods-search"
              :fetch-suggestions="querySearch"
              :trigger-on-focus="false"
              :popper-append-to-body="false"
              placeholder="请输入品名/条码/货号"
              @select="handleSelect">
            <i
                class="el-input__icon hmicon icon-search"
                slot="suffix">
            </i>
            <template v-if="hasDataList" slot-scope="{ item }">
              <div v-if="item.hasActivity">
                <div class="flex item-center">
                  <div class="brand">{{ item.brandName }}</div>
                  <span class="goodsName flex-1">{{ item.goodsName }}</span>
                  <div style="width: 44px; padding: 0 2px; text-align: center; border-radius: 4px; color: #2FC348; border: 1px solid #2FC348;" >有活动</div>
                </div>
                <div class="flex flex-between item-center">
                  <div class="flex item-center goods-info">
                    <div>条码:{{ item.goodsBarcode }}</div>
                    <div class="ml20" v-if="item.goodsSn">货号:{{ item.goodsSn }}</div>
                  </div>
                  <div class="flex item-center goods-info">
                    <div v-if="item.hasGoodsNum && item.hasGoodsNum > 0">已有数量：{{ item.hasGoodsNum }}</div>
                    <div style="color: #222222;" class="ml10">最低奖励：<span style="color: #E50065">¥{{ item.minDeclareReward }}</span></div>
                  </div>
                </div>

              </div>
              <div v-else>
                <div class="flex item-center">
                  <div class="brand-notActivity">{{ item.brandName }}</div>
                  <span class="goodsName-notActivity flex-1">{{ item.goodsName }}</span>
                  <div style="width: 44px; padding: 0 2px; text-align: center; border-radius: 4px; color: #dddddd; border: 1px solid #dddddd;">无活动</div>
                </div>
                <div class="flex flex-between item-center">
                  <div class="flex item-center goods-info">
                    <div>条码:{{ item.goodsBarcode }}</div>
                    <div class="ml20" v-if="item.goodsSn">货号:{{ item.goodsSn }}</div>
                  </div>
                </div>

              </div>
            </template>
            <template v-else slot-scope="{ item }">
              <div class="notHasData">
                <div>{{ item.value }}</div>
              </div>
            </template>
          </el-autocomplete>
        </div>
        <div v-if="declareVersion == 'new'">
          <el-scrollbar
              ref="scrollContainer"
              :vertical="false"
              wrap-style="max-height: 400px;"
          >
            <div
                v-for="(v, i) in detailsSalesVolume.newVersionRewardRuleInfoModelList"
                :key="i"
                class="border1"
            >
              <div class="flex flex-between p10 header">
                <div @click="evenDetails(v)" class="pointer">
                  <el-tag
                      v-if="v.rewardMode === 'fixed'"
                      effect="plain"
                      size="small"
                      class="blue"
                      style="border-color:#56abee;"
                  >
                    普通活动
                  </el-tag>
                  <el-tag
                      effect="plain"
                      size="small"
                      class="blue"
                      v-if="v.rewardMode === 'sub'"
                      style="borderColor:#56abee;"
                  >
                    差异活动
                  </el-tag>
                  <el-tag
                      v-if="v.rewardMode === 'radio'"
                      effect="plain"
                      size="small"
                      class="blue"
                      style="border-color:#56abee;"
                  >
                    冲刺活动
                  </el-tag>
                  <el-tag
                    effect="plain"
                    size="small"
                    class="blue"
                    v-if="v.rewardMode === 'collocation'"
                    style="borderColor:#56abee;"
                  >
                    搭配活动
                  </el-tag>
                  <span class="ml10">{{ v.rewardName }}</span>
                  <span class="ml10" v-if="v.rewardRuleId">
                    {{ v.rewardStartDate }}至{{ v.rewardEndDate }}
                  </span>
                </div>
                <div class="flex-1 primary flex flex-end item-center mr10">
                  {{ !v.rewardRuleId ? "- -" : v.rewardMoney + "元" }}
                </div>
              </div>
              <div
                  v-for="(j, k) in v.billDetailsBoList"
                  class="p10 fz13 tab-body mb10"
                  :key="k"
                  @click="getKey(i, k)"
              >
                <div class="flex item-center one-item">
                  <div class="delete-icon" @click="deleteGoods(j)">
                    <i class="hmicon icon-shanchu"></i>
                  </div>
                  <div class="flex item-center" style="width: 60%">
                    <div class="match-wrapper mr20">
                      <el-progress type="circle" :width="56" :color="'#2FC348'" :percentage="new Number(j.goodsNameMatchPercent)"></el-progress>
                    </div>
                    <div class="goodsName-wrapper">
                      <div class="flex item-center">
                        <div class="title-wrapper mr10" v-if="new Number(j.goodsNameMatchPercent) < 100">ocr</div>
                        <i class="hmicon icon-xuanzhong mr10" v-if="new Number(j.goodsNameMatchPercent) >= 100 && j.ocrGoodsName" style="color: #2FC348"></i>
                        <div style="font-size: 0" v-if="new Number(j.goodsNameMatchPercent) < 100">
                        <span v-for="(name, nameIndex) in j.ocrGoodsNameList" :key="nameIndex"
                              class="name-wrapper"
                              :class="name.findFlag == 'err'? 'name-ocr-err' : ''">{{name.name}}</span>
                        </div>
                        <div class="name-wrapper" style="color: #2FC348" v-if="new Number(j.goodsNameMatchPercent) >= 100 && j.ocrGoodsName">
                          <span>{{ j.ocrGoodsName }}</span>
                        </div>
                      </div>
                      <div class="flex item-center mt10">
                        <div class="title-wrapper mr10" v-if="new Number(j.goodsNameMatchPercent) < 100">商品名</div>
                        <i class="hmicon icon-xuanzhong mr10" v-if="new Number(j.goodsNameMatchPercent) >= 100" style="color: #2FC348"></i>
                        <div style="font-size: 0" v-if="new Number(j.goodsNameMatchPercent) < 100">
                        <span v-for="(name, nameIndex) in j.goodsNameList" :key="nameIndex"
                              class="name-wrapper"
                              :class="name.findFlag == 'err'? 'name-err' : ''">{{name.name}}</span>
                        </div>
                        <div class="name-wrapper" style="color: #2FC348" v-if="new Number(j.goodsNameMatchPercent) >= 100">
                          <span>{{ j.goodsName }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="flex item-center flex-between flex-1">
                    <div class="goodsNum-wrapper">
                      <div>
                        <el-input placeholder="请输入内容" v-model="j.goodsNum" maxlength="4" type="number" size="mini" @blur="goodsNumBlur(j)" class="input-with-select">
                          <el-button slot="prepend" size="mini" icon="el-icon-minus" :disabled="j.goodsNum <= 1" @click="changeGoodsNum('sub', j)"></el-button>
                          <el-button slot="append" size="mini" icon="el-icon-plus" :disabled="j.goodsNum >= 9999" @click="changeGoodsNum('add', j)"></el-button>
                        </el-input>
                      </div>
                      <div class="mt10 text-center" style="color: #999999">
                        识别数: <span style="color:#222222;">{{ j.ocrGoodsNum }}</span>
                      </div>
                    </div>
                    <div class="more-wrapper" v-if="j.hasOtherFlag">
                      <div class="more-item more-close" @click="openMore(j, k)" v-if="!j.openMoreFlag">
                        <i class="hmicon icon-arrow-down" style="color: #ffffff"></i>
                      </div>
                      <div class="more-item more-open" @click="openMore(j, k)" v-else>
                        <i class="hmicon icon-arrow-down icon-arrow-down-open rotate" style="color: #E50065;"></i>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="j.otherBillDetailsBoList && j.otherBillDetailsBoList.length > 0 && j.openMoreFlag">
                  <div class="flex item-center other-wrapper" v-for="(other, otherIndex) in j.otherBillDetailsBoList" :key="otherIndex">
                    <div class="flex item-center" style="width: 80%">
                      <div class="other-title mr20">备选商品{{ otherIndex + 1 }}</div>
                      <div class="match-wrapper mr20">
                        <el-progress type="circle" :width="56" :color="'#2FC348'" :percentage="new Number(other.goodsNameMatchPercent)"></el-progress>
                      </div>
                      <div class="goodsName-wrapper">
                        <div class="flex item-center">
                          <div class="title-wrapper mr10" v-if="new Number(other.goodsNameMatchPercent) < 100">ocr</div>
                          <i class="hmicon icon-xuanzhong mr10" v-if="new Number(other.goodsNameMatchPercent) >= 100" style="color: #2FC348"></i>
                          <div style="font-size: 0" v-if="new Number(other.goodsNameMatchPercent) < 100">
                        <span v-for="(name, nameIndex) in other.ocrGoodsNameList" :key="nameIndex"
                              class="name-wrapper"
                              :class="name.findFlag == 'err'? 'name-ocr-err' : ''">{{name.name}}</span>
                          </div>
                          <div class="name-wrapper" style="color: #2FC348" v-if="new Number(other.goodsNameMatchPercent) >= 100">
                            <span>{{ other.ocrGoodsName }}</span>
                          </div>
                        </div>
                        <div class="flex item-center mt10">
                          <div class="title-wrapper mr10" v-if="new Number(other.goodsNameMatchPercent) < 100">商品名</div>
                          <i class="hmicon icon-xuanzhong mr10" v-if="new Number(other.goodsNameMatchPercent) >= 100" style="color: #2FC348"></i>
                          <div style="font-size: 0" v-if="new Number(other.goodsNameMatchPercent) < 100">
                            <span v-for="(name, nameIndex) in other.goodsNameList" :key="nameIndex"
                                  class="name-wrapper"
                                  :class="name.findFlag == 'err'? 'name-err' : ''">{{name.name}}</span>
                          </div>
                          <div class="name-wrapper" style="color: #2FC348" v-if="new Number(other.goodsNameMatchPercent) >= 100">
                            <span>{{ other.goodsName }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex-1 flex item-center flex-end">
                      <div>
                        <div style="text-align: end" class="primary" v-if="!other.goodsPrice || other.goodsPrice <= 0">{{ "- -" }}</div>
                        <div style="text-align: end" class="primary" v-else>{{ "￥" + other.goodsPrice }}</div>
                        <div class="mt10">
                          <el-button type="primary" size="small" @click="selectOther(other, otherIndex, j, k)"
                          >选择</el-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </el-scrollbar>
        </div>
        <div v-else>
          <div v-if="detailsSalesVolume.rewardRuleInfoModelList.length">
            <el-scrollbar
                ref="scrollContainer"
                :vertical="false"
                wrap-style="max-height: 400px;"
            >
              <div
                  v-for="(v, i) in detailsSalesVolume.successList"
                  :key="i"
                  class="border1"
              >
                <div class="flex flex-between p10 header">
                  <div @click="evenDetails(v)" class="pointer">
                    <el-tag
                      effect="plain"
                      size="small"
                      class="blue"
                      v-if="v.rewardMode === 'collocation'"
                      style="borderColor:#56abee;"
                  >
                    搭配活动
                  </el-tag>
                   <el-tag
                      effect="plain"
                      size="small"
                      class="blue"
                      v-if="v.rewardMode === 'sub'"
                      style="borderColor:#56abee;"
                  >
                    差异活动
                  </el-tag>
                    <el-tag
                        v-if="v.rewardMode === 'fixed'"
                        effect="plain"
                        size="small"
                        class="blue"
                        style="border-color:#56abee;"
                    >
                      普通活动
                    </el-tag>
                    <el-tag
                        v-if="v.rewardMode === 'radio'"
                        effect="plain"
                        size="small"
                        class="blue"
                        style="border-color:#56abee;"
                    >
                      冲刺活动
                    </el-tag>
                    <el-tag
                    effect="plain"
                    size="small"
                    type="info"
                    v-if="v.rewardMode === 'fixed' && v.upperLimitSwitch"
                    style="borderColor:#909399;"
                  >
                    最高奖励匹配
                  </el-tag>
                    <span class="ml10">{{ v.rewardName }}</span>
                    <span class="ml10">
                    {{ v.rewardStartDate }}至{{ v.rewardEndDate }}
                  </span>
                  </div>
                  <div class="flex-1 primary flex flex-end item-center">
                    {{ v.rewardMoney }}元
                  </div>
                </div>

                
                <div
                    v-for="(j, k) in v.billDetailsBoList"
                    class="flex flex-between item-center p10 fz13 tab-body"
                    :class="{ 'required': j.isRequiredGoods === 'yes' }"
                    :key="k"
                    @click="getKey(i, k)"
                >
                  <div
                      class="input"
                      @mouseenter="mouseover(j.goodsNameIndex)"
                      @mouseleave="mouseLeave"
                  >
                    <div>
                      {{ j.ocrGoodsNames }}
                    </div>

                    <el-input
                        v-model="j.ocrGoodsName"
                        clearable
                        style="width:230px;"
                        placeholder="请填写匹配OCR商品名称"
                        size="small"
                        class="ipt"
                    >
                    </el-input>
                    <span>{{ j.goodsNameMatchPercent || 0 }}%</span>
                    <span
                        class="ml10 hmicon icon-tiaoma"
                        :class="j.goodsBarcodeFlag ? 'success' : 'danger'"
                    >
                  </span>
                  </div>
                  <div class="ml10 mr10" style="width:65px">
                    <el-tooltip
                        placement="top-start"
                        content="识别商品数量"
                        effect="dark"
                        v-if="j.ocrGoodsNum"
                    >
                      <div class="text-center mb10">
                        {{ j.ocrGoodsNum }}
                      </div>
                    </el-tooltip>
                    <el-tooltip
                        placement="top-start"
                        content="商品数量"
                        effect="dark"
                    >
                      <div class="text-center" v-if="detailsSalesVolume.declareVersion == 'new'">
                        <div @dblclick="changeRuleGoodsNumEnddate(i, k, j, 'succ')">
                        <span v-show="j.edit_goodsNum_enddate" class="blue pointer"
                        >{{ j.goodsNum }}
                          <!-- <span class="hmicon icon-shuru blue pointer"> </span> -->
                        </span>
                          <el-input
                              :ref="'enddateGoodsNumInput' + i + k"
                              @blur="enddateRuleGoodsNumBlur(i, k, j, 'succ')"
                              @keyup.enter.native="$event.target.blur"
                              clearable
                              v-show="!j.edit_goodsNum_enddate"
                              size="mini"
                              style="width:100%"
                              v-model="j.goodsNum"
                              placeholder="请输入内容"
                          ></el-input>
                        </div>
                      </div>
                      <div class="text-center" v-else>{{ j.goodsNum }}</div>
                    </el-tooltip>
                  </div>

                  <el-tooltip
                      v-if="j.goodsBarcodeFlag"
                      placement="top-start"
                      :content="j.goodsName"
                      effect="dark"
                  >
                    <div class="text-left flex-1 success" @click="ocrMatchLog(j)">
                      {{ j.goodsName }}
                    </div>
                  </el-tooltip>
                  <el-tooltip
                      v-else
                      placement="top-start"
                      :content="j.goodsName"
                      effect="dark"
                  >
                    <div
                        :class="[
                      goodsOcrFlag < j.goodsNameMatchPercent
                        ? 'success'
                        : 'danger'
                    ]"
                        class="text-left flex-1"
                        @click="ocrMatchLog(j)"
                    >
                      {{ j.goodsName }}
                    </div>
                  </el-tooltip>
                  <el-tooltip placement="top" content="商品条码" effect="dark">
                    <div class="" style="width:120px">
                      {{ j.goodsBarcode }}
                    </div>
                  </el-tooltip>
                  <el-tooltip
                      v-if="!!j.goodsSn"
                      :disabled="!j.goodsSn"
                      placement="top"
                      content="商品货号"
                      effect="dark"
                  >
                    <div class="" style="width:120px">
                      {{ j.goodsSn }}
                    </div>
                  </el-tooltip>
                </div>




              </div>
              <div v-if="detailsSalesVolume.errList.length">
                <div class="modal-table">
                  <div
                      class="table-header flex flex-start"
                      style="padding:10px 20px"
                  >
                    以下商品不满足活动
                  </div>
                  <div
                      v-for="(j, k) in detailsSalesVolume.errList"
                      class="table-body flex flex-between item-center"
                      :key="k + 'dd'"
                  >
                    <el-tooltip
                        placement="top-start"
                        :content="j.goodsName"
                        effect="dark"
                    >
                      <div class="text-left flex-1 danger">
                        {{ j.goodsName }}
                      </div>
                    </el-tooltip>
                    <div class="flex-1" v-if="detailsSalesVolume.declareVersion == 'new'">
                      <div @dblclick="changeRuleErrorGoodsNumEnddate(k, j)">
                        <span v-show="j.edit_err_goodsNum_enddate" class="blue pointer"
                        >{{ j.goodsNum }}
                        </span>
                        <el-input
                            :ref="'ruleErrGoodsNumInput' + k"
                            @blur="enddateRuleErrorGoodsNumBlur(k, j)"
                            @keyup.enter.native="$event.target.blur"
                            clearable
                            :key="Math.random()"
                            v-show="!j.edit_err_goodsNum_enddate"
                            size="mini"
                            style="width:100%"
                            v-model="j.goodsNum"
                            placeholder="请输入内容"
                        ></el-input>
                      </div>
                    </div>
                    <div class="flex-1" v-else> {{ j.goodsNum }}</div>
                    <div class="flex-1">
                      {{ j.goodsBarcode }}
                    </div>
                  </div>
                </div>
              </div>
            </el-scrollbar>
          </div>
          <div v-else>
            <el-table
                stripe
                border
                ref="table"
                show-summary
                :data="detailsSalesVolume.billDetailsBoList"
                style="width: 100%"
                id="table"
                size="small"
            >
              <el-table-column
                  type="index"
                  label="序号"
                  header-align="center"
                  align="center"
              ></el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="brandName"
                  label="品牌名"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="goodsName"
                  label="商品名"
              >
              </el-table-column>
              <el-table-column
                  header-align="center"
                  align="center"
                  prop="goodsNum"
                  label="商品数量"
              >
                <template slot-scope="scope">
                  <div @dblclick="changeGoodsNumEnddate(scope.$index, scope.row)" v-if="detailsSalesVolume.declareVersion == 'new'">
                  <span v-show="scope.row.edit_goodsNum_enddate" class="blue pointer"
                  >{{ scope.row.goodsNum }}
                  </span>
                    <el-input
                        :ref="'enddateGoodsNumInput' + scope.$index"
                        @blur="enddateGoodsNumBlur(scope.$index, scope.row)"
                        @keyup.enter.native="$event.target.blur"
                        clearable
                        v-show="!scope.row.edit_goodsNum_enddate"
                        size="mini"
                        style="width:100%"
                        v-model="scope.row.goodsNum"
                        placeholder="请输入内容"
                    ></el-input>
                  </div>
                  <div v-else>{{ scope.row.goodsNum }}</div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-if="false" style="max-height:300px" class="mt10 modal-table">
          <el-scrollbar
              style="height:100%"
              class="page-component__scroll"
              v-if="detailsSalesVolume.rewardRuleInfoModelList.length"
          >
            <div v-for="(v, i) in detailsSalesVolume.successList" :key="i">
              <div class="modal-table">
                <div class="table-header flex flex-bteween">
                  <div @click="evenDetails(v)" class="pointer">
                    <el-tag
                        v-if="v.rewardMode === 'fixed'"
                        effect="plain"
                        size="small"
                        class="blue"
                        style="border-color:#56abee;"
                    >
                      普通活动
                    </el-tag>
                     <el-tag
                      effect="plain"
                      size="small"
                      class="blue"
                      v-if="v.rewardMode === 'sub'"
                      style="borderColor:#56abee;"
                  >
                    差异活动
                  </el-tag>
                    <el-tag
                        v-if="v.rewardMode === 'radio'"
                        effect="plain"
                        size="small"
                        class="blue"
                        style="border-color:#56abee;"
                    >
                      冲刺活动
                    </el-tag>
                    {{ v.rewardName }}
                    <span class="ml10">
                      {{ v.rewardStartDate }}至{{ v.rewardEndDate }}
                    </span>
                  </div>
                  <div class="flex-1 primary flex flex-end item-center">
                    {{ v.rewardMoney }}元
                  </div>
                </div>
                <div
                    v-for="(j, k) in v.billDetailsBoList"
                    class="table-body flex flex-between item-center"
                    :key="k"
                    @click="getKey(i, k)"
                >
                  <div
                      class="input"
                      @mouseenter="mouseover(j.goodsNameIndex)"
                      @mouseleave="mouseLeave"
                  >
                    <div>
                      {{ j.ocrGoodsNames }}
                    </div>

                    <el-input
                        v-model="j.ocrGoodsName"
                        clearable
                        style="width:280px;"
                        placeholder="请填写匹配OCR商品名称"
                        size="small"
                        class="ipt"
                    >
                      <template slot="append">
                        <div style="width:55px">
                          {{ j.goodsNameMatchPercent || 0 }}%
                        </div>
                      </template>
                    </el-input>
                    <span
                        class="ml10 hmicon icon-tiaoma"
                        :class="j.goodsBarcodeFlag ? 'success' : 'danger'"
                    >
                    </span>
                  </div>
                  <div class="ml10 mr10">{{ j.goodsNum }}</div>
                  <el-tooltip
                      v-if="j.goodsBarcodeFlag"
                      placement="top-start"
                      :content="j.goodsName"
                      effect="dark"
                  >
                    <div class="text-left flex-1 success">
                      {{ j.goodsName }}
                    </div>
                  </el-tooltip>
                  <el-tooltip
                      v-else
                      placement="top-start"
                      :content="j.goodsName"
                      effect="dark"
                  >
                    <div
                        :class="[
                        goodsOcrFlag < j.goodsNameMatchPercent
                          ? 'success'
                          : 'danger'
                      ]"
                        class="text-left flex-1"
                    >
                      {{ j.goodsName }}
                    </div>
                  </el-tooltip>
                  <el-tooltip placement="top" content="商品条码" effect="dark">
                    <div class="flex-1">
                      {{ j.goodsBarcode }}
                    </div>
                  </el-tooltip>
                  <el-tooltip
                      v-if="!!j.goodsSn"
                      :disabled="!j.goodsSn"
                      placement="top"
                      content="商品货号"
                      effect="dark"
                  >
                    <div class="flex-1">
                      {{ j.goodsSn }}
                    </div>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div v-if="detailsSalesVolume.errList.length">
              <div class="modal-table">
                <div
                    class="table-header flex flex-start"
                    style="padding:10px 20px"
                >
                  以下商品不满足活动
                </div>
                <div
                    v-for="(j, k) in detailsSalesVolume.errList"
                    class="table-body flex flex-between item-center"
                    :key="k + 'dd'"
                >
                  <el-tooltip
                      placement="top-start"
                      :content="j.goodsName"
                      effect="dark"
                  >
                    <div class="text-left flex-1 danger">
                      {{ j.goodsName }}
                    </div>
                  </el-tooltip>
                  <div class="flex-1">{{ j.goodsNum }}</div>

                  <div class="flex-1">
                    {{ j.goodsBarcode }}
                  </div>
                </div>
              </div>
            </div>
          </el-scrollbar>
          <el-table
              stripe
              border
              v-else
              ref="table"
              show-summary
              :data="detailsSalesVolume.billDetailsBoList"
              style="width: 100%"
              id="table"
              size="small"
          >
            <el-table-column
                type="index"
                label="序号"
                header-align="center"
                align="center"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="brandName"
                label="品牌名"
            >
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="goodsName"
                label="商品名"
            >
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="goodsNum"
                label="商品数量"
            >
            </el-table-column>
          </el-table>
          <!-- </el-scrollbar> -->
        </div>
        <div v-if="declareVersion == 'new'" class="flex item-center" :class="{'flex-between over100': ToFixed(detailsSalesVolume.total, 2)>=bigPriceLimit,'flex-end':ToFixed(detailsSalesVolume.total, 2)<bigPriceLimit}">
          <div class="mb20 mt10" style="fontSize:18px;fontWeight:600;" v-if="ToFixed(detailsSalesVolume.total, 2)>=bigPriceLimit">大额小票</div>
          <div class="flex flex-end mb20 mt10">
            <span style="fontSize:18px;fontWeight:600;"> 总计商品信息：</span>
            <span style="fontSize:18px;fontWeight:600;"  class="mr10 primary">
            {{ detailsSalesVolume.newVersionRewardRuleInfoModelList && detailsSalesVolume.newVersionRewardRuleInfoModelList.length > 0 ? detailsSalesVolume.newVersionRewardRuleInfoModelList.length : 0}}条
          </span>
            <span style="fontSize:18px;fontWeight:600;"> 总计提成：</span>
            <span style="fontSize:18px;fontWeight:600;" class="primary">
            ¥{{ ToFixed(detailsSalesVolume.total, 2) }}</span
            >
          </div>
        </div>
        <div v-if="detailsSalesVolume.rewardRuleInfoModelList.length && declareVersion != 'new'" class="flex item-center" :class="{'flex-between over100': ToFixed(detailsSalesVolume.total, 2)>=bigPriceLimit,'flex-end':ToFixed(detailsSalesVolume.total, 2)<bigPriceLimit}">
          <div class="mb20 mt10" style="fontSize:18px;fontWeight:600;" v-if="ToFixed(detailsSalesVolume.total, 2)>=bigPriceLimit">大额小票</div>
          <div class="flex flex-end mb20 mt10">
            <span style="fontSize:18px;fontWeight:600;"> 总计提成：</span>
            <span style="fontSize:18px;fontWeight:600;" class="primary">
            ¥{{ ToFixed(detailsSalesVolume.total, 2) }}</span
            >
          </div>
        </div>
        <div  v-if="manualReviewSwitch==='close'">
          <div
              class="btn-wrapper flex flex-center mt10 fixed"
              v-if="personAuditState === 'wait' || personAuditState === 'hang'"
          >
            <el-button
                size="small"
                type="primary"
                style="width:180px;borderRadius:6px;white-space: break-spaces;"
                class="refuse-btn"
            >{{ manualReviewSwitchTips }}</el-button
            >
          </div>
        </div>
        <div v-else>
          <div v-if="detailsSalesVolume.declareSn && detailsSalesVolume.declareSn.startsWith('S')">
            <div
                class="btn-wrapper flex flex-center mt10 fixed flex-column fix-btn-wrap new_extremely"
                v-if="personAuditState === 'wait' || personAuditState === 'hang'"
                style="z-index:1000; border: 1px solid #FFB800; box-shadow: 0px 10px 15px 0px rgba(0,0,0,0.03);"
            >
              <div class="extremely_fast_audits">
                <img class="icons" src="https://imgcdn.hemiao100.com/hemiaoBase/redpackageVideoAd/jisushenhe.png">
                <p>极速审核单</p>
              </div>
              <div class="flex flex-center" style="padding: 0 10px 10px 10px;">
                <!-- <el-button
                    v-if="detailsSalesVolume.systemAuditState === 'wait' && detailsSalesVolume.refuseReason"
                    @click="hasReject"
                    size="small"
                    type="primary"
                    style="width:180px;borderRadius:6px;white-space: break-spaces;"
                    class="refuse-btn"
                >{{ detailsSalesVolume.refuseReason }}</el-button
                > -->
                <!-- <el-button
                    v-else-if="riskManagementRefuseReason"
                    @click="riskManagementRefuseReasonClick"
                    size="small"
                    type="primary"
                    style="width:180px;borderRadius:6px;white-space: break-spaces;"
                    class="refuse-btn"
                >{{ riskManagementRefuseReason }}</el-button
                > -->
                <el-button
                    v-if="psList && psList.ps"
                    @click="hasReject"
                    size="small"
                    type="primary"
                    style="width:180px;borderRadius:6px;white-space: break-spaces;line-height: 20px; padding: 0;"
                    class="refuse-btn"
                >小票有PS痕迹<br>处理软件：{{psList.textContain}}</el-button>
                
              
                <template v-else>
                  <el-button
                      v-if="detailsSalesVolume.systemAuditState === 'refuse' && detailsSalesVolume.refuseReason"
                      @click="hasReject"
                      size="small"
                      type="primary"
                      style="width:180px;borderRadius:6px;white-space: break-spaces;"
                      class="refuse-btn"
                  >{{ detailsSalesVolume.refuseReason }}</el-button
                  >

                  <el-button
                      v-else-if="riskManagementRefuseReason"
                      @click="riskManagementRefuseReasonClick"
                      size="small"
                      type="primary"
                      style="width:180px;borderRadius:6px;white-space: break-spaces;"
                      class="refuse-btn"
                  >{{ riskManagementRefuseReason }}</el-button>
                </template>

                  
                <el-button
                    :disabled="detailsSalesVolume.rewardRuleInfoModelList.length === 0"
                    @click="submitRuleForm"
                    size="small"
                    type="success"
                    ref="btn"
                    class="agree-btn"
                    style="width:126px;height:46px;fontSize:20px;borderRadius:6px;"
                >同意申报</el-button>
                <el-button
                    @click="reject"
                    size="small"
                    type="danger"
                    style="width:126px;height:46px;fontSize:20px;borderRadius:6px;"
                    class="refuse-btn"
                >驳回申报</el-button>
                <el-button
                    @click="toBottom"
                    size="small"
                    type="info"
                    style="width:126px;height:46px;fontSize:20px;borderRadius:6px;"
                    class="info"
                >置底</el-button>
                <el-button
                    v-if="detailsSalesVolume.isNewGuider"
                    disabled
                    size="small"
                    type="success"
                    plain
                    style="width:126px;height:46px;fontSize:20px;borderRadius:6px;"
                    class=""
                >新导购</el-button>
              </div>
              <!-- 重复申请单-->
              <div class="duplicate_requisitions" v-if="detailsSalesVolume.relRepeatDeclareSn && detailsSalesVolume.relRepeatDeclareSn !='undefined'">
                <i class="el-icon-warning" style="font-size: 16px; color: #FF7F10;"></i>该申报为“重新申报”单，<span @click="duplicateDeclarationViewing">立即查看》</span>
              </div>
              <div class="bottom-tips" v-if="noticeContent">
                {{noticeContent}}
              </div>
            </div>
          </div>

          <div v-else>
            <div
                class="btn-wrapper flex flex-center mt10 fixed flex-column fix-btn-wrap"
                v-if="personAuditState === 'wait' || personAuditState === 'hang'"
                style="z-index:1000;"
            >
              <div class="flex flex-center">
                <el-button
                    v-if="psList && psList.ps"
                    @click="hasReject"
                    size="small"
                    type="primary"
                    style="width:180px;borderRadius:6px;white-space: break-spaces;line-height: 20px; padding: 0;"
                    class="refuse-btn"
                >小票有PS痕迹<br>处理软件：{{psList.textContain}}</el-button
                >
                
              
                <template v-else>
                  <el-button
                      v-if="detailsSalesVolume.systemAuditState === 'refuse' && detailsSalesVolume.refuseReason"
                      @click="hasReject"
                      size="small"
                      type="primary"
                      style="width:180px;borderRadius:6px;white-space: break-spaces;"
                      class="refuse-btn"
                  >{{ detailsSalesVolume.refuseReason }}</el-button
                  >

                  <el-button
                      v-else-if="riskManagementRefuseReason"
                      @click="riskManagementRefuseReasonClick"
                      size="small"
                      type="primary"
                      style="width:180px;borderRadius:6px;white-space: break-spaces;"
                      class="refuse-btn"
                  >{{ riskManagementRefuseReason }}</el-button>
                </template>




                <el-button
                    :disabled="detailsSalesVolume.rewardRuleInfoModelList.length === 0"
                    @click="submitRuleForm"
                    size="small"
                    type="success"
                    ref="btn"
                    class="agree-btn"
                    style="width:126px;height:46px;fontSize:20px;borderRadius:6px;"
                >同意申报</el-button
                >
                <el-button
                    @click="reject"
                    size="small"
                    type="danger"
                    style="width:126px;height:46px;fontSize:20px;borderRadius:6px;"
                    class="refuse-btn"
                >驳回申报</el-button
                >
                <el-button
                    @click="toBottom"
                    size="small"
                    type="info"
                    style="width:126px;height:46px;fontSize:20px;borderRadius:6px;"
                    class="info"
                >置底</el-button
                >
                <el-button
                    v-if="detailsSalesVolume.isNewGuider"
                    disabled
                    size="small"
                    type="success"
                    plain
                    style="width:126px;height:46px;fontSize:20px;borderRadius:6px;"
                    class=""
                >新导购</el-button
                >
              </div>
               <!-- 重复申请单-->
               <div class="duplicate_requisitions" v-if="detailsSalesVolume.relRepeatDeclareSn && detailsSalesVolume.relRepeatDeclareSn !='undefined'">
                <i class="el-icon-warning" style="font-size: 16px; color: #FF7F10;"></i>该申报为“重新申报”单，<span @click="duplicateDeclarationViewing">立即查看》</span>
              </div>
              <div class="bottom-tips" v-if="noticeContent">
                {{noticeContent}}
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="flex-1 bg ml10 p10">
        <div class="mb10 flex flex-left">
          <el-radio-group v-model="status" size="small">
            <el-radio-button label="receipt" >小票图片</el-radio-button>
            <el-radio-button label="waitList" v-if="sh"
            >待审核列表</el-radio-button
            >
          </el-radio-group>
        </div>

        <div class="crb-content">  
          <div style="height:500px" v-show="status === 'receipt'">
            <div class="flex flex-start item-center">
              <!-- <el-button
                  v-if="personAuditState === 'wait'"
                  @click="open_img(false)"
                  size="small"
                  type="text"
              >
                  修正图片
              </el-button> -->
              <el-tooltip
                  class="item"
                  effect="dark"
                  content="向左旋转"
                  placement="top-start"
              >
                <span
                    @click="rotateImg(-90)"
                    class="pointer hmicon icon-xiangzuoxuanzhuan mr10"
                    style="font-size:20px"
                ></span>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  effect="dark"
                  content="向右旋转"
                  placement="top-start"
              >
                <span
                    @click="rotateImg(90)"
                    class="pointer hmicon icon-xiangyouxuanzhuan mr10"
                    style="font-size:20px"
                ></span>
              </el-tooltip>
            </div>
            <div span="8" class="left" @mousewheel.prevent="rollImg">
              <img
                  :src="detailsSalesVolume.srcList[0]"
                  alt=""
                  class="img"
                  ref="imgDiv"
                  @mousedown="move"
                  v-show="imgDivOpacity"
              />
            </div>
            <!-- <el-scrollbar style="height:100%" class="page-component__scroll">
              <div>
                <el-image
                  lazy
                  style="width:100%;borderRadius:6px;"
                  class="ml10"
                  v-for="(v, i) in detailsSalesVolume.srcList"
                  :key="i"
                  :src="v"
                  :preview-src-list="[detailsSalesVolume.srcList[i]]"
                ></el-image>
              </div>
            </el-scrollbar> -->
          </div>
          <div class="tableHeight" v-show="status === 'waitList'">
            <div class="title">
              待审核
            </div>

            <el-table
                class="mb20"
                border
                :data="declareList.records"
                stripe
                ref="multipleTable"
                @row-click="openDetails"
                max-height="500"
                :row-class-name="tableRowClassName"
                highlight-current-row
                style="width: 100%"
            >
              <el-table-column
                  header-align="center"
                  align="center"
                  type="index"
                  label="序号"
                  width="50"
                  :index="index => index + (currentPage - 1) * pageSize + 1"
              ></el-table-column>
              <el-table-column
                  prop="guiderName"
                  label="导购姓名"
                  header-align="center"
                  align="center"
              ></el-table-column>
              <el-table-column
                  prop="declareSn"
                  label="申报单号"
                  header-align="center"
                  align="center"
              ></el-table-column>
              <el-table-column
                  prop="declareTime"
                  label="申报时间"
                  header-align="center"
                  align="center"
              ></el-table-column>

              <el-table-column
                  prop="redpackageMoney"
                  label="预估收益"
                  header-align="center"
                  align="center"
              >
                <template slot-scope="scope">
                  <span class="primary">￥{{ scope.row.redpackageMoney }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="ocr-pagination hm-pagination">
              <el-pagination
                  background
                  :total="declareList.total"
                  @current-change="paging"
                  @size-change="handleSizeChange"
                  layout="total,sizes,  prev, pager, next"
                  :current-page="currentPage"
                  :pagerCount="5"
              ></el-pagination>
            </div>
          </div>

          

        </div>



      </div>
      <div class="flex-2 bg ml10 p10">
        123
      </div>
    </div>
    <el-dialog
        title="驳回备注"
        :visible.sync="detailsVisible"
        @close="detailsVisible = false"
        custom-class="sales-volumn-dialog"
        width="990px"
    >
      <el-form
          label-width="80px"
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
      >
        <el-form-item label="驳回原因" prop="refuseReason">
          <el-input
              maxlength="100"
              placeholder="请输入驳回原因，可直接选择下方模板"
              size="small"
              style="width: auto"
              :autosize="{ minRows: 4 }"
              type="textarea"
              v-model="ruleForm.refuseReason"
          ></el-input>
        </el-form-item>
        <div class="reject-refuseReason">
          <el-radio-group v-model="rejectReason" @change="switchRejectReason">
            <div v-for="(v, i) in rejectTemp" :key="i">
              <el-radio :label="i">{{ v }}</el-radio>
            </div>
          </el-radio-group>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitReject('ruleForm')" size="small" type="primary"
        >确认</el-button
        >
        <el-button @click="detailsVisible = false" size="small">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="警告提示"
        :visible="dangerVisible"
        @close="dangerVisible = false"
        custom-class="sales-volumn-dialog"
    >
      <div class="danger">
        {{ msg }}
      </div>
      <div class="primary">
        该订单已挂起,请确认供货商余额充足后处理!!
      </div>
    </el-dialog>
    <el-drawer
        size="900px"
        :visible.sync="drawer"
        :direction="direction"
        custom-class="apply-drawer"
        @opened="drawerOpened"
        @close="drawerClose"
    >
      <div slot="title" class="flex item-center">
        <span class="mr20">历史申报</span>
        <div>
          <el-button @click="submitDouble" size="small" type="success" v-if="!haveSameFlag"
          >再次提交</el-button
          >
          <el-button @click="hisRejectSubmitPre" size="small" type="danger">驳回</el-button>
        </div>
      </div>
      <div class="img-wrap">
        <div class="img-item" v-for="(item,index) in repeatOrder" :key="index">
          <img :class="{'img-active': imgActiveIndex==index}" @click="handleClickImg(item, index)" :src="item.declareImg" alt="">
        </div>
      </div>
      <div class="p20" v-if="msg">
        
        {{ msg }}
        <!-- <el-button @click="submitDouble" size="small" type="success" v-if="!haveSameFlag"
        >再次提交</el-button
        >
        <el-button @click="hisRejectSubmitPre" size="small" type="danger">驳回</el-button> -->
        <!--        <el-button v-if="errorBillAuditClick"  @click="continueShowErrorAuditDialog" size="small" type="success">继续转给供货商人员审批</el-button>-->
      </div>
      <div class="overissue" v-if="(detailsSalesVolume.refuseReason && detailsSalesVolume.refuseReason.includes('资金超发')) || ( riskManagementRefuseReason && riskManagementRefuseReason.includes('资金超发'))">
        当前申报单有资金超发风险!
      </div>
      <div style="padding:0 20px;">
        <el-scrollbar
            ref="scrollMenuRef"
            wrap-style="height: calc(100vh - 200px);"
            class="page-component__scroll scroll-menu-ref"
        >
          <div v-if="overissueList && overissueList.length && (detailsSalesVolume.refuseReason && detailsSalesVolume.refuseReason.includes('资金超发') || ( riskManagementRefuseReason && riskManagementRefuseReason.includes('资金超发')) )">
            <div class="overissue-list" v-for="(item,index) in overissueList" :key="index">
              <div class="table-header pointer" @click="evenDetails(item)">
                <div>{{ item.rewardName }}({{ item.rewardStartDate }}至{{ item.rewardEndDate }})</div>
              </div>
              <div class="table-body">
                <div class="flex goods-item">
                  <div class="flex-1 text-center">商品</div>
                  <div class="flex-1 text-center border-left">历史申报数量</div>
                </div>
                <div class="flex goods-item" v-for="(v,i) in item.billDetailsBoListNew" :key="i">
                  <div class="flex-1 text-center">{{ v.goodsName }}</div>
                  <div class="flex-1 text-center border-left">{{ v.goodsNum }}</div>
                </div>
              </div>
            </div>
          </div>
          <div
              v-for="(o, index) in repeatOrder"
              :key="index"
              style="marginBottom:30px"
              :class="`repeatOrder${index}`"
          >
            <div class="flex flex-between" style="position:relative">
              <div class="flex-1">
                <div
                    class="history danger"
                    v-if="o.personAuditState === 'cancel'"
                >
                  审核状态：已取消
                </div>
                <div
                    class="history success"
                    v-else-if="o.personAuditState === 'agree'"
                >
                  审核状态：已通过
                </div>
                <div
                    class="history gray"
                    v-else-if="o.personAuditState === 'hang'"
                >
                  审核状态：已挂起
                </div>
                <div
                    class="history gray"
                    v-else-if="o.personAuditState === 'wait'"
                >
                  审核状态：待审核
                </div>
                <div :class="['history', o.guiderName==detailsSalesVolume.guiderName && 'primary']">导购姓名：{{ o.guiderName }}</div>
                <div :class="['history', o.shopName==detailsSalesVolume.shopName && 'primary']">所属门店：{{ o.shopName }}</div>
                <div :class="['history', o.declareSn==detailsSalesVolume.declareSn && 'primary']">单号：{{ o.declareSn }}</div>
                <div :class="['history', o.receiptSn==detailsSalesVolume.receiptSn && 'primary']">小票号：{{ o.receiptSn }}</div>
                <div class="history">申报时间：{{ o.declareTime }}</div>
                <div
                    class="history"
                    v-if="o.personAuditTime"
                >
                  审核时间：{{ o.personAuditTime }}
                </div>
                <div
                    class="history gray"
                    v-else
                >
                  审核时间：-
                </div>
                <div class="history">审核时间：{{ o.personAuditTime }}</div>
                <div  :class="['history', o.receiptDateStr==detailsSalesVolume.receiptDateStr && 'primary']">识别时间：{{ o.receiptDateStr }}</div>
              </div>
              <div class="flex-1">
                <div class="flex flex-end item-center mt10 mr20">
                  <div v-if="o.sameFlag" class="primary">同张小票
                    <el-tooltip
                        class="tooltip"
                        effect="light"
                        placement="bottom"
                    >
                      <div slot="content">
                        <div>1.选择 [同张小票] 后，导购会在 [驳货] 的理由中看到同张小票的单号并且可查看明细</div>
                        <div style="margin-top: 3px">2.点击 [再次提交] 时无需选择 [同张小票] ，因为仅 [驳回] 时点击按钮 [同张小票] 才会对导购展示同张小票的单号</div>
                      </div>
                      <i class="el-icon-question" style="font-size: 16px"></i>
                    </el-tooltip>
                  </div>
                  <div v-else>勾选后可标记相同小票
                    <el-tooltip
                        class="tooltip"
                        effect="light"
                        placement="bottom"
                    >
                      <div slot="content">
                        <div>1.选择 [同张小票] 后，导购会在 [驳货] 的理由中看到同张小票的单号并且可查看明细</div>
                        <div>2.点击 [再次提交] 时无需选择 [同张小票] ，因为仅 [驳回] 时点击按钮 [同张小票] 才会对导购展示同张小票的单号</div>
                      </div>
                      <i class="el-icon-question" style="font-size: 16px"></i>
                    </el-tooltip>
                  </div>
                  <el-switch
                      class="ml10"
                      v-model="o.sameFlag"
                      @change="switchChange"
                  >
                  </el-switch>
                </div>
                <div class="flex flex-center item-center mt40">
                  <el-image
                      style="width:180px;borderRadius:6px;height: 252px;"
                      class="ml10"
                      :src="o.declareImg"
                      :preview-src-list="[o.declareImg]"
                  ></el-image>
                </div>
              </div>
              <img
                style="width:160px;height:160px; position:absolute; left:220px; top:80px;"
                v-if="o.refundPic"
                :src="o.refundPic"
              />
            </div>
            <div class="mt20">
              <div class="title">
                商品
              </div>
              <div class="flex">
                <div class="goods-wrap mr10">
                  <div class="top-title">历史申报商品</div>
                  <div
                      class="modal-table"
                      v-for="(v, i) in o.rewardRuleInfoModelList"
                      :key="i"
                  >
                    <div class="table-header flex flex-bteween">
                      <div>{{ v.rewardName }}</div>
                      <div class="flex-1 primary flex flex-end">
                        {{ v.rewardMoney }}元
                      </div>
                    </div>
                    <div
                        class="table-body flex item-center"
                        v-for="(j, k) in v.billDetailsBoList"
                        :key="k"
                    >
                      <el-tooltip
                          placement="top-start"
                          :content="j.goodsName"
                          effect="dark"
                      >
                        <div class="text-left flex-2 goods-name">
                          <span :class="isSame(j.goodsName, detailsSalesVolume.successList)">{{ j.goodsName }}</span>
                          <span class="refundSn-tips" v-if="j.refundSn">已退单</span>
                        </div>
                      </el-tooltip>
                      <div class="flex-1 flex flex-column goods-name" v-if="j.refundSn">
                        <div>退款单号:</div>
                        <div>{{ j.refundSn }}</div>
                      </div>
                      <div class="flex-1 goods-name">数量:{{ j.goodsNum }}</div>
                      <el-tooltip
                          placement="top-start"
                          content="条码"
                          effect="dark"
                      >
                        <div class="flex-1 goods-name" :class="isSame2(j.goodsBarcode, detailsSalesVolume.successList)">{{ j.goodsBarcode }}</div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="goods-wrap">
                  <div class="top-title">此次申报商品</div>
                  <div
                      class="modal-table"
                      v-for="(v, i) in o.successList"
                      :key="i"
                  >
                    <div class="table-header flex flex-bteween">
                      <div>{{ v.rewardName }}</div>
                      <div class="flex-1 primary flex flex-end">
                        {{ v.rewardMoney }}元
                      </div>
                    </div>
                    <div
                        class="table-body flex item-center"
                        v-for="(j, k) in v.billDetailsBoList"
                        :key="k"
                    >
                      <el-tooltip
                          placement="top-start"
                          :content="j.goodsName"
                          effect="dark"
                      >
                        <div class="text-left flex-2 goods-name">
                          <span :class="isSame(j.goodsName, o.rewardRuleInfoModelList)">{{ j.goodsName }}</span>
                          <span class="refundSn-tips" v-if="j.refundSn">已退单</span>
                        </div>
                      </el-tooltip>
                      <div class="flex-1 flex flex-column goods-name" v-if="j.refundSn">
                        <div>退款单号:</div>
                        <div>{{ j.refundSn }}</div>
                      </div>
                      <div class="flex-1 goods-name">数量:{{ j.goodsNum }}</div>
                      <el-tooltip
                          placement="top-start"
                          content="条码"
                          effect="dark"
                      >
                        <div class="flex-1 goods-name" :class="isSame2(j.goodsBarcode, o.rewardRuleInfoModelList)">{{ j.goodsBarcode }}</div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                </div>
              </div>
          </div>
        </el-scrollbar>
      </div>
    </el-drawer>

     <!-- 重复申报 -->
     <el-drawer
        size="900px"
        :visible.sync="drawerRepeat"
        :direction="directionRepeat"
        custom-class="apply-drawer"
        @opened="drawerOpenedRepeat"
        @close="drawerCloseRepeat"
        class="duplicate_declarations"
    >
      <h1>重新申报单</h1>
      <div style="padding:0 20px;">
        <el-scrollbar
            ref="scrollMenuRef"
            wrap-style="height: calc(100vh - 90px);"
            class="page-component__scroll scroll-menu-ref"
        >
          <div
            style="marginBottom:30px"
          >
            <div class="flex flex-between" style="position:relative">
              <div class="flex-1">
                <div
                    class="history danger"
                    v-if="historicalDeclaredCommodities.personAuditState === 'cancel'"
                >
                  审核状态：已取消
                </div>
                <div
                    class="history success"
                    v-else-if="historicalDeclaredCommodities.personAuditState === 'agree'"
                >
                  审核状态：已通过
                </div>
                <div
                    class="history success"
                    v-else-if="historicalDeclaredCommodities.personAuditState === 'refuse'"
                >
                  审核状态：已驳回
                </div>
                <div
                    class="history gray"
                    v-else-if="historicalDeclaredCommodities.personAuditState === 'hang'"
                >
                  审核状态：已挂起
                </div>
                <div
                    class="history danger"
                    v-else-if="historicalDeclaredCommodities.personAuditState === 'wait'"
                >
                  审核状态：待审核
                </div>
                <div :class="['history']">导购姓名：{{ historicalDeclaredCommodities.guiderName }}</div>
                <div :class="['history']">所属门店：{{ historicalDeclaredCommodities.shopName }}</div>
                <div :class="['history']">单号：{{ historicalDeclaredCommodities.declareSn }}</div>
                <div :class="['history']">小票号：{{ historicalDeclaredCommodities.receiptSn }}</div>
                <div :class="['history']">识别时间：{{ historicalDeclaredCommodities.receiptDateStr }}</div>
                <div :class="['history']">驳回原因：{{ historicalDeclaredCommodities.refuseReason }}</div>
              </div>
              <div class="flex-1">
                <div class="flex flex-center item-center mt40">
                  <el-image
                      style="width:180px;borderRadius:6px;height: 252px;"
                      class="ml10"
                      :src="detailsSalesVolume.srcList[0]"
                      :preview-src-list="[detailsSalesVolume.srcList[0]]"
                  ></el-image>
                </div>
              </div>
              <!-- <img
                style="width:160px;height:160px; position:absolute; left:220px; top:80px;"
                v-if="refundPic"
                :src="refundPic"
              /> -->
            </div>
            <div class="mt20">
              <div class="title">
                商品
              </div>
              <div class="flex">
                <div class="goods-wrap mr10" v-if="historicalDeclaredCommodities && historicalDeclaredCommodities.rewardRuleInfoModelList">
                  <div class="top-title">历史申报商品</div>
                  <div
                      class="modal-table"
                      v-for="(v, i) in historicalDeclaredCommodities.rewardRuleInfoModelList"
                      :key="i"
                  >
                    <div class="table-header flex flex-bteween">
                      <div>{{ v.rewardName }}</div>
                      <div class="flex-1 primary flex flex-end">
                        {{ v.rewardMoney }}元
                      </div>
                    </div>
                    <div
                        class="table-body flex item-center"
                        v-for="(j, k) in v.billDetailsBoList"
                        :key="k"
                    >
                      <el-tooltip
                          placement="top-start"
                          :content="j.goodsName"
                          effect="dark"
                      >
                        <div class="text-left flex-2 goods-name">
                          <span :class="isSameRepeat(j.goodsName, 'goodsName', detailsSalesVolume.rewardRuleInfoModelList)">{{ j.goodsName }}</span>
                        </div>
                      </el-tooltip>
                      <div class="flex-1 goods-name" :class="isSameRepeat(j.goodsNum, 'goodsNum',detailsSalesVolume.rewardRuleInfoModelList)">数量:{{ j.goodsNum }}</div>
                      <el-tooltip
                          placement="top-start"
                          content="条码"
                          effect="dark"
                      >
                        <div class="flex-1 goods-name" :class="isSameRepeat(j.goodsBarcode, 'goodsBarcode',detailsSalesVolume.rewardRuleInfoModelList)">{{ j.goodsBarcode }}</div>
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                <div class="goods-wrap">
                  <div class="top-title">此次申报商品</div>
                  <div
                      class="modal-table"
                      v-for="(v, i) in detailsSalesVolume.rewardRuleInfoModelList"
                      :key="i"
                  >
                    <div class="table-header flex flex-bteween">
                      <div>{{ v.rewardName }}</div>
                      <div class="flex-1 primary flex flex-end">
                        {{ v.rewardMoney }}元
                      </div>
                    </div>
                    <div
                        class="table-body flex item-center"
                        v-for="(j, k) in v.billDetailsBoList"
                        :key="k"
                    >
                      <el-tooltip
                          placement="top-start"
                          :content="j.goodsName"
                          effect="dark"
                          
                      >
                        <div class="text-left flex-2 goods-name">
                          <span :class="isSameRepeat(j.goodsName, 'goodsName', historicalDeclaredCommodities.rewardRuleInfoModelList)">{{ j.goodsName }}</span>
                        </div>
                      </el-tooltip>
                      <div class="flex-1 goods-name" :class="isSameRepeat(j.goodsNum, 'goodsNum', historicalDeclaredCommodities.rewardRuleInfoModelList)">数量:{{ j.goodsNum }}</div>
                      <el-tooltip
                          placement="top-start"
                          content="条码"
                          effect="dark"
                      >
                        <div class="flex-1 goods-name" :class="isSameRepeat(j.goodsBarcode, 'goodsBarcode', historicalDeclaredCommodities.rewardRuleInfoModelList)">{{ j.goodsBarcode }}</div>
                        <!-- <div class="flex-1 goods-name" :class="isSame2(j.goodsBarcode, o.rewardRuleInfoModelList)">{{ j.goodsBarcode }}</div> -->
                      </el-tooltip>
                    </div>
                  </div>
                </div>
                </div>
              
              
              
              </div>
          </div>
        </el-scrollbar>
      </div>
    </el-drawer>

    <el-drawer
        title="活动详情"
        :visible.sync="eventDetailsDrawer"
        direction="rtl"
        size="600px"
    >
      <div style="padding:0 20px">
        <div>
          <el-tag
              effect="plain"
              size="small"
              class="blue"
              v-if="row.ruleInfo.rewardMode === 'fixed'"
              style="borderColor:#56abee;"
          >
            普通活动
          </el-tag>
          <el-tag
              effect="plain"
              size="small"
              class="blue"
              v-if="row.ruleInfo.rewardMode === 'radio'"
              style="borderColor:#56abee;"
          >
            冲刺活动
          </el-tag>
          <el-tag
              effect="plain"
              size="small"
              class="blue"
              v-if="row.ruleInfo.rewardMode === 'sub'"
              style="borderColor:#56abee;"
          >
            差异活动
          </el-tag>
          <el-tag
              effect="plain"
              size="small"
              class="blue"
              v-if="row.ruleInfo.rewardMode === 'collocation'"
              style="borderColor:#56abee;"
          >
            搭配活动
          </el-tag>
          <el-tag
              effect="plain"
              size="small"
              type="info"
              v-if="row.ruleInfo.rewardMode === 'fixed' && row.ruleInfo.upperLimitSwitch"
              style="borderColor:#909399;"
          >
            最高奖励匹配
          </el-tag>
          {{ row.ruleInfo.rewardName }}
        </div>
        <!-- <div class="history">活动类型：{{ row.declareSn }}</div> -->
        <div class="history" v-if="row.ruleInfo.dateConfigMode === 'general'">
          活动时段：{{ row.ruleInfo.rewardStartDate }}至{{
            row.ruleInfo.rewardEndDate
          }}
        </div>
        <div
            class="history flex flex-wrap"
            v-if="row.ruleInfo.dateConfigMode === 'special'"
        >
          活动时段：
          <div v-if="row.ruleInfo.dateType === 'date'">
            {{ row.ruleInfo.rewardStartDate }}至{{
              row.ruleInfo.rewardEndDate
            }}的每{{ row.ruleInfo.dateValue }}天
          </div>
          <div v-if="row.ruleInfo.dateType === 'week'">
            {{ row.ruleInfo.rewardStartDate }}至{{
              row.ruleInfo.rewardEndDate
            }}的
            <span v-for="(v, i) in row.ruleInfo.dateValue" :key="i">
              {{ i === 0 ? "" : "," }}每周{{ v }}</span
            >
          </div>
          <div v-if="row.ruleInfo.dateType === 'month'">
            {{ row.ruleInfo.rewardStartDate }}至{{
              row.ruleInfo.rewardEndDate
            }}的
            <span v-for="(v, i) in row.ruleInfo.dateValue" :key="i">
              {{ i === 0 ? "" : "," }}每月{{ v }}号</span
            >
          </div>
        </div>
        <!-- <div class="history">
          活动规则：参与该活动的商品每满
          <span class="blue">{{ row.ruleInfo.rewardNumberLimit }}</span>
          件为一组计算活动
        </div> -->
        <div class="history">
          活动下线：到期<span class="blue">{{
            row.ruleInfo.autoOfflineDaysLimt
          }}</span
        >天后自动下线
        </div>
        <div class="history" v-if="supplierName">
          供货商名称:{{supplierName}}
        </div>
        <!-- <div class="history">
          基础提成：
          <span v-if="row.ruleInfo.rewardMode === 'fixed'" class="primary">
            ¥{{ row.ruleInfo.rewardValue }}</span
          >
          <span v-if="row.ruleInfo.rewardMode === 'radio'">
            {{ row.ruleInfo.rewardValue }}%</span
          >
        </div> -->
        <div v-if="row.ruleInfo.rewardMode === 'radio'">
          <div class="history">
            收益金额：{{ guiderRewardTotalMoney.toFixed(2) }}元
          </div>
          <div class="history">
            申报件数：{{ guiderRewardTotalNum.toFixed(0) }}件
          </div>
        </div>
        <div style="height:600px">
          <el-scrollbar style="height:100%" class="page-component__scroll">
            <!-- <template v-if="row.ruleInfo.rewardMode === 'collocation'"> -->
            <template v-if="row.ruleInfo.rewardMode === 'collocation'">
              <div>
                <div>
                  <div class="title">
                    搭配规则：
                  </div>
                  <div>
                    <div class="group-wrap">
                      <div class="group-item mb20" v-for="(item, pInd) in rewardRuleRelModelList" :key="pInd">
                        <span v-if="item.ruleName">{{item.ruleName}}：</span>
                        <span class="group-add-item" v-for="(group, cInd) in item.rewardRuleRelModelComposeModel" :key="cInd">
                            <span v-if="cInd > 0" class="ml10 mr10">+</span>
                            <span class="blue">{{group.composeName}}<span v-if="group.goodsUpperLimit!==''">（限制数量：{{group.goodsUpperLimit}}）</span><span v-if="group.composeAllocateReward!==''">（{{group.composeAllocateReward}}元）</span></span>
                        </span>
                        <span class="ml10 mr10">=</span>
                        <span class="">
                            <span class="blue">{{item.rewardValue}}</span>元
                        </span>
                      </div>
                  </div>
                  </div>
                </div>
                <div class="title">
                  适用商品：
                </div>
                <div class="add-group">
                  <!-- {{rewardRuleGoodsComposeModelList}} -->
                  <!-- rewardRuleRelModelList -->
                        <div class="add-wrap" v-for="item in rewardRuleGoodsComposeModelList" :key="item.id">
                            <div class="header">
                                <span>{{ item.composeName }}</span>
                                <span>限制数量：{{item.goodsUpperLimit}}</span>
                            </div>
                            <el-table :data="item.goodsComposeCollocationInfoModelList" border stripe height="266px" :header-cell-style="{background: '#F7F7F7', color: '#222222', fontSize: '14px'}">
                                <el-table-column label="商品品牌" prop="brandName" align="center"></el-table-column>
                                <el-table-column label="商品名称" prop="goodsName" align="center"></el-table-column>
                                <el-table-column label="商品条码" prop="goodsBarcode" align="center"></el-table-column>
                            </el-table>
                            <!-- <div class="footer">
                                <el-button :disabled="isDetail" @click="handleAddGroupList(item, 'edit', index)" type="text">+编辑商品</el-button>
                                <el-button @click="handleAddGroupList(item, 'detail', index)" type="text">商品预览</el-button>
                            </div> -->
                        </div>
                    </div>
              </div>
            </template>
            <template v-else>
              <div class="mt20">
                <div class="title">
                  <span>活动规则：
                    <span v-if="row.ruleInfo.rewardMode === 'fixed' && row.ruleInfo.distributionType =='group'">普通活动(按组奖励)</span>
                    <span v-if="row.ruleInfo.rewardMode === 'fixed' && row.ruleInfo.distributionType =='item'">普通活动(按件奖励)</span>
                  </span>
                  <p v-if="row.ruleInfo.upperLimitSwitch" class="rule-upperLimitSwitch">
            <span >根据申报数量按照规则门槛匹配一次，当前活动最高奖励</span>
          <span class="money">{{row.ruleInfo.ruleRelModelList[row.ruleInfo.ruleRelModelList.length - 1]['rewardValue']}}</span>
          <span>元</span>
          </p>
                </div>

                <el-table
                    :data="row.ruleInfo.ruleRelModelList"
                    style="width: 100%"
                    stripe
                    size="small"
                    border
                    v-if="row.ruleInfo.rewardMode === 'fixed' && row.ruleInfo.distributionType === 'group'"
                >
                  <el-table-column type="index" label="序号"></el-table-column>
                  <el-table-column
                      header-align="center"
                      align="center"
                      label="每组件数"
                      prop="rewardNumberLimit"
                  >
                    <template slot-scope="scope">
                      每满{{ scope.row.rewardNumberLimit }}件为一组
                    </template>
                  </el-table-column>
                  <el-table-column
                      header-align="center"
                      align="center"
                      label="每组奖励"
                      prop="rewardValue"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.rewardValue }}元
                    </template>
                  </el-table-column>


                  <el-table-column
                      header-align="center"
                      v-if="row.ruleInfo.requiredGoodsMode == 'yes'"
                      align="center"
                      label="限制数量"
                      prop="rewardRequiredNum"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.rewardRequiredNum }}件
                    </template>
                  </el-table-column>


                </el-table>
                  <div v-if="ruleForm.rewardMode === 'fixed' && ruleForm.distributionType == 'item'">按件奖励规则：以申报件数匹配最高等级X单件金额</div>
                  <el-table
                    :data="row.ruleInfo.ruleRelModelList"
                    style="width: 100%"
                    stripe
                    size="small"
                    border
                    v-if="row.ruleInfo.rewardMode === 'fixed' && row.ruleInfo.distributionType === 'item'"
                >
                  <el-table-column type="index" label="序号"></el-table-column>
                  <el-table-column
                      header-align="center"
                      align="center"
                      label="数量"
                      prop="rewardNumberLimit"
                  >
                    <template slot-scope="scope">
                     当数量大于等于{{ scope.row.rewardNumberLimit }}件时
                    </template>
                  </el-table-column>
                  <el-table-column
                      header-align="center"
                      align="center"
                      label="每件奖励"
                      prop="rewardValue"
                  >
                    <template slot-scope="scope">
                      每件按{{ scope.row.rewardValue }}元发放
                    </template>
                  </el-table-column>
                </el-table>
         <div class="flex-1 flex item-center" v-if="row.ruleInfo.rewardMode === 'fixed' && row.ruleInfo.distributionType === 'item'">
            奖励上限(元)
              <el-input
                readonly
                size="small"
                style="width: 180px;margin-left:10px"
                v-model="row.ruleInfo.maxDistributionAmount"
              ></el-input>
          </div>
                <el-table
                    v-if="row.ruleInfo.rewardMode === 'radio'"
                    ref="roleTable"
                    :data="row.ruleInfo.ruleRelModelList"
                    style="width: 500px"
                    :row-class-name="tableRowClassNameCheck"
                    border
                    id="table"
                    size="small"
                >
                  <el-table-column type="index" label="序号"></el-table-column>
                  <el-table-column
                      header-align="center"
                      align="center"
                      label="冲刺门槛"
                      prop="rewardNumberLimit"
                  >
                    <template slot-scope="scope">
                      {{ scope.row.rewardNumberLimit }}件
                    </template>
                  </el-table-column>
                  <el-table-column
                      header-align="center"
                      align="center"
                      label="额外奖励"
                      prop="rewardValue"
                  >
                    <template slot-scope="scope">
                      每件额外奖励{{ scope.row.rewardValue }}元
                    </template>
                  </el-table-column>
                </el-table>
                <el-table
                    v-if="row.ruleInfo.rewardMode === 'sub'"
                    ref="roleTable"
                    :data="row.ruleInfo.ruleRelModelList"
                    style="width:100%"
                    :row-class-name="tableRowClassNameCheck"
                    border
                    id="table"
                    size="small"
                    :show-header="false"
                >
                  <el-table-column
                      type="index"
                      label="序号"
                      header-align="center"
                      align="center"
                  ></el-table-column>
                  <el-table-column
                      header-align="center"
                      align="start"
                      label="每组件数"
                      prop="rewardNumberLimit"
                  >
                    <template slot-scope="scope">
                      买
                      {{ scope.row.rewardNumberLimit }}
                      件, 送
                      {{ scope.row.rewardSubNum }}
                      件,{{
                        new Number(scope.row.rewardNumberLimit) +
                        new Number(scope.row.rewardSubNum)
                      }}件为一组，发放
                      {{ scope.row.rewardNumberLimit }}件商品的单件奖励, 每组奖励
                      {{ scope.row.rewardValue }}
                      元
                    </template>
                  </el-table-column>
                </el-table>
              </div>
              <div class="mt20">
                <div class="title">
                  活动商品
                </div>

                <el-table
                    :data="row.goodsList"
                    style="width: 100%"
                    stripe
                    size="small"
                    border
                >
                  <el-table-column
                      header-align="center"
                      align="center"
                      type="index"
                      label="序号"
                      width="50"
                  ></el-table-column>
                  <el-table-column
                      header-align="center"
                      align="center"
                      label="商品图"
                      prop="goodsPic"
                  >
                    <template slot-scope="scope">
                      <el-image
                          style="width: 100px; height: 100px"
                          :src="scope.row.goodsPic"
                          :preview-src-list="[scope.row.goodsPic]"
                      >
                      </el-image>
                    </template>
                  </el-table-column>
                  <el-table-column
                      header-align="center"
                      align="center"
                      label="商品名称"
                      prop="goodsName"
                  ></el-table-column>
                  <el-table-column
                      header-align="center"
                      align="center"
                      label="条码"
                      prop="goodsBarcode"
                  ></el-table-column>
                  <el-table-column
                      header-align="center"
                      align="center"
                      prop="rewardBaseMoney"
                      label="单件奖励"
                      v-if="row.ruleInfo.rewardMode === 'sub'"
                  >
                  </el-table-column>
                </el-table>
              </div>
            </template>
          </el-scrollbar>
        </div>
      </div>
    </el-drawer>
    <el-dialog
        title="提示"
        :visible="tishiVisible"
        @close="tishiVisible = false"
    >
      <div class="primary flex flex-center">
        {{ msg }}
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitDouble" size="small" type="primary"
        >继续通过</el-button
        >
        <el-button @click="tishiVisible = false" size="small">关闭提示</el-button>
      </span>
    </el-dialog>
    <el-dialog
        title="修正图片"
        :visible="receiptsVisible"
        @close="receiptsVisible = false"
        width="1200px"
    >
      <div>
        <!-- <el-button  id="rotateBtn2" @click="rotate_btn2(rotate_number)" size="small" type="primary"
          >左旋转</el-button
        >
        <el-button  id="rotateBtn" @click="rotate_btn(rotate_number)"  size="small" type="primary"
          >右旋转</el-button
        > -->
        <div class="flex flex-center">
          <el-tooltip
              class="item"
              effect="dark"
              content="向左旋转"
              placement="top-start"
          >
            <span
                class="pointer hmicon icon-xiangzuoxuanzhuan mr10"
                style="fontSize:30px"
                @click="rotate_btn2(rotate_number)"
            ></span>
          </el-tooltip>
          <el-tooltip
              class="item"
              effect="dark"
              content="向右旋转"
              placement="top-start"
          >
            <span
                class="pointer hmicon icon-xiangyouxuanzhuan mr10"
                style="fontSize:30px"
                @click="rotate_btn(rotate_number)"
            ></span>
          </el-tooltip>
          <el-tooltip
              class="item"
              effect="dark"
              content="重新识别图片"
              placement="top-start"
          >
            <span
                class="pointer hmicon icon-shangchuantupian mr10"
                style="fontSize:30px"
                @click="canvas_submit"
            ></span>
          </el-tooltip>
          <el-tooltip
              class="item"
              effect="dark"
              content="更换图片"
              placement="top-start"
          >
            <el-upload
                class="flex"
                ref="eluploadMainPic"
                :data="{ fileDir: 'mall' }"
                :headers="{ 'X-Access-Token': $token }"
                :action="$uploadUrl"
                :onSuccess="uploadMainPicSucc"
                :beforeUpload="beforeUpload"
                :show-file-list="uploadShow"
            >
              <span
                  class="pointer hmicon icon-genghuantupian mr10"
                  style="fontSize:28px"
              ></span>
            </el-upload>
          </el-tooltip>
        </div>

        <!-- <el-button id="rotateBtn3" @click="canvas_submit" size="small" type="primary"
          >确认</el-button
        > -->
        <div
            id="imgDiv"
            style=" position:relative;  width: 100%;padding: 20px;text-align: center; box-sizing: border-box;"
        >
          <canvas v-show="is_canvas" id="myCanvas" style="background:#fff; width: 100%;">
            您的浏览器不支持 HTML5 canvas 标签。
          </canvas>
          <div
              v-show="is_canvas_operate"
              id="canvas_operate"
              style="position: absolute;top:0;left: 0; height: 30px; background: #fff;"
          >
            666
          </div>
        </div>
        <div v-if="saveimg">
          <img :src="saveimg" alt="" />
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :title="title"
        :visible="selectTempVisible"
        @close="tempClose"
        width="1200px"
    >
      <el-radio-group
          class="mb20"
          size="small"
          v-model="selectTempType"
          @change="selectTempTypeChange"
          v-if="isShowSelectTempType"
      >
        <el-radio-button label="receiptDate">小票日期</el-radio-button>
        <el-radio-button label="receiptSnDate">小票号日期</el-radio-button>
      </el-radio-group>
      <div class="mb10 flex flex-between">
        <el-button size="small" type="primary" @click="add">
          新增模板
        </el-button>
        <div>
          <el-input
              clearable
              style="width:250px"
              v-model.trim="searchCondition.templateName"
              placeholder="请输入模板名称"
              size="small"
              class="ipt mr10"
          ></el-input>
          <el-input
              clearable
              v-model.trim="searchCondition.templateLength"
              placeholder="请输入模板长度"
              size="small"
              class="ipt mr10"
              v-if="selectTempType !== 'receiptSnDate'"
          ></el-input>
          <el-button type="primary" size="small" @click="searchTemplate">查询</el-button>
        </div>
      </div>
      <div>
        <div class="tips mb10">提示：点击表格行即可选择</div>
        <el-table
            stripe
            border
            ref="singleTable"
            :data="tempList"
            style="width: 100%"
            id="table"
            size="small"
            :max-height="500"
            highlight-current-row
            @current-change="handleCurrentChange"
        >
          <!-- <el-table-column
        label="选择"
        width="50"
        header-align="center"
        align="center">
        <template slot-scope="scope">
          <el-radio :label="scope.row.id" v-model="radioId">&nbsp;</el-radio>
        </template>
      </el-table-column> -->
          <!-- <el-table-column
        type="index"
        label="序号"
        header-align="center"
        align="center"
      ></el-table-column> -->
          <el-table-column
              header-align="center"
              align="center"
              prop="templateName"
              label="模板名称"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="templateType"
              label="模板类型"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.templateType === 'receiptDate'">
                小票日期
              </div>
              <div v-else-if="scope.row.templateType === 'receiptSn'">
                小票号
              </div>
              <div v-else-if="scope.row.templateType === 'receiptDateStr'">
                小票时间戳
              </div>
              <div v-else-if="scope.row.templateType === 'shopName'">
                门店名称
              </div>
              <div v-else-if="scope.row.templateType === 'number'">
                商品数量
              </div>
              <div v-else-if="scope.row.templateType === 'receiptRepeat'">
                小票去重模板管理
              </div>
              <div v-else-if="scope.row.templateType === 'receiptSnDate'">
                小票号日期
              </div>
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="goodsNum"
              label="是否商户模板"
          >
            <template slot-scope="scope">
              {{ scope.row.bindStoreNum > 0 ? "是" : "否" }}
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="bindStoreNum"
              label="授权商家数量"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="bindShopNum"
              label="授权门店数量"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="description"
              label="模板描述"
          ></el-table-column>

          <el-table-column
              header-align="center"
              align="center"
              prop="storeCode"
              label="小票示例"
          >
            <template slot-scope="scope">
              <el-image
                  style="width: 100px; height: 100px"
                  :src="scope.row.templateImg"
                  :preview-src-list="[scope.row.templateImg]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="enableState"
              label="是否启用"
          >
            <template slot-scope="scope">
              <div
                  :class="scope.row.enableState === 'yes' ? 'success' : 'danger'"
              >
                {{ scope.row.enableState === "yes" ? "启用" : "禁用" }}
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination mb20">
          <el-pagination
              background
              :total="tempTotal"
              @current-change="tempPaging"
              @size-change="tempHandleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="tempCurrentPage"
              :page-size="tempPageSize"
          ></el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center mt20 item-center">
        <el-switch
            v-if="templateType === 'receiptSn'"
            v-model="receiptSnAutoCheckTemplateStarus"
            @change="editAutoCheckStatus()"
            style="margin-right: 10px"
            active-text="自动检测模板变更"
            inactive-text="不检测模板变更">
        </el-switch>
        <el-switch
            v-if="templateType === 'receiptDateStr'"
            v-model="receiptDateStrAutoCheckTemplateStarus"
            @change="editAutoCheckStatus()"
            style="margin-right: 10px"
            active-text="自动检测模板变更"
            inactive-text="不检测模板变更">
        </el-switch>
        <el-button @click="selectRow('shop')" size="small" type="primary">
          设置为门店模板</el-button
        >
        <el-button @click="selectRow('both')" size="small" type="primary">
          设置为门店模板同时设置为商户模板</el-button
        >
        <el-button size="small" type="info" @click="tempClose"
        >暂不处理</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
        title="填写黑白名单原因"
        :visible="blackGuiderVisible"
        @close="blackReasonClose"
        width="30%"
    >
      <div class="mb10 flex flex-between item-center">
        <el-input
            clearable
            v-model.trim="refuseReason"
            placeholder="请填写黑白名单原因"
            style="width: 360px;"
            type="textarea"
            :rows="6"
        ></el-input>
        <el-button @click="isWhiteChange" size="small" type="primary" style="width:80px;height: 30px;">
          确 定</el-button
        >
      </div>
      <div>
        <el-upload
            class="flex"
            ref="eluploadMainPic"
            :data="{ fileDir: 'mall' }"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadUrl"
            :onSuccess="uploadMainPicSucc2"
            :beforeUpload="beforeUpload"
            :show-file-list="uploadShow"
        >
          <div class="flex upload-upload-btn">
            <div
                class="btn flex flex-column flex-center open-file"
                @click="toggleShowRefuseReasonVoucher"
                v-if="!refuseReasonVoucher"
            >
              <div class="add-wrapper flex flex-center">
                <span class="hmicon icon-hao pointer"></span>
              </div>
              <span>上传凭证</span>
            </div>
            <div v-if="refuseReasonVoucher" class="priviewbgp2 mr10 flex item-end">
              <img :src="refuseReasonVoucher" alt="背景图" />
              <div class="opreat-wrapper flex item-center flex-center">
                <el-button type="text" @click="deleteShowRefuseReasonVoucher"
                >删除</el-button
                >
              </div>
            </div>
          </div>
        </el-upload>
      </div>

    </el-dialog>

    <hm-ocr-template-details
        v-if="detailsTempVisible"
        :dialogVisible="detailsTempVisible"
        :type="tempType"
        :id="id"
        @cancel="cancel"
        @refresh="refresh"
    >
    </hm-ocr-template-details>
    <el-dialog
        title="商户备注"
        :visible.sync="storeRemarkVisible"
        width="800px"
    >
      <div class="flex">
        <div>
          备注：
        </div>
        <el-input
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            placeholder="请输入内容"
            v-model="storeRemark"
            style="width:500px"
        >
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button @click="confirmRemark" size="small" type="primary">
          确 定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
        title="更换模板自动检测"
        :visible.sync="autoCheckTemplateVisible"
        width="1000px"
    >
      <div>
        <span
            class="hmicon icon-tishi"
            style="font-size: 14px; color: #FF7F10"
        ></span>
        <span style="font-size: 14px; color: #FF7F10; margin-left: 5px">检测到您输入的长度与当前模板的长度不一致，是否使用新的模板进行替换？</span>
      </div>
      <div class="flex item-center mt20">
        <div style="width: 42%">
          <el-table
              :data="autoCHeckTemplateNewTemplateList"
              stripe
              border
              @selection-change="handleSelectionChange"
              style="width: 100%">
            <el-table-column
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column
                prop="templateType"
                label="类型"
                header-align="center"
                align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.templateType == 'receiptSn'">{{ "小票号" }}</span>
                <span v-if="scope.row.templateType == 'receiptDateStr'">{{ "时间戳" }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="keyPrefix"
                label="新模版前缀"
                header-align="center"
                align="center"
            >
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="minStrLength"
                label="新模板长度">
            </el-table-column>
          </el-table>
        </div>
        <div style="width: 16%" class="flex flex-center">
          <div class="replace-wrapper"><span style="background-color: none; margin-left: 10px">替换 》</span></div>
        </div>
        <div style="width: 42%">
          <el-table
              :data="autoCHeckTemplateOldTemplateList"
              stripe
              border
              style="width: 100%">
            <el-table-column
                prop="date"
                label="类型"
                header-align="center"
                align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.templateType == 'receiptSn'">{{ "小票号" }}</span>
                <span v-if="scope.row.templateType == 'receiptDateStr'">{{ "时间戳" }}</span>
              </template>
            </el-table-column>
            <el-table-column
                prop="keyPrefix"
                label="旧模版前缀"
                header-align="center"
                align="center"
            >
              <template slot-scope="scope">
                {{ scope.row.keyPrefix || "--" }}
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="minStrLength"
                label="旧模板长度">
            </el-table-column>
          </el-table>
        </div>
      </div>

      <span slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button @click="submitPre" size="small" type="primary">
          确认替换</el-button
        >
        <el-button @click="cancelPre" size="small" type="primary">
          取 消</el-button
        >
      </span>
    </el-dialog>

    <hm-redpackage-guider-alias
        ref="hmRedpackageGuiderAlias"
        @getGuiderAliasName="getGuiderAliasName"
        v-if="guiderAliasFlag"
        :guiderAliasFlag.sync="guiderAliasFlag">
    </hm-redpackage-guider-alias>


    <el-dialog
        :title="learningTitle" 
        :visible.sync="ocrMatchLogVisible"
        width="1200px"
    >
      <div class="mt20 flex item-center flex-between">
        <div v-if="ocrMatchLogQueryType == 'goods'">商品名称:{{ ocrMatchLogCurrentItem.goodsName }}</div>
        <div v-if="ocrMatchLogQueryType == 'shop'">门店名称:{{ ocrMatchLogCurrentItem.curGuiderShopName }}</div>
        
        <div>
          <el-input
              clearable
              style="width: 200px"
              v-model.trim="ocrMatchParams.ocrKeyWords"
              placeholder="请输入学习词"
              size="small"
              class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="searchOcrMatchLog"
          >查询</el-button
          >
        </div>
      </div>

      <div class="mt40">
        <el-table
            :data="ocrMatchLogList"
            stripe
            border
            style="width: 100%">
          <el-table-column
              prop="templateType"
              label="学习词"
              header-align="center"
              align="center"
          >
            <template slot-scope="scope">
              {{ "goods" == ocrMatchLogQueryType ? scope.row.ocrGoodsName : scope.row.ocrShopName }}
            </template>
          </el-table-column>
          <el-table-column
              prop="createBy"
              label="添加人"
              header-align="center"
              align="center"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="createTime"
              label="添加时间">
          </el-table-column>
          <el-table-column
              prop="操作"
              header-align="center"
              align="center"
              width="120"
              label="操作">
            <template slot-scope="scope">
              <div class="flex flex-center">
                <el-button size="small" type="text" @click="deleteOcrMatchLog(scope.row)"
                >删除</el-button
                >
                <el-button size="small" type="text" @click="editOcrMatchLog(scope.row)"
                >编辑</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="hm-pagination mb20">
        <el-pagination
            background
            :total="ocrMatchLogTotal"
            @current-change="ocrMatchLogPaging"
            @size-change="ocrMatchLogHandleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="ocrMatchLogCurrentPage"
        ></el-pagination>
      </div>


      <el-dialog
          title="编辑学习词"
          :visible.sync="editOcrMatchLogVisible"
          width="600px"
          :modal-append-to-body="false"
          :append-to-body="true"
      >
        <el-form :model="ocrMatchLogRow" :rules="rules" ref="ocrMatchLogRuleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item label="学习词" prop="ocrKeyWords">
            <el-input v-model="ocrMatchLogRow.ocrKeyWords" size="small" clearable placeholder="请输入学习词"></el-input>
          </el-form-item>
        </el-form>

        <span slot="footer" class="dialog-footer flex flex-center mt20">
          <el-button @click="submitEditOcrMatchLog" size="small" type="primary">
          确 定</el-button
          >
        <el-button @click="editOcrMatchLogVisible = false" size="small" type="primary">
          取 消</el-button
        >
      </span>
      </el-dialog>


      <span slot="footer" class="dialog-footer flex flex-center mt20">
        <el-button @click="ocrMatchLogVisible = false" size="small" type="primary">
          关 闭</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
        title="提示"
        :visible.sync="errorAuditDialog"
        width="800px"
    >
      <div class="errorAudit">
        <div class="flex item-center flex-between">
          <div>
            <div class="errorAudit-title">转给哪个品牌供货商</div>
            <div style="color: red">接收的供货商通过后小票立即通过，请确保另外1个供货商的商品内容是正确</div>
          </div>
        </div>
        <div class="mt20">
          <el-radio-group
              v-model="selectAuditGoodsId"
              @change="selectErrorAuditFn"
          >
            <el-radio
                v-for="(item, i) in errorBillAudit"
                :label="item.goodsId"
                :key="i"
            >{{ item.supplierName }}
              <div>包含品牌:{{errorBillAudit[i].brandName}}</div>
            </el-radio>
          </el-radio-group>
        </div>
        <div class="mt20">
          <div class="errorAudit-title">备注信息</div>
          <div>
            <el-input
                clearable
                v-model.trim="remark"
                placeholder="请填写备注信息"
                style="width: 700px;"
                type="textarea"
                :rows="6"
                maxlength="100"
            ></el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer flex flex-center mt40">
        <el-button @click="setErrorAuditBill" size="small" type="primary">
          确 定</el-button
        >
        <el-button @click="errorAuditDialog = false" size="small" type="primary">
          关 闭</el-button
        >
      </span>
      </div>
    </el-dialog>
    <el-dialog
        title="订单详情"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        custom-class="dialogDetail"
        width="500px"
    >
      <div>
        <div class="flex flex-between">
        <div v-if="orderDetail && orderDetail.length">
          <div>订单号：{{ orderDetail[0].order_id }}</div>
          <div class="mt10">销售日期：{{ orderDetail[0].sale_date }}</div>
          <div class="mt10">会员：{{ orderDetail[0].full_name }}</div>
          <div class="mt10">实付金额：<span class="primary">￥{{ orderDetail[0].actually_price }}</span></div>
        </div>
        <el-button
            v-if="orderDetail && orderDetail.length && (personAuditState === 'wait' || personAuditState === 'hang')"
            @click="reAudit"
            size="small"
            type="success"
            ref="btn"
            class="agree-btn"
            style="width:180px;height:50px;font-size:20px;border-radius:6px;"
        >
            重新匹配审核
        </el-button>
        </div>
      </div>
      <el-scrollbar :vertical="false" wrap-style="height: 500px;margin-top:10px;">
        <div class="dialog-body">
          <div class="mb20">
            <div class="table-panel title">商品信息</div>
            <div class="table">
              <el-table
                stripe
                border
                :data="orderDetail"
                style="width: 100%"
                id="table"
                size="small"
              >
                <el-table-column
                  header-align="center"
                  prop="goods_name"
                  align="center"
                  label="商品名称"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  prop="spec_barcode"
                  align="center"
                  label="条码"
                ></el-table-column>
                <el-table-column
                  header-align="center"
                  prop="goods_sn"
                  align="center"
                  label="货号"
                ></el-table-column>
                <!-- <el-table-column
                  header-align="center"
                  align="center"
                  label="市场价"
                >
                  <template slot-scope="scope">
                    <span class="primary">￥{{ scope.row.market_price }}</span>
                  </template>
                </el-table-column> -->
                <!-- <el-table-column
                  header-align="center"
                  align="center"
                  label="门店价"
                >
                  <template slot-scope="scope">
                    <span class="primary">￥{{ scope.row.shop_price }}</span>
                  </template>
                </el-table-column> -->
                <el-table-column
                  header-align="center"
                  prop="goods_number"
                  align="center"
                  label="商品数量"
                >
                <template slot-scope="scope">
                  <span class="primary">{{ scope.row.goods_number }}</span>
                </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  prop="total_shop_price"
                  align="center"
                  label="小计金额"
                ></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-scrollbar>
    </el-dialog>



    
    <!-- 学习词匹配 -->
    <div class="learn_word_matching" v-if="learnWordMatchingShow && learnWordList">
      <!-- <div class="learn_word_matching"> -->
      <div class="interior" @click="$event.stopPropagation()">
        <h1>学习词匹配</h1>
        <h3>{{ learnWordList[0].standard_name }}</h3>
        <h4>以下哪个选项与上面最匹配</h4>
        <ul>
          <li v-for="(item, index) in learnWordList" :key="index" @mouseenter="learnMouseenter(index)" @mouseleave="hoverLearnIndex = -1" @click="learnWordMatchingAreYouSure(item)">
            <div class="p" :class="{active: index === hoverLearnIndex, neither: hoverLearnIndex === -2 && index === learnWordList.length-1}">
              <p>
                <span v-if="index === 0">A、</span>
                <span v-if="index === 1">B、</span>
                <span v-if="index === 2">C、</span>
                <span v-if="index === 3">D、</span>
                <span v-if="index === 4">E、</span>
                <span v-if="index === 5">F、</span>
                {{ item.matched_line }}
              </p>
              <button v-show="index === hoverLearnIndex ||  hoverLearnIndex === -2 && index === learnWordList.length-1">确定</button>
            </div>
          </li>
        </ul>
      </div>
    </div>



  </div>

  <!-- </hm-content> -->
</template>

<script>
import { mapGetters } from "vuex";
import { dataURLtoFile, ToFixed } from "@/utils/utils";
import { Loading } from "element-ui";
import axios from "axios";
import HmOcrTemplateDetails from "@/components/HmOcrTemplateDetails";
import HmRedpackageGuiderAlias from "@/components/HmRedpackageGuiderAlias";
import myUpload from "vue-image-crop-upload";

export default {
  components: { HmOcrTemplateDetails, HmRedpackageGuiderAlias, myUpload },
  data() {
    return {
      learnWordMatchingShow: false,
      hoverLearnIndex: -1,
      learnWordList: [
        {
          matched_line: "",
          standard_name: "",
        },
      ],
      psList: {},
      imgDivOpacity: true,
      storesDialogVisible: false,
      theNameOfTheStore: "",
      storeRemark: "",
      shopId: "",
      storeRemarkVisible: false,
      ToFixed,
      uploadShow: true,
      isSaving: false,
      tempType: "",
      radioId: {},
      detailsTempVisible: false,
      blackGuiderVisible: false,
      refuseReason: "",
      selectTempVisible: false,
      saveimg: "",
      // 覆盖的图层信息
      cover_message: [],
      // 历史图层信息
      old_message: [],
      originWidth: null, // 图片原始宽度
      originHeight: null, // 图片原始高度
      zoomWidth: null, // 图片缩放后宽度
      zoomHeight: null, // 图片缩放后高度
      scaleX: 1, // 图片宽度缩放比例（当前实际/原始）
      scaleY: 1, // 图片高度缩放比例（当前实际/原始）
      // 初始canvas
      ctx: null,
      myCanvas: null,
      canvas_operate: null,
      // 截图框
      oRelDiv: null,
      is_canvas: false,
      is_printscreen: false,
      is_canvas_operate: false,
      start_x1: 0,
      start_y1: 0,
      close_x: 0,
      close_y: 0,
      img: null,
      original_img: null,
      screenshot_frame: true,
      fileInput: null,
      rotate_number: 0,
      img_size: 1.0,
      receiptsVisible: false,
      tishiVisible: false,
      hoverIndex: -1,
      pickerOptions: {
        disabledDate: this.disabledDate,
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      repeatOrder: [],
      drawer: false,
      drawerRepeat: false,
      eventDetailsDrawer: false,
      direction: "ltr",
      directionRepeat: "ltr",
      provinceName: "",
      msg: "",
      dangerVisible: false,
      status: "receipt",
      detailsVisible: false,
      personAuditState: "",
      sh: "",
      srcList: [],
      currentPage: 1,
      pageSize: 10,
      rejectReason: "",
      ruleForm: {
        refuseReason: "",
      },
      rules: {
        refuseReason: {
          required: true,
          message: "请输入驳回原因",
          trigger: "change",
        },
        ocrKeyWords: {
          required: true,
          message: "请输入学习词",
          trigger: "blur",
        },
      },
      rejectTemp: [
        "您输入的申报数量与实际数量不符，如有疑问请联系客服。",
        "您输入的申报商品数量存在问题，如有疑问请联系客服。",
        "您小票存在问题，如有疑问请联系客服。",
      ],
      parkey: null,
      childkey: null,
      declareRow: {},
      row: {
        goodsList: [],
        ruleInfo: {},
      },
      goodsOcrFlag: "",
      receiptSnFlag: false,
      copyOcrShopName: "",
      guiderRewardTotalMoney: 0,
      guiderRewardTotalNum: 0,
      inMsg: "",
      receiptDateStrLength: 0,
      receiptId: "",
      tempList: [],
      templateInfo: {
        number: "no",
        receiptDate: "no",
        receiptDateStr: "no",
        receiptRepeat: "no",
        receiptSn: "no",
        shopName: "no",
      },
      id: "",
      currentRow: {},
      orderDetail: [],
      totPrice: 0,
      title: "",
      templateType: "",
      minStrLength: 0,
      maxStrLength: 0,
      minReceiptSnLength: 0,
      maxReceiptSnLength: 0,
      zoom: 100,
      rotateDeg: 0,
      queryStartTime: this.$route.query.queryStartTime,
      queryEndTime: this.$route.query.queryEndTime,
      newNumAutoEnableSwitch: true,
      numAutoEnableSwitchStoreCode: "",
      numAutoEnableSwitchShopId: "",
      receiptSnAutoCheckTemplateStarus: true,
      receiptDateStrAutoCheckTemplateStarus: true,
      autoCheckTemplateVisible: false,
      autoCHeckTemplateNewTemplateList: [],
      autoCHeckTemplateOldTemplateList: [],
      autoCheckParams: {},
      selectAutoChenkList: [],
      editGoodsNum: "",
      state: "",
      hasDataList: true,
      editRuleGoodsNum: "",
      isFocus: false,
      editRuleErrorGoodsNum: "",
      hasRelDeclareSn: false,
      relDeclareSn: "",
      tempReceiptSn: "",
      tempReceiptDateStr: "",
      declareVersion: "",
      tempTotal: 0,
      tempCurrentPage: 1,
      tempPageSize: 10,
      searchCondition: {
        templateName: "",
        templateLength: "",
      },
      openMoreFlag: false,
      guiderAliasFlag: false,
      receiptRepeatTemplateName: "",
      ocrMatchLogVisible: false,
      learningTitle:'',
      ocrMatchLogCurrentItem: {},
      ocrMatchLogCurrentPage: 1,
      ocrMatchLogPageSize: 10,
      ocrMatchLogTotal: 0,
      ocrMatchLogList: [],
      ocrMatchParams: {
        ocrKeyWords: "",
      },
      ocrMatchLogQueryType: "goods",
      ocrMatchLogRow: {
        ocrKeyWords: "",
      },
      editOcrMatchLogVisible: false,
      supplierName: "",
      riskManagementRefuseReason: "",
      receiptSnkeyPrefixList: [],
      shopNamekeyPrefixList: [],
      bigPriceLimit: 50,
      textCode: "manual_review_switch",
      textCodeTips: "review_close_tips",
      manualReviewSwitch: "open",
      manualReviewSwitchTips: "当前人工审核通道关闭，请稍后再试",
      errorAuditDialog: false,
      errorBillAudit: [],
      selectAuditGoodsId: "",
      errorBillAuditClick: false,
      repeatRule: "",
      refuseReasonVoucher: "",
      showRefuseReasonVoucher: false,
      selectTempType: "receiptDate",
      isShowSelectTempType: false,
      queryType: "",
      orderType: "",
      dialogVisible: false,
      haveSameFlag: false,
      remark: "",
      overissueList: [],
      rewardRuleGoodsComposeModelList: [],
      rewardRuleRelModelList: [],
      imgActiveIndex: 0,
      list: [],
      noticeContent: "",
      auditProgressDatas: [],
      newHistoryBoList: [],
      newBillDetailsBoList: [],
      historicalDeclaredCommodities: [],
      lastShopNameBlurValue: '', // 记录上次失焦时的值
      needCallApiOnConfirm: false // 是否需要在确定时调用接口
    };
  },
  computed: {
    ...mapGetters(["detailsSalesVolume", "declareList"]),
     totalGoodsNum() {
      const { billDetailsBoList } = this.detailsSalesVolume;

      if (!Array.isArray(billDetailsBoList)) {
        return 0;
      }

      return billDetailsBoList.reduce((acc, item) => {
        const num = Number(item.goodsNum);
        return acc + (isNaN(num) ? 0 : num);
      }, 0);
    }
  },
  watch: {
    detailsSalesVolume: {
      handler() {
        this.noticeQueryList();
        // if(!this.detailsSalesVolume.ocrShopName) {
        //   this.receiptSnFlag = 'shopName'
        // }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    // document.addEventListener("keydown", this.watchEnter);
    this.declareVersion = '0130705590698076'
    this.initFunc();
  },
  destroyed() {
    // document.removeEventListener("keydown", this.watchEnter);
  },
  mounted() {
   this.declareVersion = '0130705590698076'
    if (this.$route.query.declareVersion) {
      this.declareVersion = this.$route.query.declareVersion;
    }
    if (this.$route.query.queryType) {
      this.queryType = this.$route.query.queryType;
    }
    if (this.$route.query.orderType) {
      this.orderType = this.$route.query.orderType;
    }
    // this.queryAuditTemplate();
    this.ocrRuleConfig();
    this.queryDict().then((res) => {
      if (this.manualReviewSwitch === "close") {
        this.queryDictTips();
      }
    });
  },
  methods: {
    learnMouseenter(index) {
      let atLastIndex = index + 1;
      if (this.learnWordList.length == atLastIndex) {
        this.hoverLearnIndex = -2;
      } else {
        this.hoverLearnIndex = index;
      }
    },
    // 学习词选择
    async learnWordMatchingAreYouSure(val) {
      console.log(val);
      if (val.matched_line != "都不是") {
        const { code } = await this.$store.dispatch("addMatchLog", {
          storeCode: val.storeCode,
          supplierGoodsName: val.standard_name,
          ocrGoodsName: val.matched_line,
        });
        if (code == 0) {
          this.learnWordMatchingShow = false;
          this.learnWords();
        }
      } else {
        const { code } = await this.$store.dispatch("addNoneMatchNameLog", {
          operateColumnValue: this.detailsSalesVolume.declareSn, // 申报单号
          operateMemo: this.learnWordList[0].standard_name, // 学习词对比名字
        });
        this.learnWordMatchingShow = false;
        this.learnWords();
      }
    },
    // 查看小票是否有ps的痕迹
    async whetherThereIsPsOrNot(declareSn, url) {
      const { result } = await this.$store.dispatch("ifPS", {
        declareSn,
        url,
      });

      if (result && result.ps) {
        this.psList = result;
      }
    },

    // 图片恢复初始状态
    resetImg() {
      let img = this.$refs.imgDiv;
      if (img) {
        this.imgDivOpacity = false; // 隐藏
        img.style.left = "0px";
        img.style.top = "0px";
        img.style.zoom = "100%";
        this.rotateDeg = 0; // 旋转角度
        this.zoom = 100;
        img.style.transform = "none";
      }
    },
    isBtn(code) {
      return this.isShowBtn(code);
    },
    async storeModificationSubmission() {
      if (this.theNameOfTheStore) {
        const { code } = await this.$store.dispatch(
          "updateReceiptPrintShopName",
          {
            shopId: this.shopId,
            receiptPrintShopName: this.theNameOfTheStore,
          }
        );
        if (code == 0) {
          this.$message({
            message: "门店打印名称修改成功",
            type: "success",
          });
          this.detailsSalesVolume.shopName = this.theNameOfTheStore;
          this.storesDialogVisible = false;
        }
      } else {
        // 不能为空
        this.$message({
          message: "请输入门店打印名称",
          type: "error",
        });
      }
    },
    // storesHandleClose(done){
    //   this.$confirm('确认关闭？')
    //       .then(_ => {
    //         done();
    //       })
    //       .catch(_ => {});
    // },
    modifyTheStoreMethod(val) {
      if (!this.isBtn("modifyReceiptShopPrintNameBtn:true")) {
        this.storesDialogVisible = true;
        this.theNameOfTheStore = val;
      }
    },
    async initFunc() {
      if (this.$route.query.declareSn || this.declareVersion) {
        await this.detail(this.$route.query.declareSn || this.declareVersion);
      } else {
        this.provinceName = localStorage.getItem("provinceName");
        this.sh = localStorage.getItem("sh");
        this.queryDeclareList();
        await this.detail();
      }

      this.auditProgress();
    },
    // 审核进度  schedule
    auditProgress() {
      console.log(this.receiptId);
    //   this.$store
    //     .dispatch("queryEmployeeInfoAuditStepByList", {
    //       // receiptId: this.$route.query.receiptId,
    //       receiptId: this.receiptId,
    //     })
    //     .then((res) => {
    //       let { code, result } = res;
    //       if (code == 0) {
    //         if (result.length > 0) {
    //           result[0]["msg"] = "发起转单";
    //         }
    //         if (result.length > 1) {
    //           result.forEach((e, i) => {
    //             if (i > 0) {
    //               if(e.decisionOutcome == "wait") {
    //                 e["msg"] = "(待审核)"
    //               }else if(e.decisionOutcome == "refuse"){
    //                 e["msg"] = "(已拒绝)"
    //               }else {
    //                 e["msg"] = "(已通过)";
    //               }
    //             }
    //             if (i == result.length - 1) {
    //               e["msg"] = "(待审核)";
    //             }
    //           });
    //         }
    //         if (
    //           this.personAuditState == "hang" ||
    //           this.personAuditState == "agree" ||
    //           this.personAuditState == "refuse"
    //         ) {
    //           result.pop();
    //         }
    //         this.auditProgressDatas = result;
    //       }
    //     });
    },
    noticeQueryList() {
      this.$store
        .dispatch("noticeQueryList", {
          declareSn:
            this.detailsSalesVolume.declareSn || this.$route.query.declareSn,
        })
        .then((res) => {
          console.log("--res--", res);
          this.noticeContent = res.result
            .filter((item) => item.enabledState !== "no")
            .map((item) => item.noticeContent)
            .join(";");
        });
    },
    disabledDate(time) {
      return (
        time.getTime() >
        (new Date(this.detailsSalesVolume.declareTime).getTime() || Date.now())
      );
    },
    submitEditOcrMatchLog() {
      let that = this;
      this.$refs.ocrMatchLogRuleForm.validate((valid) => {
        if (valid) {
          that.$store
            .dispatch("editOcrMatchLog", {
              id: that.ocrMatchLogRow.id,
              queryType: that.ocrMatchLogQueryType,
              ocrKeyWords: that.ocrMatchLogRow.ocrKeyWords,
            })
            .then((res) => {
              if (res.code == "0") {
                that.editOcrMatchLogVisible = false;
                that.$message({
                  message: " 操作成功",
                  type: "success",
                });
                that.queryOcrMatchLogList();
              }
            });
        } else {
          return false;
        }
      });
    },
    editOcrMatchLog(row) {
      let ruleForm = JSON.parse(JSON.stringify(row));
      ruleForm.ocrKeyWords =
        "goods" == this.ocrMatchLogQueryType
          ? ruleForm.ocrGoodsName
          : ruleForm.ocrShopName;
      this.ocrMatchLogRow = ruleForm;
      this.editOcrMatchLogVisible = true;
    },
    async deleteOcrMatchLog(row) {
      const result = await this.$confirm("是否删除本条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      });
      if (result === "confirm") {
        await this.$store.dispatch("deleteOcrMatchLog", {
          id: row.id,
        });
        this.$message({
          type: "success",
          message: "操作成功",
        });
        this.queryOcrMatchLogList();
      }
    },
    selectErrorAuditFn(val) {
      this.selectAuditGoodsId = val;
    },
    ocrMatchLogPaging(page) {
      this.ocrMatchLogCurrentPage = page;
      this.queryOcrMatchLogList();
    },
    ocrMatchLogHandleSizeChange(size) {
      this.ocrMatchLogCurrentPage = 1;
      this.ocrMatchLogPageSize = size;
      this.queryOcrMatchLogList();
    },
    searchOcrMatchLog() {
      this.ocrMatchLogCurrentPage = 1;
      this.queryOcrMatchLogList();
    },
    //type用来判断是调用商品还是门店的（目前暂时只用到了商品）
    async queryOcrMatchLogList() {
      let params = {
        storeCode: this.detailsSalesVolume.storeCode,
        queryType: this.ocrMatchLogQueryType,
        pageNo:this.ocrMatchLogCurrentPage,
        pageSize:this.ocrMatchLogPageSize,
      };
      if ("goods" == this.ocrMatchLogQueryType) {
        params.supplierKeyWords = this.ocrMatchLogCurrentItem.goodsName;
      }else if("shop" == this.ocrMatchLogQueryType){
        params.supplierKeyWords = this.ocrMatchLogCurrentItem.curGuiderShopName;
      } else {
        return;
      }

      const searchCondition = JSON.parse(JSON.stringify(this.ocrMatchParams));
      Object.assign(params, searchCondition);

      const { code, result } = await this.$store.dispatch(
        "queryOcrMatchLogList",
        params
      );
      if (code === "0") {
        const { records, total } = result;
        this.ocrMatchLogList = records;
        this.ocrMatchLogTotal = total;
      }
    },
    async ocrMatchLog(goods) {
      this.ocrMatchLogCurrentItem = goods;
      this.ocrMatchLogQueryType = "goods";
      this.learningTitle = '商品学习词'
      await this.queryOcrMatchLogList();
      this.ocrMatchLogVisible = true;
    },
    async ocrMatchLogShop(shops) {
       this.learningTitle = '门店学习词'
       this.ocrMatchLogCurrentItem = shops
       this.ocrMatchLogQueryType = "shop";
       await this.queryOcrMatchLogList();
       this.ocrMatchLogVisible = true;
      console.log(shops,123)
    },
    async queryTemplateDetails() {
      const { result } = await this.$store.dispatch(
        "sysReceiptOcrTemplateDetails",
        { id: this.templateInfo.receiptRepeatTemplateId }
      );
      this.receiptRepeatTemplateName = result.templateName;
      this.templateType = result.templateType || ""
      this.repeatRule = result.repeatRule;
    },
    async queryTemplateDetailsReceiptSn() {
      const { result } = await this.$store.dispatch(
        "sysReceiptOcrTemplateDetails",
        { id: this.templateInfo.receiptSnTemplateId }
      );
      this.receiptSnkeyPrefixList = result.keyPrefix.split(",");
    },
    async queryTemplateDetailsShopName() {
      const { result } = await this.$store.dispatch(
        "sysReceiptOcrTemplateDetails",
        { id: this.templateInfo.shopNameTemplateId }
      );
      this.shopNamekeyPrefixList = result.keyPrefix.split(",");
    },
    transferSupplier() {
      if (
        !this.detailsSalesVolume.receiptDate ||
        this.detailsSalesVolume.receiptDate === "" ||
        this.detailsSalesVolume.receiptDate === null
      ) {
        this.$message({
          message: "请先选择小票时间",
          type: "warning",
        });
        return;
      }
      //判断小票号或者小票日期是否全部为空!
      if (
        !this.detailsSalesVolume.receiptSn ||
        this.detailsSalesVolume.receiptSn === "" ||
        this.detailsSalesVolume.receiptSn === null ||
        (!this.detailsSalesVolume.receiptDateStr ||
          this.detailsSalesVolume.receiptDateStr === "" ||
          this.detailsSalesVolume.receiptDateStr === null)
      ) {
        this.$message({
          message: "请填写小票号或者小票时间!",
          type: "warning",
        });
        return;
      }

      this.$confirm("是否确定转给供货商人员审批?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        await this.$store.dispatch("declareTransferSupplier", {
          receiptId: this.detailsSalesVolume.receiptId,
          receiptSn: this.detailsSalesVolume.receiptSn,
          receiptDateStr: this.detailsSalesVolume.receiptDateStr,
        });
        this.$message({
          message: "操作成功",
          type: "success",
        });
      });
    },
    continueShowErrorAuditDialog() {
      this.errorAuditDialog = true;
      this.drawer = false;
    },
    async showErrorAuditDialog() { //templateType
    console.log(this.templateType,9898989)
      if (this.detailsSalesVolume.rewardRuleInfoModelList.length === 0) {
        this.$message({
          message: "暂无活动!",
          type: "warning",
        });
        return;
      }
      if(!this.templateType) {
         if (this.detailsSalesVolume.receiptSn === "" || this.detailsSalesVolume.receiptSn === null) {
          this.$message({
            message: "请填写小票号!",
            type: "warning",
          });
          return;
        }
        if( this.detailsSalesVolume.receiptDateStr === "" || this.detailsSalesVolume.receiptDateStr === null) {
             this.$message({
              message: "必须填识别时间,请填写完整!",
              type: "warning",
            });
            return;
        }
      }
      if (
        this.detailsSalesVolume.receiptDate === "" ||
        this.detailsSalesVolume.receiptDate === null
      ) {
        this.$message({
          message: "请填写小票日期!",
          type: "warning",
        });
        return;
      } else {
        if (
          (this.detailsSalesVolume.receiptSn === "" ||
            this.detailsSalesVolume.receiptSn === null) &&
          (this.detailsSalesVolume.receiptDateStr === "" ||
            this.detailsSalesVolume.receiptDateStr === null)
        ) {
          this.$message({
            message: "请填写小票号或者小票时间!",
            type: "warning",
          });
          return;
        } else {
          if (
            this.repeatRule !== "receiptSn" &&
            !this.detailsSalesVolume.receiptDateStr
          ) {
            this.$message({
              message: "必须填识别时间,请填写完整!",
              type: "warning",
            });
            return;
          }
          if (
            this.repeatRule === "receiptSn" &&
            !this.detailsSalesVolume.receiptSn
          ) {
            this.$message({
              message: "识别小票号不能为空,请填写完整!",
              type: "warning",
            });
            return;
          }
          if (
            this.detailsSalesVolume.receiptDateStr &&
            this.detailsSalesVolume.receiptDateStr.length > 0 &&
            this.detailsSalesVolume.receiptDateStr.length != this.maxStrLength
          ) {
            this.$message({
              message: "小票时间位数不足,请填写完整!",
              type: "warning",
            });
            return;
          }
        }
        if (
          this.detailsSalesVolume.receiptSn &&
          this.detailsSalesVolume.receiptSn.length > 32
        ) {
          this.$message({
            message: "小票号长度不能超过32位!",
            type: "warning",
          });
          return;
        }
      }

      this.errorBillAuditClick = true;
      this.$store
        .dispatch("detailsRepeatDeclare", {
          guiderId: this.detailsSalesVolume.guiderId,
          receiptSn: this.detailsSalesVolume.receiptSn,
          // storeCode: this.$route.query.storeCode,
          receiptDateStr: this.detailsSalesVolume.receiptDateStr,
          isErrorAudit: "yes",
          declareSn: this.detailsSalesVolume.declareSn,
          priorSortGuiderId: this.detailsSalesVolume.guiderId,
          priorSortShopId: this.detailsSalesVolume.shopId,
          priorSortReceiptSn: this.detailsSalesVolume.receiptSn,
        })
        .then((res) => {
          if (res.code === "0" && res.result && res.result.length > 0) {
            res.result.forEach((v) => {
              v.sameFlag = false;
            });
            this.errorAuditDialog = false;
            this.haveSameFlag = false;
            this.repeatOrder = res.result;
            console.log("this.repeatOrder1：", this.repeatOrder);
            this.drawer = true;
          } else {
            this.errorAuditDialog = true;
          }
        })
        .catch((err) => {
          this.errorAuditDialog = true;
        });
    },
    async setErrorAuditBill() {
      console.log(this.selectAuditGoodsId);
      let param = {};
      this.errorBillAudit.filter((f) => {
        if (f.goodsId === this.selectAuditGoodsId) {
          param = f;
        }
      });
      param.receiptId = this.detailsSalesVolume.receiptId;
      param.receiptSn = this.detailsSalesVolume.receiptSn;
      param.receiptDateStr = this.detailsSalesVolume.receiptDateStr;
      param.receiptDate = this.detailsSalesVolume.receiptDate;
      param.shopName = this.detailsSalesVolume.shopName;
      param.ocrShopName = this.detailsSalesVolume.ocrShopName;
      param.remark = this.remark;
      console.log(param);

      const { code } = await this.$store.dispatch("setErrorBillAudit", param);
      if (code === "0") {
        this.detailsSalesVolume.supplierAuditing = true;
      }
      this.errorAuditDialog = false;
    },
    getGuiderAliasName(aliasName) {
      this.detailsSalesVolume.aliasName = aliasName;
    },
    guiderAliasConfig() {
      this.guiderAliasFlag = true;
      this.$nextTick(() => {
        let ruleForm = {};
        ruleForm.guiderName = this.detailsSalesVolume.guiderName;
        ruleForm.guiderId = this.detailsSalesVolume.guiderId;
        let aliasList = [];
        if (this.detailsSalesVolume.aliasName) {
          aliasList = this.detailsSalesVolume.aliasName.split(",");
        }
        ruleForm.aliasList = aliasList;
        console.log("ruleForm", ruleForm);
        this.$refs.hmRedpackageGuiderAlias.initList(ruleForm);
      });
    },
    deleteGoods(item) {
      item.goodsNum = 0;
      this.goodsNumBlur(item);
    },
    async goodsNumBlur(item) {
      const { code } = await this.$store.dispatch(
        "editBillDetailsCopyGoodsNum",
        item
      );
      if (code === "0") {
        this.receiptDateChange("yes");
      }
    },
    async changeGoodsNum(type, item) {
      if (type == "add") {
        item.goodsNum++;
        if (item.goodsNum > 9999) {
          item.goodsNum = 9999;
        }
      } else if (type == "sub") {
        item.goodsNum--;
        if (item.goodsNum < 1) {
          item.goodsNum = 1;
        }
      }
      const { code } = await this.$store.dispatch(
        "editBillDetailsCopyGoodsNum",
        item
      );
      if (code === "0") {
        this.receiptDateChange("yes");
      }
    },
    async selectOther(other, otherIndex, item, itemIndex) {
      let params = JSON.parse(JSON.stringify(item));
      params.newDetaisId = other.detaisId;
      params.newSupplierGoodsId = other.supplierGoodsId;
      const { code } = await this.$store.dispatch("otherGoodsSelect", params);
      if (code === "0") {
        this.receiptDateChange("yes");
      }
    },
    async openMore(item, index) {
      item.openMoreFlag = !item.openMoreFlag;
      if (item.openMoreFlag) {
        if (
          !item.otherBillDetailsBoList ||
          item.otherBillDetailsBoList.length < 1
        ) {
          item.otherBillDetailsBoList = [];
          let params = JSON.parse(JSON.stringify(item));
          params.receiptDate = this.detailsSalesVolume.receiptDate;
          const { result } = await this.$store.dispatch(
            "queryOtherGoodsList",
            params
          );
          result.forEach((v) => {
            item.otherBillDetailsBoList.push(v);
          });
        }
      }
      this.$forceUpdate();
    },
    searchTemplate() {
      this.tempCurrentPage = 1;
      this.queryTempList();
    },
    tempPaging(page) {
      this.tempCurrentPage = page;
      this.queryTempList();
    },
    tempHandleSizeChange(size) {
      this.tempCurrentPage = 1;
      this.tempPageSize = size;
      this.queryTempList();
    },
    async querySearch(queryString, cb) {
      this.hasDataList = true;
      // 调用 callback 返回建议列表的数据
      if (!queryString) {
        cb([]);
        return;
      }

      if (!this.detailsSalesVolume.receiptDate) {
        this.hasDataList = false;
        cb([{ value: "请先输入小票时间" }]);
        return;
      }

      let params = {
        shopId: this.numAutoEnableSwitchShopId,
        keyWord: queryString,
        guiderId: this.detailsSalesVolume.guiderId,
        storeCode: this.detailsSalesVolume.storeCode,
        receiptDate: this.detailsSalesVolume.receiptDate + "00:00:00",
        declareSn: this.detailsSalesVolume.declareSn,
      };
      const { code, result } = await this.$store.dispatch(
        "declareGoodsSearch",
        params
      );
      if (code === "0") {
        if (result && result.length > 0) {
          cb(result);
          return;
        }
        this.hasDataList = false;
        cb([{ value: "无匹配数据" }]);
        return;
      }
      cb([]);
    },
    async handleSelect(item) {
      let params = {
        storeCode: this.detailsSalesVolume.storeCode,
        shopId: this.numAutoEnableSwitchShopId,
        guiderId: this.detailsSalesVolume.guiderId,
        declareSn: this.detailsSalesVolume.declareSn,
        goodsName: item.goodsName,
        brandName: item.brandName,
        supplierGoodsId: item.supplierGoodsId,
        goodsBarcode: item.goodsBarcode,
      };
      await this.$store.dispatch("addBillDetailCopyInfo", params);
      this.receiptDateChange("yes");
    },
    enddateRuleErrorGoodsNumBlur(index, rowdata) {
      if (
        rowdata.goodsNum === "" ||
        rowdata.goodsNum === this.editRuleErrorGoodsNum
      ) {
        rowdata.goodsNum = this.editRuleErrorGoodsNum;
        this.detailsSalesVolume.errList = [...this.detailsSalesVolume.errList];
      } else {
        let flag = false;

        if (rowdata.goodsNum === "" && rowdata.goodsNum > 0) {
          flag = true;
        }
        if (flag) {
          this.$message({
            message: "请输入默认指标值",
            type: "warning",
          });
        } else {
          this.$store
            .dispatch("editBillDetailsGoodsNum", rowdata)
            .then((res) => {
              if (res.code === "0") {
                this.receiptDateChange("yes");
              }
            });
        }
      }
      this.detailsSalesVolume.billDetailsBoList[
        index
      ].edit_goodsNum_enddate = !this.detailsSalesVolume.billDetailsBoList[
        index
      ].edit_goodsNum_enddate;
    },
    changeRuleErrorGoodsNumEnddate(index, rowdata) {
      console.log("rowdata", rowdata.edit_err_goodsNum_enddate);
      this.editRuleErrorGoodsNum = rowdata.goodsNum;
      this.detailsSalesVolume.errList[index].edit_err_goodsNum_enddate = !this
        .detailsSalesVolume.errList[index].edit_err_goodsNum_enddate; //直接加key
      console.log(
        "改变之后rowdata",
        JSON.parse(
          JSON.stringify(
            this.detailsSalesVolume.errList[index].edit_err_goodsNum_enddate
          )
        )
      );
      this.$forceUpdate();
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        console.log(
          "ruleErrGoodsNumInput",
          this.$refs["ruleErrGoodsNumInput" + index]
        );
        this.$refs["ruleErrGoodsNumInput" + index][0].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
      console.log("errList", this.detailsSalesVolume.errList);
    },
    enddateRuleGoodsNumBlur(firstIndex, secondIndex, rowdata, status) {
      if (
        rowdata.goodsNum === "" ||
        rowdata.goodsNum === this.editRuleGoodsNum
      ) {
        rowdata.goodsNum = this.editRuleGoodsNum;
      } else {
        let flag = false;

        if (rowdata.goodsNum === "" && rowdata.goodsNum > 0) {
          flag = true;
        }
        if (flag) {
          this.$message({
            message: "请输入默认指标值",
            type: "warning",
          });
        } else {
          this.$store
            .dispatch("editBillDetailsGoodsNum", rowdata)
            .then((res) => {
              if (res.code === "0") {
                this.receiptDateChange("yes");
              }
            });
        }
      }
      if (status == "succ") {
        this.detailsSalesVolume.successList[firstIndex].billDetailsBoList[
          secondIndex
        ].edit_goodsNum_enddate = !this.detailsSalesVolume.successList[
          firstIndex
        ].billDetailsBoList[secondIndex].edit_goodsNum_enddate;
        this.detailsSalesVolume.successList[firstIndex].billDetailsBoList = [
          ...this.detailsSalesVolume.successList[firstIndex].billDetailsBoList,
        ];
      } else {
        this.detailsSalesVolume.errList[firstIndex].billDetailsBoList[
          secondIndex
        ].edit_goodsNum_enddate = !this.detailsSalesVolume.errList[firstIndex]
          .billDetailsBoList[secondIndex].edit_goodsNum_enddate;
        this.detailsSalesVolume.errList[firstIndex].billDetailsBoList = [
          ...this.detailsSalesVolume.errList[firstIndex].billDetailsBoList,
        ];
      }
    },
    changeRuleGoodsNumEnddate(firstIndex, secondIndex, rowdata, status) {
      this.editRuleGoodsNum = rowdata.goodsNum;
      if (status == "succ") {
        this.detailsSalesVolume.successList[firstIndex].billDetailsBoList[
          secondIndex
        ].edit_goodsNum_enddate = !this.detailsSalesVolume.successList[
          firstIndex
        ].billDetailsBoList[secondIndex].edit_goodsNum_enddate; //直接加key
        this.detailsSalesVolume.successList[firstIndex].billDetailsBoList = [
          ...this.detailsSalesVolume.successList[firstIndex].billDetailsBoList,
        ];
      } else {
        this.detailsSalesVolume.errList[firstIndex].billDetailsBoList[
          secondIndex
        ].edit_goodsNum_enddate = !this.detailsSalesVolume.errList[firstIndex]
          .billDetailsBoList[secondIndex].edit_goodsNum_enddate; //直接加key
        this.detailsSalesVolume.errList[firstIndex].billDetailsBoList = [
          ...this.detailsSalesVolume.errList[firstIndex].billDetailsBoList,
        ];
      }
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs[
          "enddateGoodsNumInput" + firstIndex + secondIndex
        ][0].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    enddateGoodsNumBlur(index, rowdata) {
      if (rowdata.goodsNum === "" || rowdata.goodsNum === this.editGoodsNum) {
        rowdata.goodsNum = this.editGoodsNum;
        this.detailsSalesVolume.billDetailsBoList = [
          ...this.detailsSalesVolume.billDetailsBoList,
        ];
      } else {
        let flag = false;

        if (rowdata.goodsNum === "" && rowdata.goodsNum > 0) {
          flag = true;
        }
        if (flag) {
          this.$message({
            message: "请输入默认指标值",
            type: "warning",
          });
        } else {
          this.$store
            .dispatch("editBillDetailsCopyGoodsNum", rowdata)
            .then((res) => {
              if (res.code === "0") {
                this.receiptDateChange("yes");
              }
            });
        }
      }
      this.detailsSalesVolume.billDetailsBoList[
        index
      ].edit_goodsNum_enddate = !this.detailsSalesVolume.billDetailsBoList[
        index
      ].edit_goodsNum_enddate;
    },
    changeGoodsNumEnddate(index, rowdata) {
      this.editGoodsNum = rowdata.goodsNum;
      this.detailsSalesVolume.billDetailsBoList[
        index
      ].edit_goodsNum_enddate = !this.detailsSalesVolume.billDetailsBoList[
        index
      ].edit_goodsNum_enddate; //直接加key
      this.detailsSalesVolume.billDetailsBoList = [
        ...this.detailsSalesVolume.billDetailsBoList,
      ];
      setTimeout(() => {
        //定时器是为了避免没有获取到dom的情况报错，所以象征性的给1毫秒让他缓冲
        this.$refs["enddateGoodsNumInput" + index].focus();
        //el-input的autofocus失效，所以用这个方法。对应在template里的refs绑定值
      }, 1);
    },
    async queryAutoCheckStatus(templateType) {
      let params = {
        storeCode: this.numAutoEnableSwitchStoreCode,
        shopId: this.numAutoEnableSwitchShopId,
        templateType: templateType,
      };
      const { result } = await this.$store.dispatch(
        "queryAutoCHeckStatusSwitch",
        params
      );
      if (templateType == "receiptSn") {
        this.receiptSnAutoCheckTemplateStarus = result;
      } else if (templateType == "receiptDateStr") {
        this.receiptDateStrAutoCheckTemplateStarus = result;
      }
    },
    async editAutoCheckStatus() {
      let switchObj =
        this.currentRow.templateType == "receiptSn"
          ? this.receiptSnAutoCheckTemplateStarus
          : this.receiptDateStrAutoCheckTemplateStarus;
      console.log("switchObj", switchObj);
      let status = switchObj ? "open" : "close";
      let params = {
        storeCode: this.numAutoEnableSwitchStoreCode,
        shopId: this.numAutoEnableSwitchShopId,
        templateType: this.templateType,
        newAutoCheckTemplateRuleInfoStatus: status,
      };
      await this.$store.dispatch("updateAutoCHeckStatusSwitch", params);
      this.$message({
        message: "操作成功",
        type: "success",
      });
      this.queryAutoCheckStatus(this.currentRow.templateType);
    },
    //修改数量自动通过开关
    async numAutoEnableChange() {
      let status = this.newNumAutoEnableSwitch ? "open" : "close";
      let params = {
        storeCode: this.numAutoEnableSwitchStoreCode,
        shopId: this.numAutoEnableSwitchShopId,
        newNumautoEnableStatus: status,
      };
      await this.$store.dispatch("updateNewNumAutoEnableSwitch", params);
      this.$message({
        message: "操作成功",
        type: "success",
      });
      this.queryNewNumAutoEnableSwitch(
        this.numAutoEnableSwitchStoreCode,
        this.numAutoEnableSwitchShopId
      );
    },
    //查询新数量审核是否自动通过开关
    async queryNewNumAutoEnableSwitch(storeCode, shopId) {
      let params = {
        storeCode: storeCode,
        shopId: shopId,
      };
      const { result } = await this.$store.dispatch(
        "queryNewNumAutoEnableSwitch",
        params
      );
      this.newNumAutoEnableSwitch = result;
    },
    async confirmRemark() {
      await this.$store.dispatch("editStoreRemark", {
        storeRemark: this.storeRemark,
        storeCode: this.detailsSalesVolume.storeCode,
      });
      this.$message({
        message: "操作成功！",
        type: "success",
      });
      if (this.$route.query.declareSn) {
        this.detail(this.$route.query.declareSn);
      } else {
        // this.queryDeclareList();
        this.detail();
      }
      this.storeRemarkVisible = false;
    },
    editRemark() {
      this.storeRemark = this.detailsSalesVolume.storeRemark;
      this.storeRemarkVisible = true;
    },
    rotateImg(deg) {
      this.rotateDeg = this.rotateDeg + deg;
      this.$refs.imgDiv.style.transform = `scale(${this.zoom / 100}) rotate(${
        this.rotateDeg
      }deg)`;
    },
    // 拖动图片
    move(e) {
      e.preventDefault();
      // 获取元素
      var left = document.querySelector(".left");
      var img = document.querySelector(".img");
      var x = e.pageX - img.offsetLeft;
      var y = e.pageY - img.offsetTop;
      // 添加鼠标移动事件
      left.addEventListener("mousemove", move);
      function move(e) {
        img.style.left = e.pageX - x + "px";
        img.style.top = e.pageY - y + "px";
      }
      // 添加鼠标抬起事件，鼠标抬起，将事件移除
      img.addEventListener("mouseup", function() {
        left.removeEventListener("mousemove", move);
      });
      // 鼠标离开父级元素，把事件移除
      left.addEventListener("mouseout", function() {
        left.removeEventListener("mousemove", move);
      });
    },
    // 缩放图片
    rollImg(event) {
      /* 获取当前页面的缩放比 若未设置zoom缩放比，则为默认100%，即1，原图大小 */
      this.zoom = parseInt(this.$refs.imgDiv.style.zoom) || 100;
      /* event.wheelDelta 获取滚轮滚动值并将滚动值叠加给缩放比zoom wheelDelta统一为±120，其中正数表示为向上滚动，负数表示向下滚动 */

      this.zoom += event.wheelDelta / 12;
      /* 最小范围 和 最大范围 的图片缩放尺度 */
      if (this.zoom >= 80 && this.zoom < 1000) {
        this.$refs.imgDiv.style.zoom = this.zoom + "%";
      }
      this.$refs.imgDiv.style.transform = `scale(${this.zoom / 100}) rotate(${
        this.rotateDeg
      }deg)`;
      return false;
    },

    beforeUpload(file) {
      console.log("file: ", file);
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning",
        });
      }
      return extension || extension2 || extension3 || extension4;
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
      this.uploadShow = true;
    },
    uploadListDetailError() {
      this.$message({
        message: "上传失败，请重试!",
        type: "warning",
      });
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.open_img(jsonData.result);
        this.detailsSalesVolume.srcList = [jsonData.result];
        this.receiptsVisible = false;
        this.queryOcrResult(jsonData.result);
        this.uploadShow = false;
      }
    },
    uploadMainPicSucc2(jsonData) {
      if (jsonData.code === 0) {
        this.refuseReasonVoucher = jsonData.result;
      }
    },
    tempClose() {
      this.selectTempVisible = false;
      this.currentRow = {};
      this.searchCondition.templateName = "";
      this.searchCondition.templateLength = "";
      this.tempCurrentPage = 1;
      this.tempPageSize = 10;
    },
    blackReasonClose() {
      this.blackGuiderVisible = false;
    },
    blackReasonClick() {
      if (this.detailsSalesVolume.isWhite) {
        this.detailsSalesVolume.isWhite = false;
      } else {
        this.detailsSalesVolume.isWhite = true;
        console.log(
          "detailsSalesVolume.isWhite:",
          this.detailsSalesVolume.isWhite
        );
        this.refuseReason = "";
        this.refuseReasonVoucher = "";
        this.blackGuiderVisible = true;
      }
    },
    refresh() {
      this.queryTempList();
      this.detailsTempVisible = false;
    },
    async selectRow(setType) {
      if (Object.keys(this.currentRow).length === 0) {
        this.$message({
          message: "请选择模板！",
          type: "warning",
        });
      } else {
        let params = {
          sysTemplateId: this.currentRow.id,
          templateType: this.currentRow.templateType,
          shopId: this.detailsSalesVolume.shopId,
          storeCode: this.detailsSalesVolume.storeCode,
          setType,
        };
        const { code } = await this.$store.dispatch("addOcrRule", params);
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success",
          });
          this.currentRow = {};
          this.selectTempVisible = false;
          this.queryTempConfig(this.detailsSalesVolume.shopId);
        }
      }
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    async queryTempList() {
      let params = {
        pageSize: this.tempPageSize,
        pageNo: this.tempCurrentPage,
        templateType: this.templateType,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));

      Object.assign(params, searchCondition);
      if (params.templateLength) {
        params.minStrLength = params.templateLength;
        params.maxStrLength = params.templateLength;
      }
      const { code, result } = await this.$store.dispatch(
        "sysReceiptOcrTemplateList",
        params
      );
      if (code === "0") {
        const { records, total } = result;
        this.tempList = records;
        this.tempTotal = total;
        this.tempList.forEach((v) => {
          if (v.id === this.id) {
            this.$refs.singleTable.setCurrentRow(v);
          }
        });
      }
    },
    cancel() {
      this.detailsTempVisible = false;
    },
    editTemp(id, templateType, title) {
      this.searchCondition.templateLength = "";
      this.id = id;
      this.title = title;
      this.templateType = templateType;
      if ("receiptSn" == templateType) {
        if (this.detailsSalesVolume.receiptSn) {
          this.searchCondition.templateLength = this.detailsSalesVolume.receiptSn.length;
        }
      }
      if (templateType == "receiptDate" || templateType == "receiptSnDate") {
        this.selectTempType = templateType;
        this.isShowSelectTempType = true;
      } else {
        this.isShowSelectTempType = false;
      }
      this.queryTempList();
      this.queryAutoCheckStatus("receiptSn");
      this.queryAutoCheckStatus("receiptDateStr");
      this.selectTempVisible = true;
    },
    add() {
      this.detailsTempVisible = true;
      this.tempType = "add";
    },
    async detailsTemp(id) {
      this.tempType = "details";

      this.detailsTempVisible = true;
      this.id = id;
    },
    async viewOrder(orderId, storeCode) {
      const { result } = await this.$store.dispatch("queryOrderPosDetail", {
        orderId: orderId,
        storeCode: storeCode,
      });
      const { orderDetail } = result;
      this.orderDetail = orderDetail;
      this.dialogVisible = true;
    },
    // 重新匹配审核
    async reAudit() {
      this.$store
        .dispatch("detailsRepeatDeclare", {
          guiderId: this.detailsSalesVolume.guiderId,
          receiptSn: this.detailsSalesVolume.receiptSn,
          receiptDateStr: this.detailsSalesVolume.receiptDateStr,
          declareSn: this.detailsSalesVolume.declareSn,
          priorSortGuiderId: this.detailsSalesVolume.guiderId,
          priorSortShopId: this.detailsSalesVolume.shopId,
          priorSortReceiptSn: this.detailsSalesVolume.receiptSn,
        })
        .then(async (res) => {
          if (res.code === "0" && res.result && res.result.length > 0) {
            res.result.forEach((v) => {
              v.sameFlag = false;
            });
            this.errorAuditDialog = false;
            this.haveSameFlag = false;
            this.repeatOrder = res.result;

            this.repeatOrder.forEach((v, index) => {
              // 添加排序代码
              let result1 = [];
              let result2 = [];
              result1[index] = [];
              result2[index] = [];
              v.rewardRuleInfoModelList[0].billDetailsBoList.forEach(
                (item1) => {
                  this.detailsSalesVolume.successList[0].billDetailsBoList.forEach(
                    (item2) => {
                      if (item1.goodsBarcode === item2.goodsBarcode) {
                        result1[index].push(item1); // 相同位置的相同元素，放入结果数组
                        result2[index].push(item2);
                      }
                    }
                  );
                }
              );
              for (
                let i = 0;
                i < v.rewardRuleInfoModelList[0].billDetailsBoList.length;
                i++
              ) {
                if (
                  !result1[index].includes(
                    v.rewardRuleInfoModelList[0].billDetailsBoList[i]
                  )
                ) {
                  // 避免重复添加相同的元素
                  result1[index].push(
                    v.rewardRuleInfoModelList[0].billDetailsBoList[i]
                  );
                }
              }
              for (
                let i = 0;
                i <
                this.detailsSalesVolume.successList[0].billDetailsBoList.length;
                i++
              ) {
                if (
                  !result2[index].includes(
                    this.detailsSalesVolume.successList[0].billDetailsBoList[i]
                  )
                ) {
                  // 避免重复添加相同的元素
                  result2[index].push(
                    this.detailsSalesVolume.successList[0].billDetailsBoList[i]
                  );
                }
              }
              v.rewardRuleInfoModelList[0].billDetailsBoList = result1[index];
              v.successList = JSON.parse(
                JSON.stringify(this.detailsSalesVolume.successList)
              );
              v.successList[0].billDetailsBoList = result2[index];
              console.log("修改过后的this.repeatOrder2：", this.repeatOrder);
            });

            console.log("this.repeatOrder1：", this.repeatOrder);
            this.drawer = true;
          } else {
            let params = JSON.parse(JSON.stringify(this.detailsSalesVolume));
            const { code, inMsg, errMsg, result } = await this.$store.dispatch(
              "reAudit",
              params
            );
            if (code === "0") {
              // 审核完成 应该自动下一单
              if (inMsg === "-1") {
                this.$message({
                  message: errMsg,
                  type: "success",
                });
                this.dialogVisible = true;

                console.log(errMsg.indexOf("供货商余额不足"));
                if (errMsg.indexOf("供货商余额不足") != -1) {
                  this.dialogVisible = false;
                  if (this.$route.query.declareSn) {
                    this.$router.back(-1);
                  } else {
                    this.detail();
                    this.detailsVisible = false;

                    setTimeout(() => {
                      this.resetRuleForm();
                    }, 0);
                    this.dialogVisible = false;
                  }
                }

                // 这里应该自动下一单
                if (this.$route.query.declareSn) {
                  setTimeout(() => {
                    this.$router.back(-1);
                  }, 2000);
                } else {
                  setTimeout(() => {
                    this.resetRuleForm();
                  }, 0);
                  this.detail();
                  // this.queryDeclareList();
                }
              } else if (inMsg === "-2") {
                this.$message({
                  message: errMsg,
                  type: "warning",
                });

                this.detailsRepeatDeclare("sub");
              } else if (inMsg === "-3" || inMsg === "-4") {
                this.$message({
                  message: errMsg,
                  type: "warning",
                });
                this.dialogVisible = true;
              } else {
                this.$message({
                  message: "操作成功!",
                  type: "success",
                });

                if (this.$route.query.declareSn) {
                  this.$router.back(-1);
                } else {
                  this.detail();
                  this.detailsVisible = false;

                  setTimeout(() => {
                    this.resetRuleForm();
                  }, 0);
                  this.dialogVisible = false;
                }
              }
            }
            this.dialogVisible = false;
          }
        })
        .catch((err) => {});
    },
    async queryTempConfig(shopId) {
      const { code, result } = await this.$store.dispatch("queryTempConfig", {
        shopId,
      });
      if (code === "0") {
        if (result) {
          this.minStrLength = result.minStrLength || 0;
          this.maxStrLength = result.maxStrLength || 0;
          if (
            result.hasOwnProperty("minReceiptSnLength") &&
            result.hasOwnProperty("maxReceiptSnLength")
          ) {
            this.minReceiptSnLength =
              result.minReceiptSnLength === ""
                ? this.detailsSalesVolume.receiptSnLength
                : result.minReceiptSnLength;
            this.maxReceiptSnLength =
              result.maxReceiptSnLength === ""
                ? this.detailsSalesVolume.receiptSnLength
                : result.maxReceiptSnLength;
          } else {
            this.minReceiptSnLength = this.detailsSalesVolume.receiptSnLength;
            this.maxReceiptSnLength = this.detailsSalesVolume.receiptSnLength;
          }

          this.templateInfo = result;
          if (this.templateInfo.receiptRepeat === "yes") {
            this.queryTemplateDetails();
          }
          if (this.templateInfo.receiptSnTemplateId) {
            this.queryTemplateDetailsReceiptSn(
              this.templateInfo.receiptSnTemplateId
            );
          }
          if (this.templateInfo.shopNameTemplateId) {
            this.queryTemplateDetailsShopName(
              this.templateInfo.shopNameTemplateId
            );
          }
        }
      }
    },

    receiptDateStrChange(val) {
      this.receiptDateStrLength = val.length;
    },
    async isWhiteChange() {
      if (this.refuseReason == "") {
        this.$message({
          message: "请输入原因",
          type: "warning",
        });
        return;
      }
      if (this.refuseReasonVoucher == "") {
        this.$message({
          message: "请上传凭证",
          type: "warning",
        });
        return;
      }
      let params = {
        guiderId: this.detailsSalesVolume.guiderId,
        isWhite: false,
        refuseReason: this.refuseReason,
        refuseReasonVoucher: this.refuseReasonVoucher,
      };
      this.$store.dispatch("managerGuiderEdit", params).then((res) => {
        this.blackGuiderVisible = false;
        this.detailsSalesVolume.isWhite = false;
        this.$message({
          message: " 操作成功",
          type: "success",
        });
      });
    },
    async queryOcrResult(img) {
      const { result } = await this.$store.dispatch("queryOcrResult", {
        receiptTemplateImg: img,
      });
      this.detailsSalesVolume.ocrResultList = JSON.parse(
        JSON.stringify(result)
      );
      this.submitImg(img, result);
    },
    async submitImg(declareImg, ocrResult) {
      const { code } = await this.$store.dispatch("submitDeclareImg", {
        receiptId: this.detailsSalesVolume.receiptId,
        declareImg,
        ocrResult: JSON.stringify(ocrResult),
      });
      if (code === "0") {
        this.$message({
          message: "操作成功",
          type: "success",
        });
      }
    },
    canvas_submit() {
      let mycanvas = document.getElementById("myCanvas");
      var base64Data = mycanvas.toDataURL("image/jpeg", 1.0);
      this.saveimg = base64Data;
      let file = dataURLtoFile(base64Data);
      var forms = new FormData();
      forms.append("file", file);
      let loading;
      loading = Loading.service({
        lock: true,
        text: "卖力加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0)",
      });
      axios({
        method: "post",
        url: this.$uploadUrl,
        data: forms,
        headers: {
          "Content-Type": "multipart/form-data",
          "X-Access-Token": this.$token,
        },
      }).then((res) => {
        if (res.data.code === 0) {
          this.detailsSalesVolume.srcList = [res.data.result];
          this.receiptsVisible = false;
          this.queryOcrResult(res.data.result);
        }
        loading.close();
      });

      this.ctx.save();
    },
    // 打开图片
    open_img(newImg) {
      if (!newImg) {
        // 清除之前的残留
        this.saveimg = "";
        this.receiptsVisible = true;
      }

      setTimeout(() => {
        if (this.oRelDiv) {
          this.oRelDiv.innerHTML = "";
        }
        var __this = this;
        var myCanvas = document.getElementById("myCanvas");
        var ctx = myCanvas.getContext("2d");
        this.ctx = ctx;
        this.myCanvas = myCanvas;

        var imgDiv = document.getElementById("imgDiv");
        var img = new Image();
        img.setAttribute("crossOrigin", "anonymous");
        let src = newImg ? newImg : this.detailsSalesVolume.srcList[0];
        if (src) {
          __this.screenshot_frame = false;
          __this.is_canvas = true;
          // 被裁剪图片

          img.setAttribute("id", "img");
          img.src = src;
          __this.img = img;

          // 图片写入canvas 内
          img.onload = function() {
            img.width = img.naturalWidth;
            img.height = img.naturalHeight;
            myCanvas.width = img.naturalHeight;
            myCanvas.height = img.naturalHeight;
            imgDiv.style.height = img.naturalHeight;
            if (img.naturalWidth > img.naturalHeight) {
              __this.originWidth = 1000;
              __this.originHeight = 900;
              __this.zoomWidth = 1000;
              __this.zoomHeight = 900;
            } else {
              __this.originWidth = img.naturalWidth;
              __this.originHeight = img.naturalHeight;
              __this.zoomWidth = img.naturalWidth;
              __this.zoomHeight = img.naturalHeight;
            }

            ctx.drawImage(img, 0, 0, __this.originWidth, __this.originHeight);
          };
        } else {
          this.zoomWidth = null;
          this.zoomHeight = null;
          __this.screenshot_frame = true;
        }
      }, 100);
    },
    // 旋转1
    rotate_btn() {
      this.rotate_number += 90;
      var degree = 0;
      degree += parseInt(this.rotate_number);
      degree %= 360;
      this.ctx.save();

      this.ctx.clearRect(0, 0, this.myCanvas.width, this.myCanvas.height);
      this.ctx.translate(this.myCanvas.width / 2, this.myCanvas.height / 2);
      this.ctx.rotate((degree / 180) * Math.PI);
      this.ctx.translate(-this.myCanvas.width / 2, -this.myCanvas.height / 2);
      if (this.zoomWidth >= this.zoomHeight) {
        this.ctx.drawImage(
          this.img,
          this.myCanvas.width / 2 - this.zoomHeight / 2,
          this.myCanvas.height / 2 - this.zoomWidth / 2,
          this.originWidth * this.img_size,
          this.originHeight * this.img_size
        );
      } else {
        this.ctx.drawImage(
          this.img,
          this.myCanvas.width / 2 - this.zoomWidth / 2,
          this.myCanvas.height / 2 - this.zoomHeight / 2,
          this.originWidth * this.img_size,
          this.originHeight * this.img_size
        );
      }

      this.ctx.restore();
    },
    // 旋转2
    rotate_btn2() {
      this.rotate_number -= 90;
      var degree = 0;
      degree += parseInt(this.rotate_number);
      degree %= 360;
      this.ctx.save();
      this.ctx.clearRect(0, 0, this.myCanvas.width, this.myCanvas.height);
      this.ctx.translate(this.myCanvas.width / 2, this.myCanvas.height / 2);
      this.ctx.rotate((degree / 180) * Math.PI);
      this.ctx.translate(-this.myCanvas.width / 2, -this.myCanvas.height / 2);
      if (this.zoomWidth >= this.zoomHeight) {
        this.ctx.drawImage(
          this.img,
          this.myCanvas.width / 2 - this.zoomHeight / 2,
          this.myCanvas.height / 2 - this.zoomWidth / 2,
          this.originWidth * this.img_size,
          this.originHeight * this.img_size
        );
      } else {
        this.ctx.drawImage(
          this.img,
          this.myCanvas.width / 2 - this.zoomWidth / 2,
          this.myCanvas.height / 2 - this.zoomHeight / 2,
          this.originWidth * this.img_size,
          this.originHeight * this.img_size
        );
      }
      this.ctx.restore();
    },

    tableRowClassNameCheck({ row, rowIndex }) {
      if (rowIndex === this.row.ruleInfo.ruleRelModelList.length - 1) {
        if (this.guiderRewardTotalNum > row.rewardNumberLimit) {
          return "tuikuan";
        }
      } else {
        if (
          this.guiderRewardTotalNum > row.rewardNumberLimit &&
          this.guiderRewardTotalNum <=
            this.row.ruleInfo.ruleRelModelList[rowIndex + 1].rewardNumberLimit
        ) {
          return "tuikuan";
        }
      }

      return "";
    },
    receiptDateChange(val) {
      if (val) {
        this.tempReceiptSn = this.detailsSalesVolume.receiptSn;
        this.tempReceiptDateStr = this.detailsSalesVolume.tempReceiptDateStr;
        this.doubleDetails();
      }
    },

    receiptSnFocus(val) {
      this.receiptSnFlag = val;
    },
    changeShopName() {
       if (this.detailsSalesVolume.ocrShopName !== this.lastShopNameBlurValue) {
        this.lastShopNameBlurValue = this.detailsSalesVolume.ocrShopName;
        this.needCallApiOnConfirm = true; // 标记需要在确定时调用接口
        // 这里可以选择是否立即调用接口，或者只在确定时调用
        // await this.callApi(this.inputValue);
      }
      // if (this.detailsSalesVolume.ocrShopName) {
      //   const { result } = await this.$store.dispatch("changeShopName", {
      //     ocrShopName: this.detailsSalesVolume.ocrShopName,
      //     declareSn: this.detailsSalesVolume.declareSn,
      //   });
      // }
    },
    async getChangeShopName() {
      if (this.detailsSalesVolume.ocrShopName) {
        const { result } = await this.$store.dispatch("changeShopName", {
          ocrShopName: this.detailsSalesVolume.ocrShopName,
          declareSn: this.detailsSalesVolume.declareSn,
        });
      }
    },
    mouseover(index) {
      this.hoverIndex = index;
    },
    mouseLeave() {
      this.hoverIndex = -1;
    },
    async evenDetails(v) {
      if (!v.rewardRuleId) {
        return;
      }
      const { result } = await this.$store.dispatch(
        "detailsSupplierRewardRuleInfoList",
        {
          rewardRuleId: v.rewardRuleId,
        }
      );
      this.row = result;
      this.supplierName = this.row.ruleInfo.supplierName;
      this.row.ruleInfo.ruleRelModelList.sort(
        (a, b) => a.rewardNumberLimit - b.rewardNumberLimit
      );
      let res = await this.$store.dispatch("queryRewardTotalProfit", {
        rewardRuleId: v.rewardRuleId,
        guiderId: this.detailsSalesVolume.guiderId,
      });
      const { guiderRewardTotalMoney, guiderRewardTotalNum } = res.result;
      this.guiderRewardTotalMoney = guiderRewardTotalMoney;
      this.guiderRewardTotalNum = guiderRewardTotalNum;
      if (this.row.ruleInfo.rewardMode === "collocation") {
        const data = await this.$store.dispatch(
          "findSupplierRewardRuleInfoCollocationList",
          {
            rewardRuleId: v.rewardRuleId,
            supplierCode: v.supplierCode,
          }
        );
        const {
          rewardRuleGoodsComposeModelList,
          rewardRuleRelModelList,
        } = data.result;
        this.rewardRuleGoodsComposeModelList = rewardRuleGoodsComposeModelList;
        this.rewardRuleRelModelList = rewardRuleRelModelList.map((item) => {
          item.rewardRuleRelModelComposeModel.map((v) => {
            let find = rewardRuleGoodsComposeModelList.find(
              (goods) => goods.composeId == v.composeId
            );
            v.goodsUpperLimit = find ? find.goodsUpperLimit : "";
            return v;
          });
          return item;
        });
      }
      this.$forceUpdate();
      this.eventDetailsDrawer = true;
    },
    resetRuleForm() {
      this.ruleForm.personAuditState = "";
      this.rejectReason = "";
      if (this.$refs.ruleForm) {
        this.$refs.ruleForm.resetFields();
      }
    },
    async detailsRepeatDeclare(type) {
      const { result } = await this.$store.dispatch("detailsRepeatDeclare", {
        guiderId: this.detailsSalesVolume.guiderId,
        receiptSn: this.detailsSalesVolume.receiptSn,
        receiptDateStr: this.detailsSalesVolume.receiptDateStr,
        declareSn: this.detailsSalesVolume.declareSn,
        priorSortGuiderId: this.detailsSalesVolume.guiderId,
        priorSortShopId: this.detailsSalesVolume.shopId,
        priorSortReceiptSn: this.detailsSalesVolume.receiptSn,
      });
      if (result && result.length > 0) {
        result.forEach((v) => {
          v.sameFlag = false;
        });
        if (this.errorBillAuditClick) {
          this.errorAuditDialog = false;
        }
        this.haveSameFlag = false;
        this.drawer = true;
      } else {
        this.errorAuditDialog = true;
      }
      if (result == null || result.length <= 0) {
        if (
          this.detailsSalesVolume.refuseReason &&
          this.detailsSalesVolume.refuseReason.includes("资金超发")
        ) {
          this.drawer = true;
          this.errorAuditDialog = false;
        } else {
          if (type === "reject") {
            this.$message({
              message: "未找到pos数据!",
              type: "error",
            });
          }
          this.drawer = false;
          this.errorAuditDialog = false;
        }
      }
      this.repeatOrder = result;
      console.log("this.detailsSalesVolume2：", this.detailsSalesVolume);
      console.log("this.repeatOrder2：", this.repeatOrder);
      this.repeatOrder.forEach((v) => {
        v.billDetailsBoListLength = 0;
        v.refundSnNum = 0;
        v.refundState = "";
        v.refundPic = "";
        v.rewardRuleInfoModelList.forEach((o) => {
          v.billDetailsBoListLength += o.billDetailsBoList.length;
          o.billDetailsBoListTemp = o.billDetailsBoList;
          o.billDetailsBoListTempNoRefundSn = [];
          o.billDetailsBoListTempHaveRefundSn = [];
          o.billDetailsBoListTemp.forEach((k) => {
            if (k.refundSn) {
              o.billDetailsBoListTempHaveRefundSn.push(k);
              v.refundSnNum++;
            } else {
              o.billDetailsBoListTempNoRefundSn.push(k);
            }
          });
          o.billDetailsBoList = [];
          o.billDetailsBoList = o.billDetailsBoListTempHaveRefundSn.concat(
            o.billDetailsBoListTempNoRefundSn
          );
        });
      });
      this.repeatOrder.forEach((v, index) => {
        if (v.billDetailsBoListLength && v.refundSnNum) {
          if (v.billDetailsBoListLength === v.refundSnNum) {
            v.refundState = "all";
            v.refundPic =
              "https://imgcdn.hemiao100.com/hemiaoBase/hmService/refund-all.png";
          } else {
            v.refundState = "part";
            v.refundPic =
              "https://imgcdn.hemiao100.com/hemiaoBase/hmService/refund.png";
          }
        } else {
          v.refundState = "";
          v.refundPic = "";
        }

        // 添加排序代码
        let result1 = [];
        let result2 = [];
        result1[index] = [];
        result2[index] = [];
        v.rewardRuleInfoModelList[0].billDetailsBoList.forEach((item1) => {
          this.detailsSalesVolume.successList[0].billDetailsBoList.forEach(
            (item2) => {
              if (item1.goodsBarcode === item2.goodsBarcode) {
                result1[index].push(item1); // 相同位置的相同元素，放入结果数组
                result2[index].push(item2);
              }
            }
          );
        });
        for (
          let i = 0;
          i < v.rewardRuleInfoModelList[0].billDetailsBoList.length;
          i++
        ) {
          if (
            !result1[index].includes(
              v.rewardRuleInfoModelList[0].billDetailsBoList[i]
            )
          ) {
            // 避免重复添加相同的元素
            result1[index].push(
              v.rewardRuleInfoModelList[0].billDetailsBoList[i]
            );
          }
        }
        for (
          let i = 0;
          i < this.detailsSalesVolume.successList[0].billDetailsBoList.length;
          i++
        ) {
          if (
            !result2[index].includes(
              this.detailsSalesVolume.successList[0].billDetailsBoList[i]
            )
          ) {
            // 避免重复添加相同的元素
            result2[index].push(
              this.detailsSalesVolume.successList[0].billDetailsBoList[i]
            );
          }
        }
        v.rewardRuleInfoModelList[0].billDetailsBoList = result1[index];
        v.successList = JSON.parse(
          JSON.stringify(this.detailsSalesVolume.successList)
        );
        v.successList[0].billDetailsBoList = result2[index];
        console.log("修改过后的this.repeatOrder2：", this.repeatOrder);
      });
      // },1000)

      let repeatOrderTemp = this.repeatOrder;
      let repeatOrderTemp2 = [];
      repeatOrderTemp.forEach((v) => {
        v.rewardRuleInfoModelList.forEach((o) => {
          repeatOrderTemp2.push(o);
        });
      });
      let repeatOrderTemp3 = JSON.parse(JSON.stringify(repeatOrderTemp2));
      var newArr = [];
      repeatOrderTemp3.forEach((item) => {
        var dataItem = item;
        if (newArr.length > 0) {
          var filterValue = newArr.filter((v) => {
            return v.rewardRuleId == dataItem.rewardRuleId;
          });
          if (filterValue.length > 0) {
            newArr.forEach((n) => {
              if (n.rewardRuleId == item.rewardRuleId) {
                n.billDetailsBoList.push(...item.billDetailsBoList);
              }
            });
          } else {
            newArr.push(dataItem);
          }
        } else {
          newArr.push(dataItem);
        }
      });
      var newArr2 = JSON.parse(JSON.stringify(newArr));
      newArr2.forEach((item) => {
        item.billDetailsBoListNew = [];
        item.billDetailsBoList.forEach((v) => {
          var dataItem = v;
          if (item.billDetailsBoListNew.length > 0) {
            var filterValue2 = item.billDetailsBoListNew.filter((v) => {
              return v.goodsBarcode == dataItem.goodsBarcode;
            });
            if (filterValue2.length > 0) {
              item.billDetailsBoListNew.forEach((n) => {
                if (n.goodsBarcode == v.goodsBarcode) {
                  n.goodsNum += v.goodsNum;
                }
              });
            } else {
              item.billDetailsBoListNew.push(dataItem);
            }
          } else {
            item.billDetailsBoListNew.push(dataItem);
          }
        });
      });
      this.overissueList = JSON.parse(JSON.stringify(newArr2));
    },
    switchRejectReason() {
      this.ruleForm.refuseReason = this.rejectTemp[this.rejectReason];
    },

    async submitDouble() {
      let params = JSON.parse(JSON.stringify(this.detailsSalesVolume));
      params.personAuditState = "agree";
      if (this.inMsg === "-3") {
        params.ifConfirm = "yes";
      } else {
        params.ifConfirm = "yess";
      }
      const { code, inMsg, errMsg } = await this.$store.dispatch(
        "rejectSalesVolumeList",
        params
      );
      if (code === "0") {
        this.dialogVisible = false;
        if (inMsg === "-1") {
          console.log(11111);
          // this.dangerVisible = true;
          this.msg = errMsg;
          this.drawer = false;
          this.detail();
          // this.queryDeclareList();

          setTimeout(() => {
            this.resetRuleForm();
          }, 0);
        } else if (inMsg === "-2") {
          this.$message({
            message: "该订单已审核通过,请勿重复提交!",
            type: "warning",
          });
          this.drawer = false;
          this.detailsRepeatDeclare("sub");
        } else if (inMsg === "-3") {
          this.tishiVisible = true;
          this.msg = errMsg;
          this.drawer = false;
        } else {
          this.$message({
            message: "操作成功!",
            type: "success",
          });

          if (this.$route.query.declareSn) {
            this.$router.back(-1);
          } else {
            this.detail();
            this.detailsVisible = false;
            this.tishiVisible = false;
            this.drawer = false;
            setTimeout(() => {
              this.resetRuleForm();
            }, 0);
          }
        }
      }
    },
    async submitRuleForm() {
      // this.$refs.btn.$el.onkeydown = () => {
      //   let _key = window.event.keyCode;
      //   if (_key === 13) {
      //     return false;
      //   }
      // };
       if (this.needCallApiOnConfirm) {
        await this.getChangeShopName();
        this.needCallApiOnConfirm = false;
      }
      this.errorBillAuditClick = false;
      this.ruleForm.personAuditState = "agree";
      Object.assign(this.detailsSalesVolume, this.ruleForm);

      if (
        this.detailsSalesVolume.receiptDate === "" ||
        this.detailsSalesVolume.receiptDate === null
      ) {
        this.$message({
          message: "请填写小票日期!",
          type: "warning",
        });
      } else {
        if (
          (this.detailsSalesVolume.receiptSn === "" ||
            this.detailsSalesVolume.receiptSn === null) &&
          (this.detailsSalesVolume.receiptDateStr === "" ||
            this.detailsSalesVolume.receiptDateStr === null)
        ) {
          this.$message({
            message: "请填写小票号或者小票时间!",
            type: "warning",
          });
        } else {
          if (
            this.repeatRule !== "receiptSn" &&
            !this.detailsSalesVolume.receiptDateStr
          ) {
            this.$message({
              message: "必须填识别时间,请填写完整!",
              type: "warning",
            });
            return;
          }
          if (
            this.detailsSalesVolume.receiptDateStr &&
            this.detailsSalesVolume.receiptDateStr.length > 0 &&
            this.detailsSalesVolume.receiptDateStr.length != this.maxStrLength
          ) {
            this.$message({
              message: "小票时间位数不足,请填写完整!",
              type: "warning",
            });
            return;
          }
          if (
            this.detailsSalesVolume.receiptSn &&
            this.detailsSalesVolume.receiptSn.length > 32
          ) {
            this.$message({
              message: "小票号长度不能超过32位!",
              type: "warning",
            });
            return;
          }

          this.learnWordMatchingSubmit();
        }
      }
    },
    // 弹窗过后继续
    async learnWordMatchingSubmit() {
      if (
        this.detailsSalesVolume.receiptDate != "" &&
        this.detailsSalesVolume.receiptDate != null
      ) {
        this.detailsSalesVolume.receiptDate = `${this.detailsSalesVolume.receiptDate.substring(
          0,
          10
        )} 00:00:00`;
      }

      let params = {};
      this.detailsSalesVolume.copyOcrShopName = this.detailsSalesVolume
        .copyOcrShopName
        ? this.detailsSalesVolume.copyOcrShopName
        : "";

      if (this.copyOcrShopName === this.detailsSalesVolume.copyOcrShopName) {
        for (let key in this.detailsSalesVolume) {
          if (key !== "ocrShopName") {
            params[key] = this.detailsSalesVolume[key];
          }
        }
      } else {
        params = JSON.parse(JSON.stringify(this.detailsSalesVolume));
      }
      let autoParams = JSON.parse(JSON.stringify(this.detailsSalesVolume));
      autoParams.oldSysTemplateIdSn =
        this.templateInfo.receiptSnTemplateId || "";
      autoParams.oldSysTemplateIdDateStr =
        this.templateInfo.receiptDateStrTemplateId || "";
      autoParams.snCheckTemplateFlag = true;
      autoParams.dateStrCheckTemplateFlag = true;
      if (
        autoParams.receiptSn.length >= this.minReceiptSnLength &&
        autoParams.receiptSn.length <= this.maxReceiptSnLength
      ) {
        autoParams.snCheckTemplateFlag = false;
      }
      console.log("autoParams", autoParams);
      this.autoCheckParams = autoParams;

      // 1、 检测到您输入的长度与当前模板的长度不一致，是否使用新的模板进行替换
      const { result } = await this.$store.dispatch(
        "autoCheckTemplate",
        autoParams
      );
      this.autoCHeckTemplateNewTemplateList = result.newList;
      this.autoCHeckTemplateOldTemplateList = result.oldList;
      // 长度与当前模版一致
      if (
        this.autoCHeckTemplateNewTemplateList &&
        this.autoCHeckTemplateNewTemplateList.length > 0
      ) {
        this.autoCheckTemplateVisible = true;
      } else {
        this.cancelPre();
      }
    },

    handleSelectionChange(val) {
      this.selectAutoChenkList = val;
    },
    // 长度不一样的确定
    submitPre() {
      this.autoCheckParams.snCheckTemplateFlag = false;
      this.autoCheckParams.dateStrCheckTemplateFlag = false;
      this.autoCheckParams.oldSysTemplateIdSn =
        this.templateInfo.receiptSnTemplateId || "";
      this.autoCheckParams.oldSysTemplateIdDateStr =
        this.templateInfo.receiptDateStrTemplateId || "";
      if (this.selectAutoChenkList && this.selectAutoChenkList.length > 0) {
        this.selectAutoChenkList.forEach((v) => {
          if (v.templateType == "receiptSn") {
            this.autoCheckParams.snCheckTemplateFlag = true;
            this.autoCheckParams.newSysTemplateIdSn = v.id;
          } else if (v.templateType == "receiptDateStr") {
            this.autoCheckParams.dateStrCheckTemplateFlag = true;
            this.autoCheckParams.newSysTemplateIdDateStr = v.id;
          }
        });
      }
      console.log("autoCheckParams", this.autoCheckParams);
      this.submitInfo();
    },
    //2、 长度不一样的取消
    cancelPre() {
      this.autoCheckParams.snCheckTemplateFlag = false;
      this.autoCheckParams.dateStrCheckTemplateFlag = false;
      this.autoCheckParams.oldSysTemplateIdSn =
        this.templateInfo.receiptSnTemplateId || "";
      this.autoCheckParams.oldSysTemplateIdDateStr =
        this.templateInfo.receiptDateStrTemplateId || "";
      this.submitInfo();
    },

    // 学习词后面的步骤
    async learnWords() {
      this.$message({
        message: "操作成功!",
        type: "success",
      });

      if (this.$route.query.declareSn) {
        this.$router.back(-1);
      } else {
        this.detail();
        // this.queryDeclareList();
        this.detailsVisible = false;

        setTimeout(() => {
          this.resetRuleForm();
          // document.addEventListener("keydown", this.watchEnter);
        }, 0);
        this.autoCheckTemplateVisible = false;
      }
    },

    // 3、第三步
    async submitInfo() {
      // this.$refs.btn.$el.onkeydown = () => {
      //   let _key = window.event.keyCode;
      //   if (_key === 13) {
      //     return false;
      //   }
      // };

      const { code, inMsg, errMsg, result } = await this.$store.dispatch(
        "rejectSalesVolumeList",
        this.autoCheckParams
      );

      if (code === "0") {
        this.msg = errMsg;
        this.inMsg = inMsg;

        if (inMsg === "-1") {
          // this.dangerVisible = true;
          this.detail();
          // this.queryDeclareList();
          setTimeout(() => {
            this.resetRuleForm();
          }, 0);
        } else if (inMsg === "-2") {
          this.$message({
            message: errMsg,
            type: "warning",
          });
          // this.drawer = true;
          // this.tishiVisible = true;
          this.detailsRepeatDeclare("sub");
        } else if (inMsg === "-3" || inMsg === "-4") {
          this.tishiVisible = true;
        } else {
          /**
           * 学习词
           */
          const getUiTextListByTextCode = await this.$store.dispatch(
            "getUiTextListByTextCode",
            {
              textCodeList: ["Learning Term Popup"],
            }
          );
          const recommendStudy = await this.$store.dispatch("recommendStudy", {
            declareSn: this.detailsSalesVolume.declareSn,
          });
          if (
            recommendStudy.result &&
            recommendStudy.result.recommendStudyResultList.length
          ) {
            recommendStudy.result.recommendStudyResultList.push({
              matched_line: "都不是",
            });
            // console.log(recommendStudy.result.recommendStudyResultList);
            this.learnWordList = recommendStudy.result.recommendStudyResultList;
          }
          // console.log("recommendStudy", recommendStudy);
          // 弹窗出现的位置
          // console.log("getUiTextListByTextCode", getUiTextListByTextCode);

          // console.log(9999);
          // console.log(this.autoCheckTemplateVisible);

          if (
            !this.autoCheckTemplateVisible &&
            getUiTextListByTextCode.result &&
            getUiTextListByTextCode.result[0].textContentZhCn == "YES" &&
            recommendStudy.result &&
            recommendStudy.result.recommendStudyResultList.length > 0
          ) {
            this.learnWordMatchingShow = true;
            return;
          }
          // console.log("到这里吗");
          this.learnWords();
        }
      }

      // setTimeout(() => {
      //   // document.addEventListener("keydown", this.watchEnter);
      // }, 2000);
      this.autoCheckTemplateVisible = false;
    },
    filterGt0OrChinese(prop) {
      if (prop === "receiptDateStr") {
        this.receiptDateStrLength = this.detailsSalesVolume[prop].length;
      }
      this.detailsSalesVolume[prop] = this.detailsSalesVolume[prop].replace(/[^a-zA-Z0-9]/g, "");
    },
    submitReject(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.personAuditState = "refuse";
          Object.assign(this.detailsSalesVolume, this.ruleForm);
          if (
            this.detailsSalesVolume.receiptDate !== "" &&
            this.detailsSalesVolume.receiptDate !== null
          ) {
            this.detailsSalesVolume.receiptDate = `${this.detailsSalesVolume.receiptDate.substring(
              0,
              10
            )} 00:00:00`;
          }

          if (this.hasRelDeclareSn) {
            this.detailsSalesVolume.relRejectDeclareSn = this.relDeclareSn;
          }

          if (
            this.detailsSalesVolume.receiptSn &&
            this.detailsSalesVolume.receiptSn.length > 32
          ) {
            this.$message({
              message: "小票号长度不能超过32位!",
              type: "warning",
            });
            return;
          }

          console.log("detailsSalesVolume", this.detailsSalesVolume);

          this.$store
            .dispatch("rejectSalesVolumeList", this.detailsSalesVolume)
            .then((res) => {
              console.log(33333);

              if (res.code === "0") {
                this.detailsVisible = false;
                this.dialogVisible = false;
                this.drawer = false;

                if (this.$route.query.declareSn) {
                  this.$message({
                    message: "操作成功,返回上一页!",
                    type: "success",
                  });
                  setTimeout(() => {
                    this.$router.back(-1);
                  }, 2000);
                } else {
                  this.$message({
                    message: "操作成功!",
                    type: "success",
                  });
                  setTimeout(() => {
                    this.resetRuleForm();
                  }, 0);
                  this.detail();
                  // this.queryDeclareList();
                }
              }
            });
        } else {
          return false;
        }
      });
    },
    hasReject() {
      // this.drawer = true;
      // let repeatType = this.detailsSalesVolume.receiptSn
      //   ? "receiptSn"
      //   : this.detailsSalesVolume.receiptDateStr
      //     ? "receiptDateStr"
      //     : "";
      this.detailsRepeatDeclare("reject");
    },
    reject() {
      this.queryAuditTemplate();
      this.detailsVisible = true;
    },
    hisRejectSubmitPre() {
      let arr = this.repeatOrder.filter((v) => v.sameFlag).map((v) => {
        return v.declareSn;
      });
      if (arr && arr.length) {
        this.hasRelDeclareSn = true;
        this.relDeclareSn = arr.join(",");
      }
      this.ruleForm.refuseReason = "该小票已提交过,请取消本次申报,勿重复申报!";
      this.detailsVisible = true;
      this.dialogVisible = false;
    },
    async toBottom() {
      console.log("111:", this.receiptId);
      // console.log("222:", this.declareRow.receiptId);

      const { code } = await this.$store.dispatch("goBottom", {
        receiptId: this.receiptId,
      });
      if (code === "0") {
        this.detail();
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryDeclareList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryDeclareList();
    },
    tableRowClassName({ row }) {
      if (row.declareSn === this.detailsSalesVolume.declareSn) {
        return "success-row";
      }
      return "";
    },
    openDetails(row) {
      this.declareRow = row;
      this.detail(row.declareSn);
    },
    queryDeclareList() {
    //   let params = {
    //     pageNo: this.currentPage,
    //     pageSize: this.pageSize,
    //     storeCode: this.$route.query.storeCode,
    //     queryStartTime: this.queryStartTime,
    //     queryEndTime: this.queryEndTime,
    //     auditState: "PCWait",
    //     declareVersion: this.declareVersion,
    //     queryType: this.queryType,
    //     orderType: this.orderType,
    //   };
    //   this.$store.dispatch("queryDeclareList", params).then((res) => {
    //     this.declareRow = res.result.records[0];
    //     console.log("list res:::", this.declareRow);
    //   });
    },
    async queryAuditTemplate() {
      const { result } = await this.$store.dispatch("queryAuditTemplateV2");
      this.rejectTemp = result.textContentZhCn.split("|");
    },
    async ocrRuleConfig() {
      const { result } = await this.$store.dispatch("ocrRuleConfig");
      result.forEach((v) => {
        if (v.itemText === "goods_rule") {
          this.goodsOcrFlag = +v.itemValue;
        }
      });
    },
    async doubleDetails() {
      this.openMoreFlag = false;
      let params = JSON.parse(JSON.stringify(this.detailsSalesVolume));
      params.receiptDate = `${params.receiptDate} 00:00:00`;
      const { code, inMsg, errMsg } = await this.$store.dispatch(
        "doubleDetailsSalesVolumeList",
        params
      );
      if (code === "0") {
        if (this.tempReceiptSn) {
          this.detailsSalesVolume.receiptSn = this.tempReceiptSn;
        }
        if (this.tempReceiptDateStr) {
          this.detailsSalesVolume.receiptDateStr = this.tempReceiptDateStr;
        }

        if (inMsg === "-1") {
          console.log(333333);
          // this.dangerVisible = true;
          this.msg = errMsg;
        } else if (inMsg === "-2") {
          this.$message({
            message: errMsg,
            type: "warning",
          });
          this.ruleForm.refuseReason =
            "小票销期日期，申报商品没有奖励，请取消申报!";
        }
      }
    },
    detail(declareSn) {
      this.hasRelDeclareSn = false;
      this.resetImg();
      this.relDeclareSn = "";
      let params = {
        declareSn,
        queryStartTime: this.queryStartTime,
        queryEndTime: this.queryEndTime,
        declareVersion: this.declareVersion,
      };
      if (this.$route.query.declareSn) {
        return this.$store
          .dispatch("detailsSalesVolumeList", params)
          .then((res) => {
            console.log("detail if res:::", res);
            this.declareRow = res.result;
            this.receiptId = res.result.receiptId;
            if (res.result.receiptDateStr !== "" && res.result.receiptDateStr) {
              this.receiptDateStrLength = res.result.receiptDateStr.length;
            }
            if (res.result.ocrShopName) {
              this.copyOcrShopName = JSON.parse(
                JSON.stringify(res.result.ocrShopName || "")
              );
            }

            this.queryTempConfig(res.result.shopId);
            this.shopId = res.result.shopId;
            this.queryNewNumAutoEnableSwitch(
              res.result.storeCode,
              res.result.shopId
            );
            this.numAutoEnableSwitchStoreCode = res.result.storeCode;
            this.numAutoEnableSwitchShopId = res.result.shopId;
            this.personAuditState = res.result.personAuditState;
            this.riskManagementRefuseReason = res.result.refuseReason;
            // this.queryAutoCheckStatus("receiptSn");
            // this.queryAutoCheckStatus("receiptDateStr");
            if (res.result && res.result.errorBillAudit) {
              this.errorBillAudit = res.result.errorBillAudit;
            }

            if (res.result.declareImg && declareSn) {
              this.whetherThereIsPsOrNot(declareSn, res.result.declareImg);
              this.imgDivOpacity = true;
            }
          });
      } else {
        params.storeCode = this.$route.query.storeCode;
        params.queryType = this.$route.query.queryType;
        params.orderType = this.$route.query.orderType;
        return this.$store
          .dispatch("detailsSalesVolumeList", params)
          .then((res) => {
            this.receiptId = res.result.receiptId;
            this.declareRow = res.result;
            this.shopId = res.result.shopId;
            console.log("detail else res:", res);
            if (res.result.receiptDateStr !== "" && res.result.receiptDateStr) {
              this.receiptDateStrLength = res.result.receiptDateStr.length;
            }
            if (res.result.ocrShopName) {
              this.copyOcrShopName = JSON.parse(
                JSON.stringify(res.result.ocrShopName || "")
              );
            }
            if (res.result && res.result.errorBillAudit) {
              this.errorBillAudit = res.result.errorBillAudit;
            }
            this.personAuditState = res.result.personAuditState;
            this.riskManagementRefuseReason = res.result.refuseReason;
            // if (res.code === "0" && res.result === "-1") {
            //   this.$message({
            //     message: "自动审核未完成,返回上一页!",
            //     type: "success",
            //   });
            //   setTimeout(() => {
            //     this.$router.back(-1);
            //   }, 2000);
            // } else {
            //   this.queryTempConfig(res.result.shopId);
            //   this.queryNewNumAutoEnableSwitch(
            //     res.result.storeCode,
            //     res.result.shopId
            //   );
            //   this.numAutoEnableSwitchStoreCode = res.result.storeCode;
            //   this.numAutoEnableSwitchShopId = res.result.shopId;
            //   // this.queryAutoCheckStatus("receiptSn");
            //   // this.queryAutoCheckStatus("receiptDateStr");
            // }

            if (res.result.declareImg && declareSn) {
              this.whetherThereIsPsOrNot(declareSn, res.result.declareImg);
              this.imgDivOpacity = true;
            }
            this.imgDivOpacity = true;
          });
      }
    },
    getKey(parkey, childkey) {
      this.parkey = parkey;
      this.childkey = childkey;
      this.receiptSnFlag = false;
    },
    isNumber(value) {
      return!isNaN(parseFloat(value)) && Number.isFinite(value);
   },
    getInfo(v) {
      if (this.receiptSnFlag === "receiptSn") {
        this.detailsSalesVolume.receiptSn = v.replace(/[^0-9A-Za-z\.\/]/gi, "");
        if (this.receiptSnkeyPrefixList.length) {
          this.receiptSnkeyPrefixList.forEach((o) => {
            this.detailsSalesVolume.receiptSn = this.detailsSalesVolume.receiptSn.replace(
              o,
              ""
            );
          });
        }
      } else if (this.receiptSnFlag === "receiptDateStr") {
        this.$set(
          this.detailsSalesVolume,
          "receiptDateStr",
          v.replace(/[^\d.]/g, "")
        );
        this.receiptDateStrLength = v.replace(/[^\d.]/g, "").length;
        // let reg = /^[0-9]+.?[0-9]*$/;
        // if (reg.test(v)) {
        //   this.$set(
        //     this.detailsSalesVolume,
        //     "receiptDateStr",
        //     v.replace(/[^\d.]/g, "")
        //   );
        //   this.receiptDateStrLength = v.length;
        // }
      } else if (this.receiptSnFlag === "querySearch") {
        this.state = v;
      } else if (this.receiptSnFlag === "shopName") {
        this.detailsSalesVolume.ocrShopName = v;
        this.$refs.shopNameFocusRef.focus()
        if (this.shopNamekeyPrefixList.length) {
          this.shopNamekeyPrefixList.forEach((o) => {
            this.detailsSalesVolume.ocrShopName = this.detailsSalesVolume.ocrShopName.replace(
              o,
              ""
            );
          });
        }
      } else if(this.isNumber(this.parkey) && this.isNumber(this.childkey)) {
        this.detailsSalesVolume.rewardRuleInfoModelList[
          this.parkey
        ].billDetailsBoList[this.childkey].ocrGoodsName = v;
      }
    },
    back() {
      if (this.$route.query.storeCode) {
        sessionStorage.removeItem("Author");
      }
      sessionStorage.setItem("pageRefresh", 1);
      this.$router.back(-1);
    },
    riskManagementRefuseReasonClick() {
      if (
        this.riskManagementRefuseReason &&
        this.riskManagementRefuseReason.includes("资金超发")
      ) {
        this.detailsRepeatDeclare("reject");
      } else {
        this.$message({
          message: this.riskManagementRefuseReason,
          type: "warning",
        });
      }
    },
    async queryDict() {
      const { result } = await this.$store.dispatch("queryDict", {
        textCode: this.textCode,
      });
      this.manualReviewSwitch = result.textContentZhCn;
    },
    async queryDictTips() {
      const { result } = await this.$store.dispatch("queryDict", {
        textCode: this.textCodeTips,
      });
      this.manualReviewSwitchTips = result.textContentZhCn;
    },
    toggleShowRefuseReasonVoucher() {
      this.showRefuseReasonVoucher = !this.showRefuseReasonVoucher;
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccessRefuseReasonVoucher(jsonData) {
      if (this.showRefuseReasonVoucher) {
        this.refuseReasonVoucher = jsonData.result;
      }
    },
    deleteShowRefuseReasonVoucher() {
      this.refuseReasonVoucher = "";
      this.$refs.eluploadMainPic.clearFiles();
    },
    selectTempTypeChange(e) {
      this.templateType = e;
      this.tempCurrentPage = 1;
      this.tempPageSize = 10;
      console.log("this.templateType:", this.templateType);
      this.queryTempList();
    },
    switchChange(e) {
      console.log("repeatOrder", this.repeatOrder);
      let haveSameFlag = false;
      this.repeatOrder.forEach((v) => {
        if (v.sameFlag) {
          haveSameFlag = true;
        }
      });
      this.haveSameFlag = haveSameFlag;
    },
    isSameRepeat(val, className, list) {
      if (!list) {
        return;
      }
      const array = list.reduce((pre, cur) => {
        pre = pre.concat(cur.billDetailsBoList);
        return pre;
      }, []);
      let someGoodsBarcode;
      if (className == "goodsName")
        someGoodsBarcode = array.some((item) => item.goodsName === val);
      if (className == "goodsNum")
        someGoodsBarcode = array.some((item) => item.goodsNum === val);
      if (className == "goodsBarcode")
        someGoodsBarcode = array.some((item) => item.goodsBarcode === val);

      if (!someGoodsBarcode) {
        return "primary";
      } else {
        return "xxx";
      }
    },
    isSame(goodsName, list) {
      const array = list.reduce((pre, cur) => {
        pre = pre.concat(cur.billDetailsBoList);
        return pre;
      }, []);
      const some = array.some((item) => item.goodsName === goodsName);
      // console.log('list', list);
      if (some) {
        return "primary";
      } else {
        return "xxx";
      }
    },
    isSame2(goodsBarcode, list) {
      const array = list.reduce((pre, cur) => {
        pre = pre.concat(cur.billDetailsBoList);
        return pre;
      }, []);
      const some = array.some((item) => item.goodsBarcode === goodsBarcode);
      if (some) {
        return "primary";
      } else {
        return "xxx";
      }
    },
    handleClickImg(item, index) {
      this.imgActiveIndex = index;
      const dom = document.querySelector(`.repeatOrder${index}`);
      console.log(dom);
      dom.scrollIntoView();
    },
    /**
     * @desc 根据滚动设置右侧图片选中
     */
    handleScroll() {
      const scrollItem = document.querySelector(
        ".scroll-menu-ref .el-scrollbar__wrap"
      );
      let scrollTop = scrollItem.scrollTop; // 获取滚动条位置
      for (let i = 0; i < this.list.length; i++) {
        if (
          (scrollTop >= this.list[i].offsetTop && i === this.list.length) ||
          (scrollTop >= this.list[i].offsetTop &&
            scrollTop < this.list[i + 1].offsetTop)
        ) {
          this.imgActiveIndex = i;
          return;
        }
      }
    },
    /**
     * @desc 历史对比抽屉打开
     */
    drawerOpened() {
      setTimeout(() => {
        const scrollItem = document.querySelector(
          ".scroll-menu-ref .el-scrollbar__wrap"
        );
        if (scrollItem) {
          scrollItem.addEventListener("scroll", this.handleScroll);
          this.list = [];
          this.repeatOrder.forEach((item, ind) => {
            let obj = {
              offsetTop: document.querySelector(`.repeatOrder${ind}`).offsetTop,
            };
            this.list.push(obj);
          });
        }
      }, 500);
    },
    /**
     * @desc 历史对比抽屉关闭
     */
    drawerClose() {
      const scrollItem = document.querySelector(
        ".scroll-menu-ref .el-scrollbar__wrap"
      );
      scrollItem.removeEventListener("scroll", this.handleScroll);
    },

    /**
     * @desc 重复单抽屉打开
     */
    drawerOpenedRepeat() {
      setTimeout(() => {
        const scrollItem = document.querySelector(
          ".scroll-menu-ref .el-scrollbar__wrap"
        );
        if (scrollItem) {
          scrollItem.addEventListener("scroll", this.handleScroll);
          this.list = [];
          this.repeatOrder.forEach((item, ind) => {
            let obj = {
              offsetTop: document.querySelector(`.repeatOrder${ind}`).offsetTop,
            };
            this.list.push(obj);
          });
        }
      }, 500);
    },
    /**
     * @desc 重复单抽屉关闭
     */
    drawerCloseRepeat() {
      const scrollItem = document.querySelector(
        ".scroll-menu-ref .el-scrollbar__wrap"
      );
      scrollItem.removeEventListener("scroll", this.handleScroll);
    },

    async duplicateDeclarationViewing() {
      this.drawerRepeat = true;
      // console.log(this.detailsSalesVolume.relRepeatDeclareSn);
      const result = await this.duplicateSingleQueries(
        this.detailsSalesVolume.relRepeatDeclareSn
      );
      // this.detailsRepeatDeclare("sub");
      console.log(result);
      if (result) {
        this.historicalDeclaredCommodities = result;
      }
    },
    // 重复单详情
    async duplicateSingleQueries(declareSn) {
      let params = {
        declareSn,
      };
      const { result } = await this.$store.dispatch(
        "detailsRefundSalesVolume",
        params
      );
      return result;
    },
  },
};
</script>
<style lang="scss">
.page-component__scroll {
  height: 100%;
}
.page-component__scroll .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
<style lang="scss" scoped>
.bg {
  background: white;
}
.ocrResult {
  width: 300px;
  height: 100vh;
}
.fixed {
  position: fixed;
  bottom: 100px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  width: 100%;
}
.hoverBg {
  background: #e50065;

  color: #fff;
}
.oneLine {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.history {
  line-height: 35px;
  color: #0e1118;
}
.agree-btn {
  background: linear-gradient(
    180deg,
    rgba(41, 180, 64, 1),
    rgba(55, 211, 81, 1)
  );
}
.refuse-btn {
  background: linear-gradient(
    180deg,
    rgba(236, 20, 20, 1),
    rgba(255, 96, 96, 1)
  );
}
.ocr {
  background: rgba(255, 249, 252, 1);
  border: 1px solid rgba(229, 0, 101, 1);
  border-radius: 6px;
}
.not-config {
  color: #999;
}
.title {
  margin-bottom: 10px;
  &::before {
    display: inline-block;
    margin-right: 10px;
    content: "";
    width: 4px;
    height: 12px;
    background: #e50065;
    border-top-left-radius: 30px;
    border-bottom-right-radius: 30px;
  }
}
.temp-header {
  background: rgba(255, 255, 255, 1);
  color: #000;
  padding: 10px 20px 10px 0;
  font-size: 16px;
  user-select: none;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin-bottom: 10px;
  .left_box {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .btn {
      margin-right: 60px;
      margin-left: 20px;
    }
  }
  .right_box {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .hmicon {
    color: #e50065;
    font-size: 18px;
  }
  .btn {
    cursor: pointer;
  }
  .title {
    font-size: 18px;
  }
  .sub-title {
    font-size: 14px;
  }
  .header-list {
    li {
      border-right: 1px solid #fff;
      padding: 0 22px;
    }
    li:last-child {
      padding-right: 0;
      border-right: 0;
    }
  }
}

.store-remark {
  padding: 2px 5px;
  border-radius: 4px;
  border: 1px solid #e50065;
  background: #fedeec;
  color: #e50065;
  font-size: 14px;
  font-weight: bold; /* 新增：使文字加粗 */
  margin-left: 10px;
  text-align: center;
  cursor: pointer;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.border1 {
  border: 1px solid #ddd;
}
.fz {
  font-size: 14px;
  .breadth {
    width: 350px;
    margin-right: 10px;
  }
}
.header {
  background: #f7f7f7;
  font-weight: 700;
  font-size: 14px;
}
.tab-body {
  font-size: 14px;
  border-bottom: 1px solid #ddd;
  .goodsName-wrapper {
    margin-right: 100px;
    .title-wrapper {
      flex-shrink: 0;
      width: 46px;
      padding: 2px 0;
      text-align: center;
      background-color: #f4f4f4;
      border-radius: 2px;
      border: 1px solid #dddddd;
      font-size: 14px;
      color: #666666;
    }
    .name-wrapper {
      font-size: 14px;
      color: #666666;
    }
    .name-ocr-err {
      color: #0081e5;
    }
    .name-err {
      color: #ff0000;
    }
  }
  .more-wrapper {
    .icon-arrow-down-open {
      display: inline-block;
      &.rotate {
        transform: rotate(180deg);
      }
    }
    .more-item {
      padding: 12px 9px;
      border: 4px;
    }
    .more-open {
      background-color: #fedeec;
    }
    .more-close {
      background-color: #e50065;
    }
  }
  .other-wrapper {
    padding: 10px 0;
    background-color: #fbfbfb;
    border-radius: 0px 0px 4px 4px;
    border-top: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
  }
  .other-title {
    padding: 10px 8px;
    color: #000000;
    background-color: #f4f4f4;
    border-radius: 4px;
    border: 1px solid #dddddd;
  }
  .one-item {
    position: relative;
    .delete-icon {
      position: absolute;
      top: -10px;
      left: -10px;
      padding: 10px;
      background-color: #ffffff;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.16);
      border-radius: 0px 0px 4px 4px;
      z-index: 99;
      display: none;
    }
  }
  .one-item:hover {
    .delete-icon {
      display: block;
    }
  }
}

.modal-table {
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  .table-header {
    background: #f7f7f7;
    font-weight: 700;
    font-size: 12px;
    > div {
      padding: 10px 20px;
      color: #222;
    }
  }
  .table-body {
    padding: 17px;
    > div {
      // padding: 10px 20px;
    }
    .input {
      // width: 400px;
      height: 100%;
      text-align: left;
    }
  }
}
.crb-content {
  height: 680px;
  position: relative;
  .tableHeight {
    position: absolute;
    width: 100%;
  }
}
.left {
  position: relative;
  width: 460px;
  height: 600px;
  background-color: #fff;
  padding: 20px;
  float: left;
  overflow: hidden;
  border: 1px solid #ddd;
  .img {
    position: absolute;
    top: 5px;
    left: 7px;
    max-width: 460px;
    height: auto;
    cursor: move;
  }
}

// .store-remark {
//   width: 300px;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   display: -webkit-box;
//   -webkit-box-orient: vertical;
//   -webkit-line-clamp: 2; /*行数*/
//   font-size: 14px;
// }
.replace-wrapper {
  position: relative;
  background: #eeeeee;
  padding: 10px 20px;
  margin-right: 18px;
  height: 37px;
  word-break: keep-all;
  font-size: 14px;
  box-sizing: border-box;
  cursor: pointer;
}
.replace-wrapper.prev {
  background: #fedeec;
  color: #e50065;
  .num {
    background: #e50065;
    color: #fff;
  }
}

.replace-wrapper.prev:after {
  border-left-color: #fedeec;
}

.replace-wrapper:after {
  position: absolute;
  right: -36px;
  top: 0;
  content: "";
  border: 18px solid transparent;
  border-left-color: #eeeeee;
}

.replace-wrapper::before {
  position: absolute;
  left: 0;
  top: 0;
  content: "";
  border: 18px solid transparent;
  border-left-color: #fff;
}
.replace-wrapper:first-child::before {
  display: none;
}
.shop-goods-search {
  width: 500px;
  /deep/ .el-input--small {
    width: 500px !important;
  }
}
/deep/ .el-autocomplete-suggestion {
  width: 500px !important;
}
.my-autocomplete {
  li {
    line-height: normal;
    padding: 7px;
    .brand {
      color: #fff;
      padding: 0 5px;
      background: #e50065;
      border-radius: 4px;
    }
    .goodsName {
      margin-left: 8px;
      font-size: 14px;
      color: #2b2b2b;
      white-space: normal !important;
      line-height: 20px;
    }
    .goods-info {
      font-size: 12px;
      color: #999999;
    }
    .brand-notActivity {
      color: #fff;
      padding: 0 5px;
      background: #dddddd;
      border-radius: 4px;
    }
    .goodsName-notActivity {
      margin-left: 8px;
      font-size: 14px;
      color: #999999;
      white-space: normal !important;
      line-height: 20px;
    }
    .notHasData {
      padding: 20px;
      font-size: 12px;
      color: #999999;
    }
  }
}
.over100 {
  background: #ff9632;
}
.errorAudit {
  .errorAudit-title {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 10px;
  }
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 100px;
    height: 100px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.priviewbgp2 {
  position: relative;
  width: 100px;
  height: 100px;
  padding: 10px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.refundSn-tips {
  border: solid 1px #e50065;
  color: #e50065;
}
/deep/ .dialogDetail {
  margin-left: 50px;
}
.overissue {
  color: #f33030;
  background: #ffe1e1;
  margin: 0 20px;
  line-height: 35px;
  padding-left: 10px;
}
.overissue-list {
  margin: 20px;
  border: solid 1px #e0e0e0;
  .table-header {
    background: #f7f7f7;
    font-weight: 700;
    font-size: 12px;
    > div {
      padding: 10px 20px;
      color: #222;
    }
  }
  .table-body {
    .goods-item {
      border-top: solid 1px #e0e0e0;
      line-height: 35px;
      .border-left {
        border-left: solid 1px #e0e0e0;
      }
    }
  }
}
.group-wrap {
  div {
    flex-shrink: 0;
  }
  .group-item {
    padding: 0 20px;
    background: #fff;
    // display: flex;
    // align-items: center;
    // flex-wrap: wrap;
    margin-bottom: 20px;
    .group-add-item {
      position: relative;
      // display: flex;
      // align-items: center;
      .add-icon {
        width: 30px;
        height: 30px;
        background: #686868;
        border-radius: 50%;
        font-size: 40px;
        color: #fff;
        margin: 0 19px;
        // font-weight: 600;
      }
      .close-item {
        position: absolute;
        right: -17px;
        top: -20px;
        cursor: pointer;
        padding: 10px;
      }
    }

    .add-btn {
      width: 54px;
      height: 54px;
      margin-left: 19px;
      border-radius: 8px 8px 8px 8px;
      opacity: 1;
      border: 1px dashed #e50065;
      font-size: 40px;
      color: #e50065;
      cursor: pointer;
    }

    .equal {
      width: 30px;
      height: 30px;
      background: #686868;
      border-radius: 50%;
      font-size: 40px;
      color: #fff;
      margin: 0 19px;
    }
  }
}

.add-group {
  // display: flex;
  // flex-wrap: nowrap;
  // margin-left: 20px;
  // padding-bottom: 18px;
  // background: #f4f4f4;
  overflow: hidden;
  &::-webkit-scrollbar {
    height: 6px;
    border-radius: 4px 4px 4px 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: #dddddd;
    border-radius: 4px 4px 4px 4px;
  }
  .add-wrap {
    width: 100%;
    max-height: 366px;
    padding: 0 20px;
    margin-bottom: 20px;
    box-sizing: border-box;
    background: #fff;
    // margin-right: 20px;
    border-radius: 6px 6px 6px 6px;
    &:last-of-type {
      margin-right: 0;
    }
    .header {
      height: 20px;
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      color: #222222;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 10px;
      background: #fff;
    }

    .footer {
      display: flex;
      justify-content: space-between;
    }
  }
}
.ocr-pagination {
  overflow-y: auto;
}
.btn-wrapper {
  width: auto !important;
}
.goods-wrap {
  .top-title {
    height: 44px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 14px;
    color: #222222;
    line-height: 44px;
    text-align: center;
  }
}
.goods-name {
  font-size: 14px;
}
.apply-drawer {
  padding-left: 100px;
}

.rule-upperLimitSwitch {
  display: inline-block;
  font-size: 12px;
  .money {
    color: red;
  }
}
</style>
<style lang="scss">
.apply-drawer {
  padding-left: 100px;
  position: relative;

  .img-wrap {
    position: absolute;
    left: 0;
    top: 0;
    padding: 0 10px;
    height: calc(100vh);
    overflow-y: auto;
    img {
      width: 80px;
      border-radius: 2px 2px 2px 2px;
    }
    &::-webkit-scrollbar {
      height: 6px;
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: #dddddd;
      border-radius: 4px 4px 4px 4px;
    }
    .img-active {
      border: 3px solid #e50065;
    }
  }
}
.bottom-tips {
  margin-top: 5px;
  width: 440px;
  max-height: 60px;
  font-size: 14px;
  line-height: 20px;
  overflow-y: auto;
  color: #f22d2d;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #99a9bf;
    border-radius: 20px;
  }
}
.fix-btn-wrap {
  background: #eeeeee;
  box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.03);
  border-radius: 8px 8px 8px 8px;
  padding: 10px;
}

.schedule {
  h2 {
    height: 22px;
    font-family: PingFang HK, PingFang HK;
    font-size: 16px;
    color: #222222;
    line-height: 19px;
    text-align: left;
    position: relative;
    padding-left: 8px;
  }
  h2::before {
    content: "";
    width: 3px;
    height: 14px;
    background: #e50065;
    border-radius: 2px 0px 2px 0px;
    position: absolute;
    left: 0;
    top: 2px;
  }
  ul {
    li {
      min-height: 66px;
      position: relative;
      padding-left: 16px;
      h3 {
        height: 24px;
        font-family: PingFang SC, PingFang SC;
        font-size: 16px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.9);
        line-height: 24px;
        text-align: left;
      }
      p {
        font-weight: 400;
        font-size: 14px;
        color: rgba(0, 0, 0, 0.6);
        line-height: 22px;
        text-align: left;
        span {
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #e50065;
          line-height: 22px;
          text-align: left;
          margin-right: 20px;
        }
      }
    }
    li:before {
      content: "";
      width: 8px;
      height: 8px;
      border-radius: 100px 100px 100px 100px;
      border: 2px solid #e50065;
      position: absolute;
      left: 0;
      top: 7px;
    }
    li:after {
      content: "";
      width: 4px;
      height: 40px;
      display: block;
      background: #dcdcdc;
      position: absolute;
      left: 3px;
      bottom: 0;
    }
  }
}

.new_extremely {
  padding: 0 !important;
  box-sizing: border-box;
  overflow: hidden;
  .extremely_fast_audits {
    width: 100%;
    height: 24px;
    background: #ffedc0;
    border-radius: 8px 8px 0px 0px;
    border-bottom-style: 1px solid #ffb800;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 7px;
    .icons {
      width: 16px;
      height: 16px;
    }
    p {
      font-weight: 600;
      font-size: 16px;
      color: #ffa800;
      line-height: 34px;
      text-align: center;
    }
  }
}
.duplicate_requisitions {
  width: 100%;
  height: 33px;
  font-size: 14px;
  color: #ff7f10;
  line-height: 16px;
  display: flex;
  align-items: center;
  span {
    cursor: pointer;
    color: #e50065;
  }
}
.duplicate_declarations {
  h1 {
    font-size: 16px;
    color: #000;
    margin: 0;
    padding-left: 20px;
    margin-bottom: 25px;
  }
  .history {
    font-weight: 400;
    font-size: 14px;
    color: #222222;
    line-height: 16px;
    margin-bottom: 10px;
  }
  .mt40 {
    margin: 0;
  }
  .primary {
    min-width: 130px;
    font-weight: 400;
    font-size: 14px;
    color: #ff0000;
  }
}

.learn_word_matching {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  .interior {
    width: 760px;
    background: #fff;
    position: absolute;
    left: calc(50vw - 380px);
    top: calc(50vh - 190px);
    border-radius: 8px;
    padding-bottom: 20px;
    box-sizing: border-box;
    position: relative;
    z-index: 1002;
    h1 {
      width: 100%;
      height: 56px;
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #222222;
      padding-left: 29px;
      box-sizing: border-box;
      font-weight: 600;
      border-bottom: 1px solid #dddddd;
    }
    h3 {
      font-weight: 600;
      font-size: 24px;
      color: #0081e5;
      line-height: 34px;
      margin: 0;
      margin-left: 29px;
    }
    h4 {
      font-weight: 600;
      font-size: 20px;
      color: #000000;
      line-height: 28px;
      margin: 7px 0 0 29px;
    }
    ul {
      display: inline-grid;
      margin: 9px 0 0 30px;
      padding: 16px;
      border-radius: 8px;
      border: 1px solid #bbbbbb;
      list-style-type: none;
      li {
        display: inline-block;
        min-width: 451px;
        // display: flex;
        // align-items: center;
        // justify-items: center;
        margin-bottom: 10px;
        cursor: pointer;
        .p {
          min-width: 450px;
          padding: 6px 14px;
          box-sizing: border-box;
          background: #f6f6f6;
          border-radius: 6px;
          border: 1px solid #cbcbcb;
          cursor: pointer;
          p {
            display: block;
            line-height: 33px;
            font-weight: 500;
            font-size: 18px;
            color: #585858;
            border: none;
          }
          button {
            width: 75px;
            height: 34px;
            background: #2fc348;
            border-radius: 4px;
            font-weight: 400;
            font-size: 14px;
            color: #ffffff;
            line-height: 16px;
            border: none;
            margin: auto;
            display: block;
            cursor: pointer;
          }
        }
        .active {
          color: #2fc348;
          border: 1px solid #2fc348;
          p {
            color: #2fc348;
          }
        }
        .neither {
          color: #e50065;
          border: 1px solid #e50065;
          p {
            color: #e50065 !important;
          }
          button {
            background: #e50065;
          }
        }
      }
    }
  }
}

.required {
  background: #fff0f0;
}
</style>
